"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClSRComboboxContainer = exports.ClSRCombobox = exports.ClCombobox = exports.ClMultipleChoice = exports.ClMVCheckBoxRadio = exports.ClSVCheckBoxSwitch = exports.ClTextArea = exports.ClDatetime = exports.ClNumericInput = exports.ClTextInput = exports.ClStaticText = exports.ClGroup = exports.ClPage = exports.LayoutItem = exports.ClImageViewControl = exports.ClMediaControl = exports.AttachmentInfo = exports.ClStaticImageControl = exports.ClImageControl = exports.ClAttachmentControl = exports.ClFieldControl = exports.ClCollection = exports.ClControlFactory = exports.ChecklistAction = exports.ChecklistMode = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("lightbox2");
require("lightbox2/dist/css/lightbox.css");
const Utilities_1 = require("../../javascript/Utilities");
const Instance_1 = require("../../model/Instance");
require("tracking/build/tracking");
require("tracking/build/data/face");
class FieldCollection {
    constructor() {
        this.allControls = [];
    }
    pushControl(control) {
        this.allControls.push(control);
    }
}
class ImageCollection {
    constructor() {
        this.allControls = [];
    }
    pushControl(control) {
        this.allControls.push(control);
    }
}
class DataCollection {
    constructor() {
        this.allControls = [];
    }
    pushControl(control) {
        this.allControls.push(control);
    }
}
class MultiValueCollection {
    constructor() {
        this.allControls = [];
    }
    pushControl(control) {
        this.allControls.push(control);
    }
}
var ChecklistMode;
(function (ChecklistMode) {
    ChecklistMode[ChecklistMode["Editor"] = 1] = "Editor";
    ChecklistMode[ChecklistMode["Designer"] = 2] = "Designer";
    ChecklistMode[ChecklistMode["Questionnaire"] = 4] = "Questionnaire";
    ChecklistMode[ChecklistMode["Preview"] = 8] = "Preview";
})(ChecklistMode = exports.ChecklistMode || (exports.ChecklistMode = {}));
var ChecklistAction;
(function (ChecklistAction) {
    ChecklistAction[ChecklistAction["Edit"] = 1] = "Edit";
    ChecklistAction[ChecklistAction["New"] = 2] = "New";
})(ChecklistAction = exports.ChecklistAction || (exports.ChecklistAction = {}));
class ClControlFactory {
    constructor(checklistjQuery, instance, configData, Mode, ReadOnly, Action) {
        this.checklistjQuery = checklistjQuery;
        this.instance = instance;
        this.configData = configData;
        this.Mode = Mode;
        this.ReadOnly = ReadOnly;
        this.Action = Action;
        // private configData: any;
        this.maxNumberOfFields = 250;
        this.maxNumberOfImageFields = 25;
        this.maxNumberOfImagesPerField = 100;
        // public Mode: ChecklistMode;
        // public checklistQuery;
        // public instance: any;
        this.helpButtonChecked = false;
        this.faceDetectionRetryCountInit = true;
        this.faceDetectionRetryCount = 2;
        // this.instance = instance;
        // this.checklistQuery
        // this.configData = configDataI;
        this.dataCollection = new DataCollection();
        this.fieldCollection = new FieldCollection();
        this.imageCollection = new ImageCollection();
        // this.Mode = mode;
        if (instance["rowspacing"])
            this.rowSpacing = instance["rowspacing"];
        else
            this.rowSpacing = 20;
        Object.freeze(this.maxNumberOfFields);
        Object.freeze(this.maxNumberOfImageFields);
        Object.freeze(this.maxNumberOfImagesPerField);
    }
    setChecklistChanged(hasChanged) {
        this.instance["changed"] = hasChanged;
        if (hasChanged)
            this.checklistjQuery.trigger("checklistChanged");
    }
    resetOrder() {
        this.resetOrderInternal(this.instance.layout);
    }
    resetOrderInternal(layout) {
        for (let idx = 0; idx < layout.length; idx++) {
            let item = layout[idx];
            item["order"] = idx;
            if (item["type"] === "group" || item["type"] === "page")
                this.resetOrderInternal(item.layout);
        }
    }
    getInstance() {
        return this.instance;
    }
    CheckValues() {
        let checkSelfRef = !this.CheckIfSRValueIsAbstractOrSoftDeleted();
        let checkValidValues = !this.CheckIfDependentValueIsValid();
        return checkSelfRef && checkValidValues;
    }
    CheckIfSRValueIsAbstractOrSoftDeleted() {
        let that = this;
        let abstractValueFound = false;
        let softdeletedValueFound = false;
        if (that.fieldCollection && that.fieldCollection.allControls) {
            $.each(that.fieldCollection.allControls, (idx, control) => {
                if (!abstractValueFound && control instanceof ClSRComboboxContainer && control.hasAbstractValue()) {
                    abstractValueFound = true;
                    let field = that.getLabelText(control.field.labels, that.userUILangId, that.instance.langid);
                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("clabstractsrvalue").replace("{0}", field));
                    return;
                }
                if (!softdeletedValueFound && control instanceof ClSRComboboxContainer && control.hasSoftDeletedValue()) {
                    softdeletedValueFound = true;
                    let field = that.getLabelText(control.field.labels, that.userUILangId, that.instance.langid);
                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("clsoftdeletedsrvalue").replace("{0}", field));
                    return;
                }
            });
        }
        return abstractValueFound && softdeletedValueFound;
    }
    CheckIfDependentValueIsValid() {
        let that = this;
        let invalidValueFound = false;
        if (that.fieldCollection && that.fieldCollection.allControls) {
            $.each(that.fieldCollection.allControls, (idx, control) => {
                if (!invalidValueFound && control instanceof ClFieldControl && control.field.show && !control.IsValid() && that.getAsArray(control.field.value).length > 0) {
                    invalidValueFound = true;
                    let field = that.getLabelText(control.field.labels, that.userUILangId, that.instance.langid);
                    Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("clinvalidvalue").replace("{0}", field));
                    return;
                }
            });
        }
        return invalidValueFound;
    }
    isAllowedImageType(mimeType) {
        return mimeType === "image/png" ||
            mimeType === "image/jpeg" ||
            mimeType === "image/bmp" ||
            mimeType === "image/gif" ||
            mimeType === "image/tiff";
    }
    getItemById(itemId) {
        return this.getItemByIdInternal(this.instance.layout, itemId);
    }
    removeItem(itemId) {
        let idxOfControl = -1;
        let index = this.fieldCollection.allControls.findIndex(control => control.id === itemId);
        if (index !== -1)
            this.fieldCollection.allControls.splice(index, 1);
        let domControl = $("[cl_itemid=" + itemId + "]").remove();
        this.removeItemFromLayout(this.instance.layout, itemId);
    }
    removeItemFromLayout(layout, itemId) {
        let indexToDelete = -1;
        let itemDeleted = false;
        $.each(layout, (idx, layoutItem) => {
            if (!itemDeleted && indexToDelete === -1) {
                if (layoutItem["id"] === itemId)
                    indexToDelete = idx;
                else if (layoutItem["type"] === "group" || layoutItem["type"] === "page") {
                    itemDeleted = this.removeItemFromLayout(layoutItem["layout"], itemId);
                }
            }
        });
        if (!itemDeleted && indexToDelete !== -1) {
            layout.splice(indexToDelete, 1);
            itemDeleted = true;
        }
        return itemDeleted;
    }
    insertItemToLayoutAfter(item, prevItemId, groupId) {
        if (groupId) {
            let group = this.getItemById(groupId);
            let prevPos = group.layout.findIndex(elem => elem.id === prevItemId);
            item.parentid = groupId;
            group.layout.splice(prevPos + 1, 0, item);
        }
        else {
            let prevPos = this.instance.layout.findIndex(elem => elem.id === prevItemId);
            item.parentid = undefined;
            this.instance.layout.splice(prevPos + 1, 0, item);
        }
    }
    appendItemToLayout(item, groupId) {
        if (groupId) {
            let group = this.getItemById(groupId);
            item.parentid = groupId;
            group.layout.push(item);
        }
        else {
            item.parentid = undefined;
            this.instance.layout.push(item);
        }
    }
    getNumberOfFields() {
        return this.getAllFields(this.instance.layout).length;
    }
    getNumberOfImageFields() {
        let imageFields = [];
        let allFields = this.getAllFields(this.instance.layout);
        $.each(allFields, (idx, field) => {
            if (field.controltype === "ImageView")
                imageFields.push(field);
        });
        return imageFields.length;
    }
    Fields() {
        return this.getAllFields(this.instance.layout);
    }
    Items() {
        return this.getAllItems(this.instance.layout);
    }
    getAllFields(layout) {
        let fields = [];
        $.each(layout, (idx, value) => {
            if (value.type === "field")
                fields.push(value);
            else if (value.layout) {
                let tmpFields = this.getAllFields(value.layout);
                if (tmpFields && tmpFields.length > 0)
                    fields = fields.concat(tmpFields);
            }
        });
        return fields;
    }
    getAllItems(layout) {
        let items = [];
        $.each(layout, (idx, item) => {
            items.push(item);
            if (item.layout) {
                let tmpItems = this.getAllItems(item.layout);
                if (tmpItems && tmpItems.length > 0)
                    items = items.concat(tmpItems);
            }
        });
        return items;
    }
    getItemByIdInternal(layout, itemId) {
        let item;
        $.each(layout, (idx, tmpItem) => {
            if (!item) {
                if (tmpItem["id"] === itemId) {
                    item = tmpItem;
                }
                else {
                    if (tmpItem["type"] === "group" || tmpItem["type"] === "page")
                        item = this.getItemByIdInternal(tmpItem.layout, itemId);
                }
            }
        });
        return item;
    }
    getGroupById(groupId) {
        return this.getGoupByIdInternal(this.instance.layout, groupId);
    }
    getGoupByIdInternal(layout, groupId) {
        let group;
        $.each(layout, (idx, item) => {
            if (!group) {
                if (item["type"] === "group") {
                    if (item["id"] === groupId)
                        group = item;
                    else {
                        group = this.getGoupByIdInternal(item.layout, groupId);
                    }
                }
                else if (item["type"] === "page") {
                    group = this.getGoupByIdInternal(item.layout, groupId);
                }
            }
        });
        return group;
    }
    getRefIds(ftname, id) {
        let that = this;
        let Pids = [];
        $.each(that.dataCollection.allControls, (idx, value) => {
            if (value.id === ftname) {
                $.each(value.data, (idx2, value2) => {
                    if (value2.id !== id && value2.pid === id) {
                        Pids.push(value2.id);
                    }
                });
            }
        });
        return Pids;
    }
    getLangId(callback) {
        let that = this;
        that.userCulture = that.instance.userculture;
        that.userUILangId = that.instance.userlangid;
        if (!that.userCulture || !that.userUILangId) {
            Utilities_1.synUtil.getAJAXData({
                method: "GET",
                url: Utilities_1.synUtil.getWSUrl("UserInfo"),
                done(userDataJSON) {
                    return tslib_1.__awaiter(this, void 0, void 0, function* () {
                        let instance = yield Instance_1.Instance.fromJSON(userDataJSON.instance);
                        that.userUILangId = userDataJSON.userInfo.UILanguageId;
                        that.userCulture = instance.items["dzvculture.code"].valueToString();
                        callback();
                    });
                },
                fail(jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                }
            });
        }
        else
            callback();
    }
    getLabelText(labels, userLangid, defLangId) {
        let label = "";
        if (labels) {
            if ((this.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
                // Check explicit for userLangid
                $.each(labels, (idx, value) => {
                    if (value.langid === userLangid) {
                        label = value.text;
                    }
                });
            }
            if (!label) { // check for defLangIs
                $.each(labels, (idx, value) => {
                    if (value.langid === defLangId) {
                        label = value.text;
                    }
                });
            }
        }
        return label;
    }
    getLabel(labels, userLangid, defLangId) {
        let label = "";
        if (labels) {
            if ((this.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
                // Check explicit for userLangid
                $.each(labels, (idx, value) => {
                    if (value.langid === userLangid) {
                        label = value.html;
                    }
                });
            }
            if (!label) { // check for defLangIs
                $.each(labels, (idx, value) => {
                    if (value.langid === defLangId) {
                        label = value.html;
                    }
                });
            }
        }
        return label;
    }
    updateFields(layout) {
        let that = this;
        for (let index = 0; index < layout.length; ++index) {
            let item = layout[index];
            if (item.type === "field") {
                let field = item;
                let fieldcontrol = that.getFieldControl(field.id);
                if (field.controltype !== "ImageView") {
                    let newvalue = fieldcontrol.getValue();
                    field.value = newvalue;
                }
            }
            else if (item.layout) {
                that.updateFields(item.layout);
            }
        }
    }
    getFieldControl(fieldId) {
        let index;
        for (index = 0; index < this.fieldCollection.allControls.length; ++index) {
            if (fieldId === this.fieldCollection.allControls[index].id)
                return this.fieldCollection.allControls[index];
        }
    }
    updateControl(fieldId, control) {
        let index = this.fieldCollection.allControls.findIndex(control => control.id === fieldId);
        if (index !== -1) {
            this.fieldCollection.allControls[index] = control;
        }
    }
    getContainerId(imageId, fieldId) {
        let containerId = "";
        for (let idx = 0; idx < this.instance.attachments.length; ++idx) {
            if (this.instance.attachments[idx].type === "image" && this.instance.attachments[idx].id === imageId) {
                containerId = this.instance.attachments[idx].containerid;
            }
        }
        if (!containerId && fieldId) {
            containerId = this.getContainerIdInternal(imageId, fieldId, this.instance.layout);
        }
        return containerId;
    }
    getContainerIdInternal(imageId, fieldId, layout) {
        let containerId = "";
        if (layout) {
            $.each(layout, (idx, value) => {
                if (value.type === "field") {
                    if (value.id === fieldId) {
                        $.each(value.attachments, (idx, value) => {
                            if (value.Id === imageId)
                                containerId = value.containerid;
                        });
                    }
                }
                else if (value.type === "group" || value.type === "page") {
                    if (!containerId)
                        containerId = this.getContainerIdInternal(imageId, fieldId, value.layout);
                }
            });
        }
        return containerId;
    }
    setContainerId(imageId, containerId) {
        $.each(this.instance.attachments, (idx, value) => {
            if (value.type === "image" && value.id === imageId) {
                value.containerid = containerId;
            }
        });
    }
    getFileId(imageId, fieldId) {
        let that = this;
        let fileId = "";
        $.each(this.instance.attachments, (idx, value) => {
            if (value.type === "image" && value.id === imageId) {
                fileId = value.fileid;
            }
        });
        if (!fileId && fieldId) {
            fileId = that.getFileIdInternal(imageId, fieldId, that.instance.layout);
        }
        return fileId;
    }
    getCollectionFromInstance(listName) {
        let collection;
        $.each(this.instance.collections, (idx, tmpCollection) => {
            if (tmpCollection.id === listName)
                collection = tmpCollection;
        });
        return collection;
    }
    getCachedCollection(listName) {
        let collection;
        $.each(this.dataCollection.allControls, (idx, tmpCollection) => {
            if (tmpCollection.id === listName)
                collection = tmpCollection;
        });
        return collection;
    }
    getFileIdInternal(imageId, fieldId, layout) {
        let fileId;
        if (layout) {
            $.each(layout, (idx, value) => {
                if (value.type === "field") {
                    if (value.id === fieldId) {
                        $.each(value.attachments, (idx, value) => {
                            if (value.Id === imageId)
                                fileId = value.fileid;
                        });
                    }
                }
                else if (value.type === "group" || value.type === "page") {
                    if (!fileId)
                        fileId = this.getFileIdInternal(imageId, fieldId, value.layout);
                }
            });
        }
        return fileId;
    }
    setFileId(imageId, fileId) {
        $.each(this.instance.attachments, (idx, value) => {
            if (value.type === "image" && value.id === imageId) {
                value.fileid = fileId;
            }
        });
    }
    checkFieldVisibilities() {
        if ((this.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
            let that = this;
            let tmpInstance = $.extend(true, {}, that.instance);
            that.ReplaceIdsForService(tmpInstance["layout"]);
            let requestOptions = {
                instance: JSON.stringify(tmpInstance),
                forDesigner: (that.Mode & ChecklistMode.Preview) === ChecklistMode.Preview,
            };
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("ChecklistCheckConditions"),
                requestData: requestOptions,
                done: (data) => {
                    if ((that.Mode & ChecklistMode.Preview) === ChecklistMode.Preview)
                        that.SetDummyForPreview(data.layout);
                    that.updateVisibilities(data.layout);
                },
            });
        }
    }
    SetDummyForPreview(layout) {
        let that = this;
        $.each(layout, (idx, item) => {
            item.id = item.id + "_clpreview";
            if (item.layout)
                this.SetDummyForPreview(item.layout);
        });
    }
    ReplaceIdsForService(layout) {
        $.each(layout, (idx, item) => {
            item.id = item.id.replace("_clpreview", "");
            item.externalid = item.externalid.replace("_clpreview", "");
            if (item.condition)
                item.condition = item.condition.replace("_clpreview", "");
            if (item.layout)
                this.ReplaceIdsForService(item.layout);
        });
    }
    updateVisibilities(layout) {
        let that = this;
        for (let index = 0; index < layout.length; ++index) {
            let item = layout[index];
            let control = that.getFieldControl(layout[index].id);
            if (control) {
                if (control.field.visible !== layout[index].visible || control.field.show !== layout[index].show) {
                    control.field.visible = layout[index].visible;
                    control.field.show = layout[index].show;
                    control.setVisibility(control.field.visible, control.field.show);
                }
            }
            else {
                let orgitem = that.getItemById(item.id);
                orgitem.visible = item.visible;
                orgitem.show = item.show;
            }
            if (item.type === "group" || item.type === "page") {
                that.updateVisibilities(item.layout);
                if (item.type === "page") {
                    let page = $(".clpageTab[cl_page_id=" + item.id + "]");
                    if (page) {
                        if (item.visible === true && item.show === true)
                            page.show();
                        else
                            page.hide();
                    }
                }
            }
        }
    }
    getDataCollection(callback, data, bIsMultilanguage, bIsSelfRefFt, bIsSortable, language, id, pid) {
        let that = this;
        let resultData = [];
        resultData = data;
        if (bIsMultilanguage) {
            resultData = [];
            let index;
            for (index = 0; index < data.length; ++index) {
                if (data[index].langid === language) {
                    resultData.push(data[index]);
                }
            }
        }
        if (bIsSelfRefFt) {
            let resultData2 = [];
            let index;
            for (index = 0; index < resultData.length; ++index) {
                if (pid) {
                    if (resultData[index].id !== pid && resultData[index].pid === pid) {
                        resultData2.push(resultData[index]);
                    }
                }
                else {
                    if (resultData[index].id === id || resultData[index].pid === resultData[index].id)
                        resultData2.push(resultData[index]);
                }
            }
            resultData = resultData2;
        }
        if (bIsSortable) {
            resultData.sort(function (a, b) {
                return a["sort"] - b["sort"];
            });
        }
        if (callback)
            callback(resultData);
        return resultData;
    }
    getCurrentValueForSelfRefControl(ftname, isselfref, id, pid) {
        let that = this;
        if (id === pid)
            return id;
        let data;
        $.each(that.dataCollection.allControls, (idx, value) => {
            if (value.id === ftname) {
                if (isselfref) {
                    data = value;
                }
            }
        });
        let parentid = id;
        while (parentid !== pid) {
            let tmpparentid = that.getPid(data, parentid);
            if (tmpparentid == undefined)
                return undefined;
            if (tmpparentid === pid || tmpparentid === id)
                break;
            if (tmpparentid === parentid)
                break;
            else
                parentid = tmpparentid;
        }
        return parentid;
    }
    getDataList(callback, field, id, pids, filter, keepIds, hardDeletedIds, includeAbstract = false, includeDeleted = false, invalidIds) {
        if (field.dataname && field.datafield) {
            let that = this;
            let getDataFromService = that.GetDataFromService(field);
            let langid = that.userUILangId;
            if ((that.Mode & ChecklistMode.Designer) === ChecklistMode.Designer || (that.Mode & ChecklistMode.Preview) === ChecklistMode.Preview)
                langid = that.instance.langid;
            let collection;
            $.each(that.instance.collections, (idx, value) => {
                if (value.id === field.dataname)
                    collection = JSON.parse(JSON.stringify(value));
            });
            let idsToKeep = [];
            if (keepIds && keepIds.length > 0)
                idsToKeep = JSON.parse(JSON.stringify(keepIds));
            if (invalidIds && invalidIds.length > 0) {
                $.each(invalidIds, (idx, invalidId) => {
                    if (idsToKeep.indexOf(invalidId) === -1)
                        idsToKeep.push(invalidId);
                });
            }
            let paging = field.controltype === "Combobox";
            if (getDataFromService) {
                let embedded = false;
                if (!((that.Mode & ChecklistMode.Designer) === ChecklistMode.Designer || (that.Mode & ChecklistMode.Preview) === ChecklistMode.Preview))
                    embedded = collection.embedded;
                let isdependent = false;
                if (field.dependentfield)
                    isdependent = true;
                let requestData = {
                    isft: collection.isft,
                    isselfref: field.isselfrefft,
                    isdependent,
                    embedded,
                    checklistid: that.instance["synerisid"],
                    filtering: true,
                    filter,
                    column: field.datafield,
                    id,
                    pids,
                    langid,
                    paging,
                    pageSize: 500,
                    page: 1,
                    sort: field["ftsort"],
                    keepIds: idsToKeep,
                    includeabstract: includeAbstract,
                    includedeleted: includeDeleted,
                    usedcolumns: collection.columns.join("|"),
                    action: that.Action,
                };
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("ChecklistGetDataCollection") + field.dataname + "/",
                    requestData: JSON.stringify(requestData),
                    done: (data) => {
                        callback(data.items);
                    },
                    fail(jqXHR, textStatus, errorThrown, url) {
                        callback(undefined);
                        Utilities_1.synUtil.getAJAXDataFail(jqXHR, textStatus, errorThrown, url);
                    }
                });
            }
            else {
                let resultData = [];
                resultData = JSON.parse(JSON.stringify(collection.data));
                if (collection.ismultilangft) {
                    resultData = [];
                    let index;
                    for (index = 0; index < collection.data.length; ++index) {
                        if (collection.data[index].langid === that.instance.langid) {
                            resultData.push(collection.data[index]);
                        }
                    }
                }
                if (field.isselfrefft) {
                    let resultData2 = [];
                    if (id) {
                        let entry = collection.data.find(entry => entry["id"] === id);
                        if (entry)
                            pids = [entry["pid"]];
                    }
                    if (pids && pids.length > 0) {
                        $.each(pids, (idx, pid) => {
                            if (id === pid) {
                                resultData = JSON.parse(JSON.stringify(collection.data.filter(item => item["id"] === item["pid"])));
                            }
                            else {
                                resultData = JSON.parse(JSON.stringify(collection.data.filter(item => item["pid"] && item["pid"].split("|").indexOf(pid) !== -1 && item["id"] !== item["pid"])));
                            }
                        });
                    }
                    else {
                        resultData = JSON.parse(JSON.stringify(collection.data.filter(item => item["id"] === item["pid"])));
                    }
                }
                else if (field.dependentfield) {
                    let tmpData = [];
                    if (pids && pids.length > 0) {
                        $.each(pids, (idx, tmpPid) => {
                            let tmpList = JSON.parse(JSON.stringify(collection.data.filter(item => item["pid"] && item["pid"].split("|").indexOf(tmpPid) !== -1)));
                            $.each(tmpList, (idx2, item) => {
                                if (tmpData.findIndex(it => it.id === item.id) === -1)
                                    tmpData.push(item);
                            });
                        });
                        // Add entries with empty pid (wildcard)
                        let tmpList = JSON.parse(JSON.stringify(collection.data.filter(item => !item["pid"])));
                        $.each(tmpList, (idx2, item) => {
                            if (tmpData.findIndex(it => it.id === item.id) === -1)
                                tmpData.push(item);
                        });
                    }
                    resultData = tmpData;
                }
                let sortColumn = field.datafield;
                let sortDir = "1";
                if (field["ftsort"]) {
                    let parts = field["ftsort"].split(".");
                    sortColumn = parts[0];
                    sortDir = parts[1];
                }
                // order by datafield
                resultData.sort(function (value1, value2) {
                    let number1 = parseInt(value1[sortColumn], 10);
                    let number2 = parseInt(value2[sortColumn], 10);
                    if (!isNaN(number1)) {
                        if (!isNaN(number2)) {
                            if (number1 > number2)
                                return sortDir === "1" ? 1 : -1;
                            if (number1 < number2)
                                return sortDir === "1" ? -1 : 1;
                            if (number1 === number2)
                                return 0;
                        }
                        else
                            return sortDir === "1" ? -1 : 1;
                    }
                    else if (!isNaN(number2))
                        return sortDir === "1" ? 1 : -1;
                    else
                        return sortDir === "1" ? value1[sortColumn].localeCompare(value2[sortColumn]) : value2[sortColumn].localeCompare(value1[sortColumn]);
                });
                $.each(idsToKeep, (idx, keepId) => {
                    if (!resultData.find(item => item.id === keepId)) {
                        let isHardDeleted = true;
                        if (field.isselfrefft || field.dependentfield) {
                            let invalidEntry = collection.data.find(_item => _item.id === keepId);
                            if (invalidEntry) {
                                isHardDeleted = false;
                                invalidEntry["isInvalid"] = true;
                                resultData.splice(0, 0, invalidEntry);
                            }
                        }
                        if (isHardDeleted) {
                            let newEntry = { id: keepId, _hardDeleted: true };
                            if (field.datafield !== "id")
                                newEntry[field.datafield] = kendo.format(Utilities_1.synUtil.Strings.getValue("dynpftentryharddeletedid").replace('%s', '{0}'), keepId);
                            resultData.splice(0, 0, newEntry);
                        }
                    }
                });
                if (filter && filter.filters.length > 0) {
                    let colfilter = filter.filters[0]["value"];
                    let resultData2 = [];
                    let index;
                    for (index = 0; index < resultData.length; ++index) {
                        if (resultData[index][field.datafield].toLowerCase().includes(colfilter.toLowerCase()))
                            resultData2.push(resultData[index]);
                    }
                    resultData = JSON.parse(JSON.stringify(resultData2));
                }
                // Remove deleted abstract and not needed entries
                let correctedEntries = [];
                if (resultData) {
                    $.each(resultData, (idx, entry) => {
                        if (!((!includeDeleted && this.isSoftDeleted(entry) && keepIds.indexOf(entry.id) === -1) || (!includeAbstract && this.isAbstract(entry) && keepIds.indexOf(entry.id) === -1)))
                            correctedEntries.push(entry);
                    });
                }
                correctedEntries = that.filterEntriesForPaging(correctedEntries, paging, 500, 1, id);
                callback(correctedEntries);
            }
        }
        else
            callback(undefined);
    }
    filterEntriesForPaging(entries, pages, pageSize, page, selectedId) {
        // Paging
        let filteredEntries = JSON.parse(JSON.stringify(entries));
        if (filteredEntries.length > 0 && pageSize > 0 && page > 0) {
            let pages = Math.floor(filteredEntries.length / pageSize);
            filteredEntries = filteredEntries.slice(pageSize * (page - 1), pageSize);
        }
        if (selectedId) {
            if (filteredEntries.findIndex(entry => entry["id"] === selectedId) === -1) {
                let selectedEntry = entries.find(entry => entry["id"] === selectedId);
                if (selectedEntry) {
                    filteredEntries.splice(0, 0, selectedEntry);
                    filteredEntries.splice(filteredEntries.length - 1, 1);
                }
            }
        }
        return filteredEntries;
    }
    getComboboxInfo(field, value, callback) {
        let that = this;
        if (field.dataname && field.datafield) {
            let getDataFromService = that.GetDataFromService(field);
            let langid = that.userUILangId;
            if ((that.Mode & ChecklistMode.Designer) === ChecklistMode.Designer || (that.Mode & ChecklistMode.Preview) === ChecklistMode.Preview)
                langid = that.instance.langid;
            if (value instanceof Array) {
                let tmpValue = "";
                $.each(value, (idx, val) => {
                    tmpValue += val + "|";
                });
                if (tmpValue)
                    value = tmpValue.substring(0, tmpValue.length - 1);
                else
                    value = "";
            }
            if (!value) {
                callback(undefined);
                return;
            }
            let collection;
            $.each(that.instance.collections, (idx, value) => {
                if (value.id === field.dataname)
                    collection = value;
            });
            if (getDataFromService) {
                let requestData = {
                    id: value,
                    checklistid: this.instance["synerisid"],
                    langid,
                    column: field.datafield,
                    dataname: field.dataname,
                    ismultilanguage: collection.ismultilangft,
                    embedded: collection.embedded,
                    isft: collection.isft,
                    isselfref: field.isselfrefft,
                };
                if ((that.Mode & ChecklistMode.Designer) === ChecklistMode.Designer) {
                    that.instance["fordesigner"] = true;
                    requestData["checklistinstance"] = JSON.stringify(that.instance);
                }
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("ChecklistGetComboboxInfo"),
                    requestData: JSON.stringify(requestData),
                    done: (data) => {
                        callback(data);
                    }
                });
            }
            else {
                let values;
                if (value)
                    values = value.split('|');
                let dataPresentedInfo = {};
                let collection;
                $.each(that.instance.collections, (idx, tmpCollection) => {
                    if (tmpCollection.id === field.dataname)
                        collection = JSON.parse(JSON.stringify(tmpCollection));
                });
                let data;
                if (collection.ismultilangft) {
                    data = collection.data.filter(entry => entry["langid"] === langid);
                }
                else
                    data = collection.data;
                $.each(values, (idx, val) => {
                    if (field.isselfrefft) {
                        let selfRefStructure = [];
                        let currentId;
                        let parentId;
                        let text;
                        let selectedEntry = data.find(entry => entry["id"] === val);
                        if (!selectedEntry) {
                            if (field.datafield !== "id")
                                text = kendo.format(Utilities_1.synUtil.Strings.getValue("dynpftentryharddeletedid").replace('%s', '{0}'), val);
                            else
                                text = val;
                            let dict = {
                                id: val,
                                pid: parentId,
                                isAbstract: false,
                                softDeleted: false,
                                showSoftDeletedWarning: true,
                                hardDeleted: true
                            };
                            dict[field.datafield] = text;
                            selfRefStructure.push(dict);
                        }
                        else {
                            do {
                                currentId = that.GetCurrentValueForSelfRefControl(val, parentId, data);
                                parentId = that.GetPid(currentId, data);
                                text = that.GetText(currentId, field.datafield, data);
                                let _entry = data.find(entry => entry["id"] === currentId);
                                if (!_entry) {
                                    let dict = {
                                        id: val,
                                        pid: parentId,
                                        isAbstract: false,
                                        softDeleted: false,
                                        showSoftDeletedWarning: true,
                                        hardDeleted: true
                                    };
                                    dict[field.datafield] = that.GetText(val, field.datafield, data);
                                    selfRefStructure.push(dict);
                                    break;
                                }
                                else {
                                    let dict = {};
                                    $.each(_entry, (key, value) => {
                                        dict[key] = value;
                                    });
                                    let isAbstract = _entry["abstract"] && _entry["abstract"].toLowerCase() === "y";
                                    let isSoftDeleted = _entry["deleted"] && _entry["deleted"].toLowerCase() === "y";
                                    let showDeletedWarning = !(_entry["deletedwarning"] && _entry["deletedwarning"].toLowerCase() === "n");
                                    dict["pid"] = parentId;
                                    dict[field.datafield] = text;
                                    dict["isAbstract"] = isAbstract;
                                    dict["softDeleted"] = isSoftDeleted;
                                    dict["showSoftDeletedWarning"] = showDeletedWarning;
                                    selfRefStructure.push(dict);
                                    parentId = currentId;
                                }
                            } while (val !== parentId);
                        }
                        dataPresentedInfo[val] = selfRefStructure;
                    }
                    else {
                        if (collection.data) {
                            let collectionEntry = data.find(entry => entry.id === val);
                            if (!collectionEntry) {
                                collectionEntry = { id: val, hardDeleted: true };
                                if (field.datafield !== "id")
                                    collectionEntry[field.datafield] = kendo.format(Utilities_1.synUtil.Strings.getValue("dynpftentryharddeletedid").replace('%s', '{0}'), val);
                                else
                                    collectionEntry[field.datafield] = val;
                            }
                            dataPresentedInfo[val] = collectionEntry;
                        }
                    }
                });
                callback(dataPresentedInfo);
            }
        }
        else
            callback(undefined);
    }
    GetAttachmentInfo(attachment) {
        let attachmentInfo = new AttachmentInfo();
        let att = this.instance.attachments.find(att => att.id === attachment["Id"]);
        if (!att)
            att = attachment;
        attachmentInfo.FileName = att["filename"];
        attachmentInfo.FileExt = att["fileext"];
        attachmentInfo.FileSize = att["filesize"];
        attachmentInfo.MimeType = att["mimetype"];
        attachmentInfo.ContainerId = att["containerid"];
        attachmentInfo.FileId = att["fileid"];
        attachmentInfo.PrettyFileSize = att["prettyfilesize"];
        return attachmentInfo;
    }
    GetPids(field, value, keepIds, callback) {
        let that = this;
        let collection;
        $.each(that.instance.collections, (idx, value) => {
            if (value.id === field.dataname)
                collection = value;
        });
        let getDataFromService = that.GetDataFromService(field);
        if (value) {
            if (getDataFromService) {
                let requestData = {
                    isft: collection.isft,
                    isselfref: field.isselfrefft,
                    embedded: collection.embedded,
                    checklistid: that.instance["synerisid"],
                    id: value,
                    langid: that.instance.langid,
                    keepIds,
                };
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("ChecklistGetPids") + field.dataname + "/",
                    requestData: JSON.stringify(requestData),
                    done: (data) => {
                        callback(data);
                    }
                });
            }
            else {
                if (field.isselfrefft)
                    callback(collection.data.filter(entry => entry["id"] !== value && entry["pid"] === value));
                else
                    callback(undefined);
            }
        }
        else
            callback(undefined);
    }
    GetDataFromService(field) {
        let that = this;
        let collection;
        let getDataFromService = false;
        $.each(that.instance.collections, (idx, value) => {
            if (value.id === field.dataname)
                collection = value;
        });
        if ((that.Mode & ChecklistMode.Designer) === ChecklistMode.Designer || (that.Mode & ChecklistMode.Preview) === ChecklistMode.Preview) {
            if (collection.isft) {
                if (!(collection.embedded && collection.data))
                    getDataFromService = true;
            }
        }
        else
            getDataFromService = true;
        return getDataFromService;
    }
    GetCurrentValueForSelfRefControl(id, pid, collectionData) {
        let parentid = id;
        if (id !== pid) {
            while (parentid !== pid) {
                let tmpparentid = this.GetPid(parentid, collectionData);
                if (tmpparentid == undefined)
                    return undefined;
                if (tmpparentid === pid || tmpparentid === id)
                    break;
                if (tmpparentid === parentid)
                    break;
                else
                    parentid = tmpparentid;
            }
        }
        return parentid;
    }
    GetPid(id, collectionData) {
        let idx = collectionData.findIndex(entry => entry["id"] === id);
        if (idx !== -1)
            return collectionData[idx]["pid"];
        else
            return undefined;
    }
    GetText(id, colName, collectionData) {
        let idx = collectionData.findIndex(entry => entry["id"] === id);
        if (idx !== -1)
            return collectionData[idx][colName];
        else
            return undefined;
    }
    getPid(ftarray, id) {
        let elem;
        if (ftarray && ftarray.data) {
            ftarray.data.forEach((item) => {
                if (item.id === id)
                    elem = item;
            });
        }
        if (elem == undefined)
            return undefined;
        else
            return elem.pid;
    }
    checkSelfRefPid(ftname, ftid, isselfref) {
        let pid;
        let that = this;
        let data;
        $.each(that.dataCollection.allControls, (idx, value) => {
            if (value.id === ftname) {
                if (isselfref) {
                    let index;
                    for (index = 0; index < value.data.length; ++index) {
                        if (value.data[index].id === ftid) {
                            pid = value.data[index].pid;
                        }
                    }
                }
            }
        });
        return pid;
    }
    create() {
        let that = this;
        let createCallback = () => {
            if ((that.Mode & ChecklistMode.Questionnaire) === ChecklistMode.Questionnaire)
                that.createQuestionnaire(that.checklistjQuery);
            else
                that.createChecklist();
        };
        this.getLangId(createCallback);
    }
    checkIfItemsHaveHelpLabel(layout) {
        let that = this;
        let bReturn = false;
        if (layout) {
            $.each(layout, (idx, item) => {
                if (!bReturn) {
                    if (item.helplabels) {
                        let helpLabel = that.getLabel(item.helplabels, that.userUILangId, that.instance.langid);
                        if (helpLabel)
                            bReturn = true;
                    }
                    if (!bReturn && (item.type === "page" || item.type === "group")) {
                        bReturn = that.checkIfItemsHaveHelpLabel(item.layout);
                    }
                }
            });
        }
        return bReturn;
    }
    createChecklist() {
        let that = this;
        let jQueryContainer;
        let parent = that.checklistjQuery.parents(".clParent:first");
        if (!parent || parent.length === 0)
            parent = that.checklistjQuery;
        if (that.instance.maxwidth)
            parent.css("max-width", that.instance.maxwidth.toString() + "%");
        if (that.instance.minwidth)
            parent.css("min-width", that.instance.minwidth.toString() + "px");
        // check for pages
        let pagingEnabled = false;
        $.each(that.instance.layout, (idx, item) => {
            if (item.type === "page")
                pagingEnabled = true;
        });
        if (((that.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) && that.checkIfItemsHaveHelpLabel(that.instance.layout)) {
            let menu = $("<ul id='cleditor_menu' style='background-color:transparent'> </ul>").appendTo(that.checklistjQuery);
            $("<li claction='clhelp' style='float:right;'><img alt src='assets/checklist/help_16x16.png'/> </li>").appendTo(menu);
            menu.kendoMenu({
                select(e) {
                    let action = e.item.attributes.getNamedItem("claction").value;
                    let type;
                    if (e.item.attributes.getNamedItem("clmenutype"))
                        type = e.item.attributes.getNamedItem("clmenutype").value;
                    if (type === "button")
                        $(e.item).toggleClass("activeMenuEntry");
                    that.helpButtonChecked = !that.helpButtonChecked;
                    if (action === "clhelp") {
                        if (that.helpButtonChecked)
                            that.checklistjQuery.find(".checklisthelplabelcolumn").addClass("highlightHelpLabel");
                        else
                            that.checklistjQuery.find(".checklisthelplabelcolumn").removeClass("highlightHelpLabel");
                    }
                },
            });
        }
        if (pagingEnabled) {
            let tabstrip = $("<div id='cltabstrip' class='clTabStrip k-tabstrip-scrollable'/>");
            let tabList = $("<ul class='clTablist'/>").appendTo(tabstrip);
            let firstPage = true;
            for (let index = 0; index < that.instance.layout.length; ++index) {
                let item = that.instance.layout[index];
                if (item.type === "page") {
                    that.createPage(item, tabstrip, firstPage);
                    if (firstPage)
                        firstPage = false;
                }
            }
            tabstrip.appendTo(that.checklistjQuery);
            $("#cltabstrip").kendoTabStrip({
                select: (e) => {
                    let pageid = $(e.item).attr("cl_page_id");
                    let page = that.getFieldControl(pageid);
                    if (page instanceof ClPage) {
                        if (!page.initialized) {
                            that.initPage(page);
                            that.setRelationBetweenFields(pageid);
                        }
                    }
                }
            });
        }
        else {
            let checklistjQuery = $("<div />");
            for (let index = 0; index < that.instance.layout.length; ++index) {
                let item = that.instance.layout[index];
                if (item.type === "field") {
                    if (!jQueryContainer) {
                        let divContainer = $("<div class='clGroup'/>").appendTo(checklistjQuery);
                        divContainer.addClass("clBorder");
                        jQueryContainer = $("<div class='checklisttable'/>").appendTo(divContainer);
                    }
                    that.createField(item, jQueryContainer, undefined, 0);
                }
                else if (item.type === "group") {
                    that.createGroup(item, checklistjQuery, undefined, -1);
                    jQueryContainer = undefined;
                }
                else if (item.type === "layoutitem") {
                    if (!jQueryContainer) {
                        let divContainer = $("<div class='clGroup'/>").appendTo(checklistjQuery);
                        divContainer.addClass("clBorder");
                        jQueryContainer = $("<div class='checklisttable'/>").appendTo(divContainer);
                    }
                    that.createLayoutItem(item, jQueryContainer, undefined);
                }
            }
            checklistjQuery.appendTo(that.checklistjQuery);
        }
        for (let index = 0; index < that.instance.attachments.length; ++index) {
            let image = new ClAttachment();
            image.id = that.instance.attachments[index].id;
            image.containerid = that.instance.attachments[index].containerid;
            image.fileid = that.instance.attachments[index].fileid;
            that.imageCollection.allControls.push(image);
        }
        if ((that.Mode & ChecklistMode.Preview) === ChecklistMode.Preview)
            that.checkFieldVisibilities();
        // Set initially to changed because mapping could have happend or variables are resolved.
        that.setChecklistChanged(true);
        that.setRelationBetweenFields();
        if (that.configData && that.configData["loadingDiv"])
            that.configData["loadingDiv"].remove();
        that.checklistjQuery.trigger("checklistSet");
    }
    createQuestionnaire(jQueryElem) {
        let that = this;
        let control;
        let index;
        for (index = 0; index < that.instance.layout.length; ++index) {
            let field = that.instance.layout[index];
            if (field.type === "field") {
                if (field.controltype === "MultipleChoice") {
                    control = new ClMultipleChoiceForQuestionnaire(field.id, field, that);
                }
                if (control != undefined) {
                    that.fieldCollection.allControls.push(control);
                    control.init(jQueryElem);
                    $("#" + field.id + "_item").hide();
                }
            }
        }
        for (index = 0; index < that.instance.attachments.length; ++index) {
            let image = new ClAttachment();
            image.id = that.instance.attachments[index].id;
            image.containerid = that.instance.attachments[index].containerid;
            image.fileid = that.instance.attachments[index].fileid;
            that.imageCollection.allControls.push(image);
        }
        $("#" + this.configData.okButtonId).addClass("buttonquestionnaire");
        $("#" + this.configData.prevButtonId).addClass("buttonquestionnaire");
        $("#" + this.configData.nextButtonId).addClass("buttonquestionnaire");
        $("#" + this.configData.checkButtonId).addClass("buttonquestionnaire");
        $("#" + this.configData.okButtonId).hide();
        if (jQueryElem.children().length > 1) {
            jQueryElem.children().first().show();
            $("#" + this.configData.prevButtonId).hide();
            $("#" + this.configData.nextButtonId).show();
            $("#" + this.configData.checkButtonId).hide();
            $("#" + this.configData.nextButtonId).attr("disabled", "disabled");
        }
        else {
            $("#" + this.configData.checkButtonId).show();
            $("#" + this.configData.prevButtonId).hide();
            $("#" + this.configData.nextButtonId).hide();
            if (jQueryElem.children().length === 1)
                jQueryElem.children().first().show();
        }
    }
    createGroup(group, jQueryElem, pageId, width) {
        let that = this;
        let control = new ClGroup(group.id, group, that);
        control.setPageId(pageId);
        that.fieldCollection.allControls.push(control);
        control.init(jQueryElem);
        let divContainer = control.getInputControl();
        let jQueryContainer = $("<div class='checklisttable' id='" + group.id + "_group' />").appendTo(divContainer);
        let jQueryGroupContainer;
        for (let index = 0; index < group.layout.length; ++index) {
            let item = group.layout[index];
            if (item.type === "field") {
                if (width <= 0)
                    width = 0;
                that.createField(item, jQueryContainer, pageId, width);
            }
            else if (item.type === "group") {
                that.createGroup(item, jQueryContainer, pageId, ++width);
                jQueryGroupContainer = undefined;
            }
            else if (item.type === "layoutitem") {
                that.createLayoutItem(item, jQueryContainer, pageId);
            }
        }
    }
    createPage(page, jQueryElem, firstPage) {
        let that = this;
        let control = new ClPage(page.id, page, that, false, firstPage);
        that.fieldCollection.allControls.push(control);
        control.init(jQueryElem);
        control.jQueryContainer = $("<div class='checklisttable' id='" + page.id + "_page' />").appendTo(jQueryElem);
        if (firstPage) {
            that.initPage(control);
        }
    }
    initPage(control) {
        let that = this;
        let page = control.page;
        let jQueryContainer = control.jQueryContainer;
        if (page.backgroundcolor)
            jQueryContainer.css("background-color", page.backgroundcolor);
        control.helpLabelColumn = $("<div id='" + page.id + "_helplabeldiv' class='checklisthelplabelrow checklisthelplabelcolumn'/>").appendTo(jQueryContainer);
        let helpLabel = that.getLabel(page.helplabels, that.userUILangId, that.instance.langid);
        if (helpLabel)
            control.setHelpLabel(helpLabel, true);
        let jQueryGroupContainer;
        for (let index = 0; index < page.layout.length; ++index) {
            let item = page.layout[index];
            if (item.type === "field") {
                that.createField(item, jQueryContainer, page.id, 0);
            }
            else if (item.type === "group") {
                that.createGroup(item, jQueryContainer, page.id, 1);
                jQueryGroupContainer = undefined;
            }
            else if (item.type === "layoutitem") {
                that.createLayoutItem(item, jQueryContainer, page.id);
            }
        }
        control.initialized = true;
    }
    createField(field, jQueryElem, pageId, levelcount) {
        let that = this;
        let control;
        switch (field.controltype) {
            case "StaticText":
                control = new ClStaticText(field.id, field, that, levelcount, field.datatype);
                break;
            case "Input":
                switch (field.datatype) {
                    case "String":
                        control = new ClTextInput(field.id, field, that, levelcount);
                        break;
                    case "Integer":
                    case "Float":
                        control = new ClNumericInput(field.id, field, that, levelcount, field.datatype);
                        break;
                    case "Date":
                    case "Time":
                    case "Datetime":
                        control = new ClDatetime(field.id, field, that, levelcount, field.datatype);
                        break;
                }
                break;
            case "TextArea":
                control = new ClTextArea(field.id, field, that, levelcount);
                break;
            case "Radiobutton":
                control = new ClMVCheckBoxRadio(field.id, field, that, levelcount, field.controltype);
                break;
            case "Checkbox":
                if (field.multivalue === true)
                    control = new ClMVCheckBoxRadio(field.id, field, that, levelcount, field.controltype);
                else
                    control = new ClSVCheckBoxSwitch(field.id, field, that, levelcount, field.controltype);
                break;
            case "Combobox":
                if (field.isselfrefft)
                    control = new ClSRComboboxContainer(field.id, field, that, levelcount);
                else
                    control = new ClCombobox(field.id, field, that, levelcount);
                break;
            case "ImageView":
                control = new ClImageViewControl(field.id, field, that, levelcount, that.instance.containerid);
                break;
            case "Switch":
                control = new ClSVCheckBoxSwitch(field.id, field, that, levelcount, field.controltype);
                break;
            case "MultipleChoice":
                control = new ClMultipleChoice(field.id, field, that, levelcount);
                break;
        }
        if (control != undefined) {
            control.pageId = pageId;
            that.fieldCollection.allControls.push(control);
            control.init(jQueryElem);
            $(control).on("controlValueChanged", function (e) {
                if (field.mandatory && (that.Mode & ChecklistMode.Editor) === ChecklistMode.Editor)
                    that.checkIfMandatoryFieldsAreSet(field.conrelfield);
            });
        }
    }
    createLayoutItem(item, jQueryElem, pageId) {
        if (item.layouttype === "HorizontalLine") {
            let control = new LayoutItem(item.id, item, this);
            control.setPageId(pageId);
            this.fieldCollection.allControls.push(control);
            control.init(jQueryElem);
        }
    }
    setInitialConditionRelationBetweenFields() {
        let that = this;
        $.each(that.fieldCollection.allControls, (idx, control) => {
            if (control.field.conditioninfo) {
                $.each(control.field.conditioninfo["parent"], (idx, parentItemid) => {
                    let parentControl = that.getFieldControl(parentItemid);
                    if (control.ConditionParentFields.indexOf(parentControl) === -1)
                        control.ConditionParentFields.push(parentControl);
                });
                $.each(control.field.conditioninfo["child"], (idx, childItemid) => {
                    let childControl = that.getFieldControl(childItemid);
                    if (control.ConditionChildFields.indexOf(childControl) === -1)
                        control.ConditionChildFields.push(childControl);
                });
            }
        });
    }
    setConditionRelationBetweenFields(controls = []) {
        let that = this;
        if (controls.length === 0)
            controls = that.fieldCollection.allControls;
        $.each(controls, (idx, control) => {
            if (control.field.condition) {
                let itemIds = that.getItemIdsFromCondition(control.field.condition);
                $.each(itemIds, (idx, itemid) => {
                    // let item = that.getItemById(itemid);
                    let parentControl = that.getFieldControl(itemid);
                    if (parentControl.ConditionChildFields.indexOf(control) === -1)
                        parentControl.ConditionChildFields.push(control);
                    if (control.ConditionParentFields.indexOf(parentControl) === -1)
                        control.ConditionParentFields.push(parentControl);
                });
            }
        });
    }
    setRelationBetweenFields(pageId = undefined) {
        let that = this;
        let controlsToSet = [];
        if (pageId)
            controlsToSet = that.fieldCollection.allControls.filter(elem => elem.getPageId() === pageId);
        else
            controlsToSet = that.fieldCollection.allControls;
        $.each(controlsToSet, (idx, control) => {
            if (control instanceof ClFieldControl) {
                control.resetRelation();
            }
        });
        $.each(controlsToSet, (idx, control) => {
            if (control instanceof ClFieldControl) {
                if (control.field.dependentfield) {
                    let dependentfieldControl = that.getFieldControl(control.field.dependentfield);
                    if (dependentfieldControl instanceof ClFieldControl) {
                        control.ParentField = dependentfieldControl;
                        if (dependentfieldControl.ChildFields.indexOf(control) === -1)
                            dependentfieldControl.ChildFields.push(control);
                    }
                }
            }
        });
        $.each(controlsToSet, (idx, control) => {
            if (control instanceof ClCombobox || control instanceof ClMVCheckBoxRadio || control instanceof ClMultipleChoice) {
                if (control.ParentField)
                    control.enable(!control.IsReadOnly());
            }
            if (control instanceof ClFieldControl) {
                if (!control.ParentField && control.ChildFields && control.ChildFields.length > 0) {
                    control.parentFieldControlHasChanged(true, false);
                }
            }
        });
    }
    RemoveFile(oldContainerId, oldFileId) {
        if (oldContainerId && oldFileId) {
            Utilities_1.synUtil.getAJAXData({
                url: "WSProxy.axd?cache=FileCache/" + oldContainerId + "/" + oldFileId + "/",
                method: "DELETE",
                fail() {
                    "Method not implemented.";
                },
            });
        }
    }
    addImageToField(fieldId, imageGuid, fileInfo, isStatic = false) {
        let field = this.getFieldById(fieldId, this.instance.layout);
        if (field) {
            let bAdd = true;
            let order = 0;
            $.each(field.attachments, (idx, value) => {
                if (value.Id === imageGuid)
                    bAdd = false;
                else {
                    if (value.Order > order)
                        order = value.Order;
                }
            });
            if (bAdd) {
                ++order;
                let image = {
                    Id: imageGuid,
                    containerid: fileInfo.containerid,
                    fileid: fileInfo.fileid,
                    Static: isStatic,
                    filename: fileInfo.filename,
                    fileext: fileInfo.fileext,
                    filesize: fileInfo.filesize,
                    mimetype: fileInfo.mimetype,
                    prettyfilesize: fileInfo.prettyfilesize,
                    Order: order,
                };
                field.attachments.push(image);
            }
        }
    }
    updateAttachmentOrder(fieldId, attachmentId, order) {
        // let field = this.instance.layout.find(item => item.id === fieldId);//
        let field = this.getFieldByIdNew(fieldId, this.instance.layout);
        if (field) {
            let attachment = field.attachments.find(att => att.Id === attachmentId);
            if (attachment)
                attachment.Order = order;
        }
    }
    removeImageFromField(fieldId, imageGuid) {
        let field = this.getFieldById(fieldId, this.instance.layout);
        if (field) {
            let index = -1;
            $.each(field.attachments, (idx, value) => {
                if (value.Id === imageGuid)
                    index = Number(idx);
            });
            if (index !== -1) {
                field.attachments.splice(index, 1);
            }
        }
    }
    getFieldById(fieldId, layout) {
        let field;
        if (layout) {
            $.each(layout, (idx, value) => {
                if (value.type === "field") {
                    if (value.id === fieldId) {
                        field = value;
                    }
                }
                else if (value.layout) {
                    if (!field)
                        field = this.getFieldById(fieldId, value.layout);
                }
            });
        }
        return field;
    }
    getFieldByIdNew(fieldId, layout) {
        let field;
        if (layout) {
            for (let idx = 0; idx < layout.length; ++idx) {
                let item = layout[idx];
                if (item.type === "field") {
                    if (item.id === fieldId) {
                        field = item;
                    }
                }
                else if (item.layout) {
                    if (!field)
                        field = this.getFieldByIdNew(fieldId, item.layout);
                }
            }
        }
        return field;
    }
    addImageToCollection(imageId, containerId, fileId) {
        let bFound = false;
        $.each(this.imageCollection.allControls, (idx, value) => {
            if (value.id === imageId)
                bFound = true;
        });
        if (!bFound) {
            let image = new ClAttachment();
            image.id = imageId;
            image.containerid = containerId;
            image.fileid = fileId;
            this.imageCollection.allControls.push(image);
        }
    }
    getAttachmentsInternal(layout) {
        let that = this;
        let attachments = [];
        if (layout) {
            $.each(layout, (idx, value) => {
                if (value.type === "field") {
                    if (value.controltype === "ImageView" && value.attachments) {
                        $.each(value.attachments, (idx, value) => {
                            let tmpImage = value;
                            tmpImage.fileid = that.getFileId(tmpImage.Id, tmpImage.FieldId);
                            tmpImage.containerid = that.getContainerId(tmpImage.Id, tmpImage.FieldId);
                            attachments.push(value);
                        });
                    }
                }
                else if (value.layout) {
                    let tmpArr = this.getAttachmentsInternal(value.layout);
                    if (tmpArr)
                        attachments.push(tmpArr);
                }
            });
        }
        if (attachments && attachments.length > 0)
            return attachments;
        else
            return undefined;
    }
    selectQuestion(next, configData) {
        let elem = $(".checklistrow:visible");
        if (configData && elem) {
            $("#" + configData.checkButtonId).hide();
            elem.hide();
            if (next) {
                let nextElem = elem.next();
                nextElem.show();
                let lastElem = this.checklistjQuery.children().last();
                if (nextElem.is(lastElem)) {
                    $("#" + configData.prevButtonId).show();
                    $("#" + configData.nextButtonId).hide();
                    $("#" + configData.checkButtonId).show();
                    $("#" + configData.checkButtonId).attr("disabled", "disabled");
                }
                else {
                    $("#" + configData.nextButtonId).show();
                    $("#" + configData.prevButtonId).show();
                    let fieldId = nextElem.children(".checklistinputrow").attr("cl_fieldId");
                    let value = this.getFieldControl(fieldId).getValue();
                    if (value == undefined)
                        $("#" + configData.nextButtonId).attr("disabled", "disabled");
                    else
                        $("#" + configData.nextButtonId).removeAttr("disabled");
                }
            }
            else {
                let prevElem = elem.prev();
                prevElem.show();
                let firstElem = this.checklistjQuery.children().first();
                if (prevElem.is(firstElem)) {
                    $("#" + configData.prevButtonId).hide();
                    $("#" + configData.nextButtonId).show();
                }
                else {
                    $("#" + configData.nextButtonId).show();
                    $("#" + configData.prevButtonId).show();
                }
                let fieldId = prevElem.children(".checklistinputrow").attr("cl_fieldId");
                let value = this.getFieldControl(fieldId).getValue();
                if (value == undefined)
                    $("#" + configData.nextButtonId).attr("disabled", "disabled");
                else
                    $("#" + configData.nextButtonId).removeAttr("disabled");
            }
        }
    }
    showResult(result) {
        this.checklistjQuery.children().hide();
        let resControl = $("<div id='questionnaire_res_" + this.instance.checklistid + "' class='questionnaireresultcontainer'/>").appendTo(this.checklistjQuery);
        let resIcon = $("<span class='questionnaireresulticon' />").appendTo(resControl);
        if (result["passed"]) {
            resControl.addClass("correct");
            $("<label class='resulticon'>✓</label>").appendTo(resIcon);
            let resultLabel = Utilities_1.synUtil.Strings.getValue("questionnairesucceedlabel");
            if (resultLabel && resultLabel !== "questionnairesucceedlabel") {
                $("<div class='correct resulticon resultlabel'>" + resultLabel + "</div>").appendTo(this.checklistjQuery);
            }
        }
        else {
            resControl.addClass("wrong");
            $("<label class='resulticon'>✗</label>").appendTo(resIcon);
            let resultLabel = Utilities_1.synUtil.Strings.getValue("questionnairefailedlabel");
            if (resultLabel && resultLabel !== "questionnairefailedlabel") {
                resultLabel = resultLabel.replace("{0}", result["passingrate"]);
                $("<div class='wrong resulticon resultlabel'>" + resultLabel + "</div>").appendTo(this.checklistjQuery);
            }
        }
        if (result["result"]) {
            let table = $("<table class='questionnaireresulttable'/>").appendTo(this.checklistjQuery);
            $.each(result["result"], (idx, value) => {
                let row = $("<tr class='questionnaireresulttablerow'/>").appendTo(table);
                let iconCol = $("<th class='questionnaireresulttablecolicon' />").appendTo(row);
                $("<th style='padding:10px;'> <label class='questionnaireresulttablecollabel'>" + idx.toString() + "</label></th>").appendTo(row);
                if (value) {
                    iconCol.addClass("correct");
                    $("<span class='resulticon'>✓</span>").appendTo(iconCol);
                }
                else {
                    $("<span class='resulticon'>✗</span>").appendTo(iconCol);
                    iconCol.addClass("wrong");
                }
            });
        }
    }
    updateCollection(listName) {
        let that = this;
        // If already cached update
        let alreadyCached = false;
        let collection;
        $.each(that.instance.collections, (idx, list) => {
            if (list.id === listName)
                collection = JSON.parse(JSON.stringify(list));
        });
        $.each(that.dataCollection.allControls, (idx, value) => {
            if (value["id"] === listName) {
                alreadyCached = true;
                value["data"] = collection.data;
                value["columns"] = collection.columns;
                value["ismultilangft"] = collection.ismultilangft;
            }
        });
        if (!alreadyCached) {
            let newCollection = new ClCollection();
            newCollection.id = collection.id;
            newCollection.data = collection.data;
            newCollection.columns = collection.columns;
            newCollection.ismultilangft = collection.ismultilangft;
            newCollection["embedded"] = true;
            that.dataCollection.pushControl(collection);
        }
    }
    checkIfExternalIdIsUnique(externalId, id) {
        return this.checkIfExternalIdIsUniqueInternal(externalId, id, this.instance["layout"]);
    }
    checkIfExternalIdIsUniqueInternal(externalId, id, layout) {
        let unique = true;
        $.each(layout, (idx, item) => {
            if (unique) {
                if (item["id"] !== id) {
                    if (item["externalid"] === externalId)
                        unique = false;
                    if (unique) {
                        if (item["layout"]) {
                            unique = this.checkIfExternalIdIsUniqueInternal(externalId, id, item["layout"]);
                        }
                    }
                }
            }
        });
        return unique;
    }
    updateConditionIds(oldId, newId) {
        this.updateConditionIdsInternal(this.instance.layout, oldId, newId);
    }
    updateConditionIdsInternal(layout, oldId, newId) {
        $.each(layout, (idx, item) => {
            if (item["condition"]) {
                let condition = item["condition"];
                if (condition.indexOf(oldId) !== -1) {
                    let newcondition = "";
                    condition = condition.replace("||", "*# #*||");
                    condition = condition.replace("&&", "*# #*&&");
                    condition = condition.replace("==", "*# #*==");
                    condition = condition.replace("!=", "*# #*!=");
                    condition = condition.replace(">=", "*# #*>=");
                    condition = condition.replace("<=", "*# #*<=");
                    condition = condition.replace(">", "*# #*>");
                    condition = condition.replace("<", "*# #*<");
                    condition = condition.replace("ISNOTNULL", "*# #*ISNOTNULL");
                    condition = condition.replace("ISNULL", "*# #*ISNULL");
                    let externalIds = condition.split("*# #*");
                    $.each(externalIds, (idx, val) => {
                        if (val === oldId)
                            newcondition += val.replace(oldId, newId);
                        else
                            newcondition += val;
                    });
                    item["condition"] = newcondition;
                }
            }
            if (item["type"] === "group" || item["type"] === "page") {
                this.updateConditionIdsInternal(item["layout"], oldId, newId);
            }
        });
    }
    getUsedColumns(dataName) {
        let collection = this.instance.collections.find(col => col.id === dataName);
        let result = this.getUsedColumnsInternal(this.instance.layout, dataName);
        if (collection && collection["ismultilangft"]) {
            if (result["columns"].indexOf("langid") === -1)
                result["columns"].push("langid");
        }
        return result;
    }
    getUsedColumnsInternal(layout, dataName) {
        let result = { columns: ["id"], fields: [] };
        // let columns = ["id"];
        for (let idx = 0; idx < layout.length; idx++) {
            let item = layout[idx];
            if (item["type"] === "group" || item["type"] === "page") {
                let internalResult = this.getUsedColumnsInternal(item.layout, dataName);
                result.columns = [...new Set(result.columns.concat(internalResult["columns"]))];
                result.fields = [...new Set(result.fields.concat(internalResult["fields"]))];
            }
            else if (item["type"] === "field") {
                if (item["dataname"] && item["dataname"] === dataName) {
                    if (result.columns.findIndex(c => c === item["datafield"]) === -1)
                        result.columns.push(item["datafield"]);
                    if (item["ftsort"]) {
                        let sortColum = item["ftsort"].split(".")[0];
                        if (result.columns.indexOf(sortColum) === -1)
                            result.columns.push(sortColum);
                    }
                    if (item["isselfrefft"] || item["dependentfield"]) {
                        if (result.columns.indexOf("pid") === -1)
                            result.columns.push("pid");
                    }
                    if (item["barcodecolumn"]) {
                        if (result.columns.indexOf(item["barcodecolumn"]) === -1)
                            result.columns.push(item["barcodecolumn"]);
                    }
                    let label = item.labels.find(l => l.langid === this.userUILangId);
                    if (!label)
                        label = item.labels.find(l => l.langid === this.instance.langid);
                    if (label) {
                        if (result.fields.findIndex(f => f === label.text) === -1)
                            result.fields.push(label.text);
                    }
                }
            }
        }
        return result;
    }
    GetLinkedFields(fieldId) {
        let linkedFields = [];
        if (fieldId) {
            $.each(this.Fields(), (idx, field) => {
                if (field["linkedfield"] === fieldId)
                    linkedFields.push(field);
            });
        }
        return linkedFields;
    }
    GetCompleteRelatedFields(fieldId) {
        let relatedFields = this.GetAllParentFields(fieldId);
        relatedFields = relatedFields.concat(this.GetAllChildFields(fieldId));
        return relatedFields;
    }
    GetAllParentFields(fieldId) {
        let parentFields = [];
        if (fieldId) {
            let control = this.getFieldControl(fieldId);
            if (control instanceof ClFieldControl) {
                if (control.ParentField) {
                    parentFields.push(control.ParentField.field);
                    parentFields = parentFields.concat(this.GetAllParentFields(control.ParentField.field.id));
                }
            }
        }
        return parentFields;
    }
    GetAllChildFields(fieldId) {
        let that = this;
        let childFields = [];
        if (fieldId) {
            let control = this.getFieldControl(fieldId);
            if (control instanceof ClFieldControl) {
                if (control.ChildFields && control.ChildFields.length > 0) {
                    $.each(control.ChildFields, (idx, childField) => {
                        childFields.push(childField.field);
                        childFields = childFields.concat(that.GetAllChildFields(childField.field.id));
                    });
                }
            }
        }
        return childFields;
    }
    GetChildFields(fieldId) {
        let childFields = [];
        if (fieldId) {
            let control = this.getFieldControl(fieldId);
            if (control instanceof ClFieldControl) {
                if (control.ChildFields && control.ChildFields.length > 0) {
                    $.each(control.ChildFields, (idx, childField) => {
                        childFields.push(childField.field);
                    });
                }
            }
        }
        return childFields;
    }
    GetDependentFields(fieldId) {
        let dependentFields = [];
        if (fieldId) {
            let control = this.getFieldControl(fieldId);
            if (control instanceof ClFieldControl) {
                if (control.ParentField) {
                    dependentFields.push(control.ParentField.field);
                }
                if (control.ChildFields && control.ChildFields.length > 0) {
                    $.each(control.ChildFields, (idx, childField) => {
                        dependentFields.push(childField.field);
                    });
                }
            }
        }
        return dependentFields;
    }
    GetNotSelectedLinkedFields(fieldId, selectedItems) {
        let notSelectedLinkedFields = [];
        let linkedFields = this.GetLinkedFields(fieldId);
        $.each(linkedFields, (idx, value) => {
            if (selectedItems.indexOf(value) === -1) {
                notSelectedLinkedFields.push(value);
            }
        });
        return notSelectedLinkedFields;
    }
    getItemIdsFromCondition(condition) {
        let that = this;
        let itemIds = [];
        if (condition) {
            let parts = condition.replace(/&&|==|!=|>=|>|<=|ISNULL|ISNOTNULL|\|\|/g, "*# #*").split("*# #*").filter(Boolean);
            let items = that.Items();
            $.each(parts, (idx, part) => {
                part = part.replace(" ", "");
                if (items.findIndex(item => item.externalid === part) !== -1) {
                    let item = items.find(item => item.externalid === part);
                    if (itemIds.findIndex(item => item === item.id) === -1)
                        itemIds.push(item.id);
                }
            });
        }
        return itemIds;
    }
    GetConditionChildItems(itemId) {
        let relevantItems = [];
        $.each(this.Items(), (idx, item) => {
            if (item["id"] !== itemId) {
                if (item["condition"]) {
                    let itemids = this.getItemIdsFromCondition(item["condition"]);
                    $.each(itemids, (idx, tmpItemid) => {
                        if (tmpItemid === itemId && relevantItems.indexOf(item["id"]) === -1)
                            relevantItems.push(item["id"]);
                    });
                }
            }
        });
        return relevantItems;
    }
    GetConditionRelevantItems(itemId) {
        let relevantItems = this.GetConditionChildItems(itemId);
        let item = this.getItemById(itemId);
        if (item["condition"]) {
            let itemids = this.getItemIdsFromCondition(item["condition"]);
            $.each(itemids, (idx, tmpItemid) => {
                if (tmpItemid !== itemId && relevantItems.indexOf(tmpItemid) === -1)
                    relevantItems.push(tmpItemid);
            });
        }
        else {
            if (relevantItems.length > 0) {
                if (relevantItems.indexOf(itemId))
                    relevantItems.push(itemId);
            }
        }
        return relevantItems;
    }
    setSavedInstance(savedInstance) {
        let that = this;
        if (savedInstance.synerisid && savedInstance.synerisid !== that.instance.synerisid)
            that.instance.synerisid = savedInstance.synerisid;
        that.updateInstanceItems(that.instance.layout, savedInstance);
        that.instance.attachments = savedInstance.attachments;
        $.each(that.Fields(), (idx, field) => {
            let control = that.getFieldControl(field.id);
            if (control instanceof ClFieldControl)
                control.updateValue(field, true, false);
        });
    }
    updateInstanceItems(layout, savedInstance) {
        let that = this;
        for (let index = 0; index < layout.length; ++index) {
            let item = layout[index];
            if (item.type === "group" || item.type === "page") {
                that.updateInstanceItems(item.layout, savedInstance);
            }
            item.value = that.getItemByIdInternal(savedInstance.layout, item.id).value;
            item.attachments = that.getItemByIdInternal(savedInstance.layout, item.id).attachments;
        }
    }
    isSoftDeleted(item) {
        let bReturn = false;
        if (item) {
            if (item.softDeleted || (item.deleted && item.deleted.toLowerCase() === "y"))
                bReturn = true;
        }
        return bReturn;
    }
    showDeletedWarning(item) {
        let bReturn = true;
        if (item) {
            if (item.showSoftDeletedWarning === false || (item.deletedwarning && item.deletedwarning.toLowerCase() === "n"))
                bReturn = false;
        }
        return bReturn;
    }
    isHardDeleted(item) {
        let bReturn = false;
        if (item) {
            if (item.hardDeleted)
                bReturn = true;
        }
        return bReturn;
    }
    isAbstract(item) {
        let bReturn = false;
        if (item) {
            if (item.isAbstract || (item.abstract && item.abstract.toLowerCase() === "y"))
                bReturn = true;
        }
        return bReturn;
    }
    isInvalid(item) {
        let bReturn = false;
        if (item) {
            if (item.isInvalid)
                bReturn = true;
        }
        return bReturn;
    }
    executeTelLink(text) {
        if (text) {
            let telnumber = this.filterTelephoneNumber(text);
            if (telnumber)
                window.open("tel:" + telnumber, "_self");
        }
    }
    filterTelephoneNumber(text) {
        let telnumber = text;
        if (telnumber) {
            telnumber = telnumber.trim();
            telnumber = telnumber.replace("tel:", "");
            telnumber = telnumber.replace(/[^0-9+#]/gi, "");
            let re_weburl = new RegExp("\\+?[0-9-/\\.*#()-]+", "gi");
            let regExResult = telnumber.match(re_weburl);
            if (regExResult && regExResult.length > 0)
                telnumber = regExResult[0];
            else
                telnumber = undefined;
        }
        return telnumber;
    }
    getAsArray(value) {
        if (value) {
            if (value instanceof Array)
                return value;
            else
                return value.split("|");
        }
        else
            return [];
    }
    getAllParentFields(allFields, currentField) {
        let parents = [];
        if (currentField.dependentfield) {
            // get parentfield
            let parentField = allFields.find(f => f["id"] === currentField.dependentfield);
            parents.push(parentField);
            parents = parents.concat(this.getAllParentFields(allFields, parentField));
        }
        return parents;
    }
    checkIfMandatoryFieldsAreSet(itemIsConditionRelevant) {
        let that = this;
        let mandatoryFieldsAreSet = true;
        if ((that.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
            let callback = () => {
                $.each(that.Fields(), (idx, field) => {
                    if (field["mandatory"] && field.visible === true && field.show === true) {
                        let control = that.getFieldControl(field["id"]);
                        if (control instanceof ClFieldControl) {
                            if (!control.hasValue())
                                mandatoryFieldsAreSet = false;
                        }
                    }
                });
                if (mandatoryFieldsAreSet) {
                    that.checklistjQuery.trigger("clMandatoryFieldsAreSet");
                }
            };
            if (itemIsConditionRelevant) {
                let tmpInstance = $.extend(true, {}, that.instance);
                let requestOptions = {
                    instance: JSON.stringify(tmpInstance),
                    forDesigner: false,
                };
                Utilities_1.synUtil.getAJAXData({
                    method: "POST",
                    url: Utilities_1.synUtil.getWSUrl("ChecklistCheckConditions"),
                    requestData: requestOptions,
                    done: (data) => {
                        that.updateVisibilities(data.layout);
                        callback();
                    },
                });
            }
            else
                callback();
        }
    }
    getFaceDetectionRetryCount() {
        if (this.faceDetectionRetryCountInit) {
            this.faceDetectionRetryCountInit = false;
            let strFacedetectionretrycount = Utilities_1.synUtil.Configs.getValue("checklistfacedetectionretrycount", "2");
            if (strFacedetectionretrycount)
                this.faceDetectionRetryCount = Number.parseInt(strFacedetectionretrycount);
        }
        return this.faceDetectionRetryCount;
    }
}
exports.ClControlFactory = ClControlFactory;
class ClCollection {
}
exports.ClCollection = ClCollection;
class ClAttachment {
}
class ClControl {
    constructor(prependId, field, checklistControlFactory) {
        this.field = field;
        this.ConditionParentFields = [];
        this.ConditionChildFields = [];
        this.pageId = undefined;
        this.id = prependId;
        this.clControlFactory = checklistControlFactory;
    }
    getDOMControl() {
        return $("#" + this.id);
    }
    getCurrentValue() {
        "Method not implemented.";
    }
    getValue() {
        return undefined;
    }
    getInputControl() {
        return this.inputControl;
    }
    getPageId() {
        return this.pageId;
    }
    setPageId(pageId) {
        this.pageId = pageId;
    }
    init(jQueryElem) {
        this.initJQueryElem = jQueryElem;
        this.divContainer = $("<div id='" + this.id + "_item' class='checklistrow'/>").appendTo(jQueryElem);
        this.divItem = $("<div id='" + this.id + "_inputitem' class='checklistinputrow'/>").appendTo(this.divContainer);
        if ((this.clControlFactory.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
            if (this.clControlFactory.rowSpacing > 0) {
                let spacing = (this.clControlFactory.rowSpacing / 2).toString();
                this.divItem.css("padding-top", spacing + "px");
                this.divItem.css("padding-bottom", spacing + "px");
            }
            else {
                this.divItem.css("padding-top", "0px");
                this.divItem.css("padding-bottom", "0px");
            }
            if (this.clControlFactory.instance.fontsize)
                this.divItem.css("font-size", this.clControlFactory.instance.fontsize.toString() + "px");
        }
    }
    IsReadOnly() {
        return this.clControlFactory.ReadOnly || this.field.readonly;
    }
    enable(enable) {
        if (enable) {
            this.inputControl.removeClass("clReadOnly");
        }
        else {
            this.inputControl.addClass("clReadOnly");
        }
    }
    setVisibility(visible, show) {
        if ((this.clControlFactory.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
            if (this.divItem) {
                if (visible === true && show === true)
                    this.divItem.show();
                else
                    this.divItem.hide();
            }
        }
    }
    setHelpLabel(label, forPage) {
        let that = this;
        if (label) {
            let container = $("<div class='display: block; box-sizing:boder-box; width: 100%' />").appendTo(that.helpLabelColumn);
            if (forPage)
                container.css("padding", "10px");
            else
                container.css("padding", "0px 0px 10px 0px");
            let ldiv = $("<div style='display:inline-block; width: 1.25em' />").appendTo(container);
            let rdiv = $("<div style='display:inline-block; width: calc(100% - 1.25em)'/>").appendTo(container);
            $("<img alt src='assets/checklist/help_16x16.png' style='width:1em;height:1em;display:inline-block;margin-right:2px;vertical-align: top;'/>").appendTo(ldiv);
            $(label).appendTo(rdiv);
        }
    }
}
class ClFieldControl extends ClControl {
    constructor(prependId, field, checklistControlFactory, levelcount) {
        super(prependId, field, checklistControlFactory);
        this.ChildFields = [];
        this.valid = true;
        this.invalidIds = [];
        this.multiValues = new MultiValueCollection();
        this.levelcount = levelcount;
        if (field.colcount)
            this.columncount = field.colcount;
        else
            this.columncount = 1;
        this.keepIds = [];
        this.hardDeletedIds = [];
    }
    notifyChange(ignore = false) {
        let that = this;
        that.field.value = this.getValue();
        if (that.field.datatype === "List")
            that.removeNotNeededDataPresentedInfo();
        let checkFieldVisibilities = false;
        if (that.field.conrelfield || (that.clControlFactory.Mode & ChecklistMode.Preview) === ChecklistMode.Preview)
            checkFieldVisibilities = true;
        if (!ignore) {
            if (this.field["linkedfield"]) {
                let linkedFields = this.clControlFactory.GetLinkedFields(this.field["linkedfield"]);
                $.each(linkedFields, (idx, linkedField) => {
                    if (linkedField["id"] !== this.field["id"]) {
                        let control = this.clControlFactory.getFieldControl(linkedField["id"]);
                        linkedField.value = that.getValue();
                        if (control instanceof ClFieldControl) {
                            control.updateValue(linkedField, true);
                            if (linkedField.conrelfield || (that.clControlFactory.Mode & ChecklistMode.Preview) === ChecklistMode.Preview)
                                checkFieldVisibilities = true;
                        }
                    }
                });
            }
        }
        that.parentFieldControlHasChanged(true, true);
        if (checkFieldVisibilities)
            that.clControlFactory.checkFieldVisibilities();
        that.clControlFactory.setChecklistChanged(true);
        that.highlightMandatory();
    }
    highlightMandatory() {
        if (this.field.mandatory && !this.hasValue())
            this.inputControl.addClass("clMandatory");
        else
            this.inputControl.removeClass("clMandatory");
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        if (!that.parentcontrol) {
            that.labelColumn = $("<div id='" + that.id + "_labeldiv' class='checklistlabelcolumn'/>").appendTo(that.divItem);
            let fontSize = that.labelColumn.css('font-size');
            let offset = that.levelcount * 5 + 10;
            that.labelColumn.css("width", "30%");
            that.inputColumn = $("<div id='" + that.id + "_controldiv' class='checklistinputcolumn'/>").appendTo(that.divItem);
            if (that.field.controltype !== "StaticText" && (that.field.datatype !== "StaticImage")) {
                if (that.field.labelhorizontaloption && (that.field.labelhorizontaloption.toLowerCase() === "center" || that.field.labelhorizontaloption.toLowerCase() === "left" || that.field.labelhorizontaloption.toLowerCase() === "justify"))
                    that.labelColumn.css("text-align", that.field.labelhorizontaloption.toLowerCase());
                else
                    that.labelColumn.css("text-align", "right");
                if (that.field.labelverticaloption && (that.field.labelverticaloption.toLowerCase() === "middle" || that.field.labelverticaloption.toLowerCase() === "bottom"))
                    that.labelColumn.css("vertical-align", that.field.labelverticaloption.toLowerCase());
                else
                    that.labelColumn.css("vertical-align", "top");
                let label = that.clControlFactory.getLabel(that.field.labels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
                if (label) {
                    $(label).appendTo(that.labelColumn);
                }
            }
            that.controljQueryElem = $("<div id='" + that.id + "_controlcontainer' class='controlcontainer'/>").appendTo(that.inputColumn);
            that.helpLabelRow = $("<div id='" + that.id + "_helplabelrow' class='checklisthelplabelrow checklisthelplabelcolumn'/>").appendTo(that.divContainer);
            let helpLabelColumn = $("<div class='checklisthelplabelcol'/>").appendTo(that.helpLabelRow);
            helpLabelColumn.css("width", "30%");
            that.helpLabelColumn = $("<div id='" + that.id + "_helplabeldiv' class='checklisthelplabelinputcolumn'/>").appendTo(that.helpLabelRow);
            let helpLabel = that.clControlFactory.getLabel(that.field.helplabels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
            that.setHelpLabel(helpLabel, false);
            if (that.field.datapresentedinfo) {
                $.each(that.field.datapresentedinfo, (key, value) => {
                    if (that.clControlFactory.isSoftDeleted(value) || that.clControlFactory.isHardDeleted(value) || that.clControlFactory.isAbstract(value)) {
                        that.keepIds.push(key);
                        if (that.clControlFactory.isHardDeleted(value))
                            that.hardDeletedIds.push(key);
                    }
                });
            }
        }
        else
            that.jQueryElem = that.parentcontrol.jQueryElem;
    }
    resetHelpLabel(callback) {
        let that = this;
        if (that.field.controltype !== "StaticText") {
            let resolveMarkdownCallback = function () {
                let label = that.clControlFactory.getLabel(that.field.helplabels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
                that.helpLabelColumn.children().remove();
                that.setHelpLabel(label, false);
                if (callback)
                    callback();
            };
            let requestOptions = {
                labels: JSON.stringify(that.field.helplabels)
            };
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                requestData: requestOptions,
                url: Utilities_1.synUtil.getWSUrl("ChecklistResolveMarkdown"),
                done(helplabels) {
                    that.field.helplabels = helplabels;
                    resolveMarkdownCallback();
                }
            });
        }
    }
    resetLabel(callback) {
        let that = this;
        if (that.field.controltype !== "StaticText" && that.field.datatype !== "StaticImage") {
            let resolveMarkdownCallback = function () {
                if (that.field.labelhorizontaloption && (that.field.labelhorizontaloption.toLowerCase() === "center" || that.field.labelhorizontaloption.toLowerCase() === "left" || that.field.labelhorizontaloption.toLowerCase() === "justify"))
                    that.labelColumn.css("text-align", that.field.labelhorizontaloption.toLowerCase());
                else
                    that.labelColumn.css("text-align", "right");
                if (that.field.labelverticaloption && (that.field.labelverticaloption.toLowerCase() === "middle" || that.field.labelverticaloption.toLowerCase() === "bottom"))
                    that.labelColumn.css("vertical-align", that.field.labelverticaloption.toLowerCase());
                else
                    that.labelColumn.css("vertical-align", "top");
                let label = that.clControlFactory.getLabel(that.field.labels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
                $("#" + that.id + "_labeldiv").children().remove();
                $(label).appendTo($("#" + that.id + "_labeldiv"));
                if (callback)
                    callback();
            };
            let requestOptions = {
                labels: JSON.stringify(that.field.labels)
            };
            Utilities_1.synUtil.getAJAXData({
                method: "POST",
                requestData: requestOptions,
                url: Utilities_1.synUtil.getWSUrl("ChecklistResolveMarkdown"),
                done(labels) {
                    that.field.labels = labels;
                    resolveMarkdownCallback();
                }
            });
        }
    }
    removeMultivalueInput(control) {
        let that = this;
        let pos = -1;
        for (let i = 0; i < that.multiValues.allControls.length; ++i) {
            if (that.multiValues.allControls[i] === control)
                pos = i;
        }
        if (pos !== -1)
            that.multiValues.allControls.splice(pos, 1);
        if (control.container)
            control.container.remove();
    }
    destroy() {
        if ($("#" + this.id).data("kendoToolTip"))
            $("#" + this.id).data("kendoToolTip").destroy();
    }
    updateValue(updatedField, valueOnly, updateDataPresentedInfo = true) {
        this.updateValueInternal(updatedField, valueOnly);
    }
    updateValueInternal(updatedField, valueOnly) {
        let that = this;
        if (valueOnly)
            that.setFieldValue();
        else {
            that.multiValues.allControls.splice(0);
            that.field = updatedField;
            that.divItem.remove();
            that.init(that.initJQueryElem);
        }
    }
    enable(enable) {
        super.enable(enable);
        if (this.multiValues.allControls) {
            $.each(this.multiValues.allControls, (idx, mvControl) => {
                mvControl.enableControlButton(enable);
            });
        }
    }
    setValue(value) {
        "Method not implemented.";
    }
    setFieldValue() {
        this.setValue(this.field.value);
    }
    parentFieldControlHasChanged(notifyLinkedFields, currentControlHasChanged) {
        let that = this;
        // Check parent if valid
        if (this.ParentField && this.field.dependentfield) {
            this.enable(!this.IsReadOnly());
            // Check valid entries
            let parentIsValid = that.parentIsValid();
            let valuesAreValid = parentIsValid;
            that.invalidIds.splice(0, that.invalidIds.length);
            let idPidMap = that.getIdPidMap();
            if (idPidMap && idPidMap.length > 0) {
                let parentValues = that.clControlFactory.getAsArray(that.ParentField.field.value);
                $.each(idPidMap, (idx, idPidEntry) => {
                    let tmpId = idPidEntry["id"];
                    let pids = idPidEntry["pids"];
                    let valueFound = false;
                    let tmpInvalidIdList = [];
                    $.each(pids, (idx2, tmpPid) => {
                        if ((tmpPid && parentValues.indexOf(tmpPid) === -1) || !parentIsValid) {
                            valuesAreValid = false;
                            if (that.invalidIds.indexOf(tmpId) === -1 && tmpInvalidIdList.indexOf(tmpId) === -1)
                                tmpInvalidIdList.push(tmpId);
                        }
                        else
                            valueFound = true;
                    });
                    if (valueFound) {
                        valuesAreValid = true;
                    }
                    else {
                        $.each(tmpInvalidIdList, (idx, invalidId) => {
                            that.invalidIds.push(invalidId);
                        });
                    }
                });
            }
            this.valid = valuesAreValid;
            this.updateDataSource(currentControlHasChanged);
        }
        if (notifyLinkedFields) {
            if (this.field["linkedfield"]) {
                let linkedFields = this.clControlFactory.GetLinkedFields(this.field["linkedfield"]);
                $.each(linkedFields, (idx, linkedField) => {
                    if (linkedField["id"] !== this.field["id"]) {
                        let control = this.clControlFactory.getFieldControl(linkedField["id"]);
                        if (control instanceof ClFieldControl) {
                            control.parentFieldControlHasChanged(false, false);
                        }
                    }
                });
            }
        }
        if (that.ChildFields && that.ChildFields.length > 0) {
            $.each(that.ChildFields, (idx, childControl) => {
                childControl.parentFieldControlHasChanged(true, false);
            });
        }
    }
    getIdPidMap() {
        return [];
    }
    hasValue() {
        if (this.field.value == undefined || this.field.value === [] || this.field.value == undefined || this.field.value === "")
            return false;
        else
            return true;
    }
    IsReadOnly() {
        let dependentReadOnly = false;
        if (this.ParentField && this.field.dependentfield) {
            if (!this.ParentField.hasValue() && !this.hasValue())
                dependentReadOnly = true;
        }
        return this.clControlFactory.ReadOnly || this.field.readonly || dependentReadOnly;
    }
    IsValid() {
        return this.valid;
    }
    updateEntryState(datapresentedInfo, valid = false) {
        "Method not implemented.";
    }
    updateDataSource(currentControlHasChanged) {
        "Method not implemented.";
    }
    resetRelation() {
        this.ParentField = undefined;
        this.ChildFields = [];
        this.valid = true;
        this.invalidIds = [];
    }
    removeNotNeededDataPresentedInfo() {
        let that = this;
        let values = that.clControlFactory.getAsArray(that.field.value);
        if (that.field.datapresentedinfo) {
            let correctDataPresentedInfo = {};
            $.each(that.field.datapresentedinfo, (id, info) => {
                if (values.indexOf(id) !== -1 || that.keepIds.indexOf(id) !== -1)
                    correctDataPresentedInfo[id] = info;
            });
            that.field.datapresentedinfo = correctDataPresentedInfo;
        }
    }
    parentIsValid() {
        if (this.ParentField)
            return this.ParentField.IsValid() && this.clControlFactory.getAsArray(this.ParentField.field.value).length > 0;
        return true;
    }
    updateUsability() {
        this.enable(!this.IsReadOnly());
    }
}
exports.ClFieldControl = ClFieldControl;
class ClMVableControl extends ClFieldControl {
    constructor(prependId, field, checklistControlFactory, levelcount, currentMV) {
        super(prependId, field, checklistControlFactory, levelcount);
        this.currentMV = currentMV;
        if (currentMV != undefined)
            this.isMultiValueControl = true;
    }
    init(jQueryElem) {
        let that = this;
        if (this.isMultiValueControl)
            that.container = $("<div id='" + that.id + "_fieldcontainer' class='fieldcontainer mvfieldcontainer'/>").appendTo(jQueryElem);
        else {
            super.init(jQueryElem);
            that.multivalueContainer = $("<div id='" + that.id + "_mvfieldcontainer' class='mvfieldcontainer' style='box-sizing:border-box;'/>").appendTo(that.controljQueryElem);
            that.container = $("<div id='" + that.id + "_fieldcontainer' class='fieldcontainer' />").appendTo(that.controljQueryElem);
        }
        that.controlContainer = $("<div id='" + that.id + "_controlcontainer' class='checklistmvcontrol' style='box-sizing:border-box;'/>").appendTo(that.container);
        that.telephoneButtonContainer = $("<div id='" + that.id + "_telephonebuttoncontainer' style='box-sizing:border-box;display:table-cell;width:1.5em;vertical-align: middle;text-align:center'/>").appendTo(that.container);
        that.telephoneButton = $("<i id='" + that.id + "_telephone' class='clbuttoncontainer fa fa-phone' aria-hidden='true' style='box-sizing:border-box;'></i>").appendTo(that.telephoneButtonContainer);
        that.telephoneButtonContainer.hide();
        let buttonContainer = $("<div id='" + that.id + "_buttoncontainer' style='box-sizing:border-box;display:table-cell;width:1.5em;vertical-align: middle;text-align:center'/>").appendTo(that.container);
        that.infoButton = $("<i id='" + that.id + "_warning' class='clbuttoncontainer fa fa-exclamation-triangle' aria-hidden='true' style='box-sizing:border-box;'></i>").appendTo(buttonContainer);
        that.infoButton.hide();
        if (that.field.multivalue) {
            that.controlButton = $("<i id='" + that.id + "_button' class='clbuttoncontainer fa' aria-hidden='true' style='box-sizing:border-box;'></i>").appendTo(buttonContainer);
            if (that.isMultiValueControl)
                that.controlButton.addClass("fa-times");
            else {
                that.controlButton.addClass("fa-plus");
                that.controlButton.hide();
            }
            if (that.IsReadOnly())
                that.controlButton.hide();
        }
    }
    enableControlButton(enable) {
        if (this.controlButton) {
            if (enable)
                this.controlButton.show();
            else
                this.controlButton.hide();
        }
    }
    setButtonVisibility(value) {
        let that = this;
        let entryAlreadExist = false;
        if (value) {
            for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                if (value === that.multiValues.allControls[i].getValue())
                    entryAlreadExist = true;
            }
            if (!entryAlreadExist && !that.clControlFactory.ReadOnly)
                that.controlButton.show();
            else
                that.controlButton.hide();
        }
        else
            that.controlButton.hide();
    }
    enable(enable) {
        super.enable(enable);
        if (!this.isMultiValueControl && this.controlButton) {
            if (enable) {
                let value = this.getCurrentValue();
                let val = this.getValue();
                if (value)
                    this.setButtonVisibility(value);
                else
                    this.controlButton.hide();
            }
            else
                this.controlButton.hide();
        }
    }
    notifyChange() {
        super.notifyChange();
        this.setMVContainerVisibilty();
    }
    setVisibility(visible, show) {
        super.setVisibility(visible, show);
        this.setMVContainerVisibilty();
    }
    setMVContainerVisibilty() {
        if (this.isMultiValueControl) {
            if (this.container.children().length > 0)
                this.container.css("display", "block");
            else
                this.container.css("display", "none");
        }
        else {
            if (this.multivalueContainer.children().length > 0)
                this.multivalueContainer.css("display", "block");
            else
                this.multivalueContainer.css("display", "none");
        }
    }
    addMultiValue(value) {
        "Method not implemented.";
    }
    setMultiValue(value) {
        let that = this;
        $.each(that.multiValues.allControls, (idx, controlToDelete) => {
            controlToDelete.container.remove();
        });
        that.multiValues.allControls.splice(0);
        that.addMultiValue(value);
    }
    setFieldValue() {
        if (this.field.multivalue) {
            this.setValue("");
            // if(this.controlButton)
            //     this.controlButton.hide();
            this.setButtonVisibility(undefined);
            this.setMultiValue(this.field.value);
            this.setMVContainerVisibilty();
        }
        else
            this.setValue(this.field.value);
    }
}
class ClAttachmentControl {
    constructor(clControlFactory, attachmentInfo, parentControl, readonly) {
        this.ClControlFactory = clControlFactory;
        this.ParentControl = parentControl;
        this.AttachmentInfo = attachmentInfo;
        this.Readonly = readonly;
    }
    isReadOnly() {
        return this.Readonly;
    }
    removeContainer() {
        this.Container.remove();
    }
}
exports.ClAttachmentControl = ClAttachmentControl;
class ClImageControl extends ClAttachmentControl {
    constructor(checklistControlFactory, attachmentInfo, parentControl, readonly, id, imageid, fieldId, columncount) {
        super(checklistControlFactory, attachmentInfo, parentControl, readonly);
        this.imageId = imageid;
        this.id = id;
        this.fieldId = fieldId;
        this.columncount = columncount;
    }
    init(jQueryElem) {
        let that = this;
        that.Container = $("<li id='" + that.id + "' class='checklistimagecontainer attachmentdragable' style='text-align:right;margin:1px;border: solid 1px black;background-color:white;line-height:1em'/>").appendTo(jQueryElem);
        that.Container.attr("cl_attachmentid", that.imageId);
        if (that.columncount === 0)
            that.Container.css({ "width": "calc(100% - 2px)" });
        else
            that.Container.css({ "width": "calc(100% / " + that.columncount + " - 2px)" });
        if (!that.isReadOnly()) {
            let delButton = $("<i class='fa fa-times' aria-hidden='true'/>").appendTo(that.Container);
            delButton.addClass("overlay");
            delButton.css("font-size", "1.5em");
            delButton.css("height", "1em");
            delButton.css("background-color", "rgba(255,255,255,0.5)");
            delButton.css("z-index", "11001");
            delButton.css("line-height", "1em");
            delButton.on("click", () => {
                that.removeImage();
                that.ParentControl.removeAttachment(that);
            });
        }
        let src;
        let containerId = this.ClControlFactory.getContainerId(this.imageId, this.fieldId);
        let fileId = this.ClControlFactory.getFileId(this.imageId, this.fieldId);
        if (containerId && fileId) {
            src = "WSProxy.axd?cache=FileCache/" + containerId + "/" + fileId + "/";
        }
        let imageControlId = "lightbox_" + Utilities_1.synUtil.getGUID(true);
        if (that.ClControlFactory.isAllowedImageType(that.AttachmentInfo.MimeType)) {
            // let imgControl = $("<a class='cl_lightbox' href='" + src + "' data-lightbox='" + this.fieldId + "' />").appendTo(inputControl);
            // let img = $("<img  id = '" + imageControlId + "'class='climageview cl_lightbox' >").appendTo(imgControl);
            let linkControl = $("<a class='cl_lightbox' style='display:flex; line-height: 1em;' href='" + src + "' data-lightbox='" + this.fieldId + "' />").appendTo(that.Container);
            let imgControl = $("<div id = '" + imageControlId + "'class= 'climageview cl_lightbox' />").appendTo(linkControl);
            imgControl.on("click", function () {
                imgControl.trigger("lightbox_clicked");
            });
            imgControl.css({ "background-image": "url('" + src + "')" });
            if (!that.isReadOnly())
                linkControl.css("margin-top", "-1.5em");
        }
        else {
            let img = $("<div class='cl_imagediv attachmentitem' style='' ></div>").appendTo(that.Container);
            let div = $("<div class='attachmentitem' style='position: absolute; left: 2px; right: 2px; top: 2px; bottom: 2px;'></div>").appendTo(img);
            let div2 = $("<div class='attachmentitem' style='display: table; height: 100%; width: 100%;'></div>").appendTo(div);
            let lab = $("<label class='attachmentitem' style='display: table-cell; text-align: center; vertical-align: middle;'/>").appendTo(div2);
            lab.text("Preview not available");
        }
    }
    removeImage() {
        this.ClControlFactory.removeImageFromField(this.fieldId, this.imageId);
        this.Container.remove();
    }
    getInputControl() {
        return this.Container;
    }
    resizeControl(colcount) {
        this.columncount = colcount;
        if (colcount === 0)
            this.Container.css({ "width": "calc(100% - 2px)" });
        else
            this.Container.css({ "width": "calc(100% / " + colcount + " - 2px)" });
    }
}
exports.ClImageControl = ClImageControl;
class ClStaticImageControl extends ClAttachmentControl {
    constructor(clControlFactory, attachmentInfo, parentControl, readonly, id, imageid, fieldId, maxwidth, horizontaloption) {
        super(clControlFactory, attachmentInfo, parentControl, readonly);
        this.imageId = imageid;
        this.id = id;
        this.fieldId = fieldId;
        this.maxwidth = maxwidth;
        this.horizontaloption = horizontaloption;
    }
    init(jQueryElem) {
        let that = this;
        let delButton;
        that.Container = $("<div id='" + that.id + "' class='checkliststaticimagecontainer' style='display: inline-block;padding:1px;'/>").appendTo(jQueryElem);
        that.Container.css("max-width", that.maxwidth + "%");
        if ((that.ClControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer) {
            // let delButtonContaianer = $("<div></div>").appendTo(inputControl);
            delButton = $("<i class='overlay fa fa-times' aria-hidden='true' />").appendTo(that.Container);
            delButton.css("font-size", "1.5em");
            delButton.css("width", "1em");
            delButton.css("height", "1em");
            delButton.css("background-color", "rgba(255,255,255,0.5)");
            delButton.css("text-align", "center");
            delButton.css("float", "right");
            delButton.on("click", () => {
                that.removeImage();
                that.ParentControl.removeAttachment(that);
            });
        }
        let src;
        let containerId = this.ClControlFactory.getContainerId(this.imageId, this.fieldId);
        let fileId = this.ClControlFactory.getFileId(this.imageId, this.fieldId);
        if (containerId && fileId) {
            src = "WSProxy.axd?cache=FileCache/" + containerId + "/" + fileId + "/";
        }
        let imageControlId = "lightbox_" + Utilities_1.synUtil.getGUID(true);
        let mediaControl;
        if (that.Readonly)
            mediaControl = $("<img id='" + imageControlId + "' src='" + src + "' class='cl_lightbox' style='width:100%'/>").appendTo(that.Container);
        else {
            let link = $("<a class='cl_lightbox' href='" + src + "' data-lightbox='" + this.fieldId + "' style='display:block' />").appendTo(that.Container);
            mediaControl = $("<img id='" + imageControlId + "' src='" + src + "' class='cl_lightbox' style='width:100%'/>").appendTo(link);
            mediaControl.on("click", function () {
                mediaControl.trigger("lightbox_clicked");
            });
        }
        if ((that.ClControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer) {
            mediaControl.css("margin-top", "-1.5em");
        }
    }
    removeImage() {
        this.ClControlFactory.removeImageFromField(this.fieldId, this.imageId);
        this.Container.remove();
        // this.parentControl.notifyChange();
    }
    getInputControl() {
        return this.Container;
    }
    resizeControl(maxWidth) {
        this.Container.css({ "max-width": maxWidth + "%" });
    }
}
exports.ClStaticImageControl = ClStaticImageControl;
class AttachmentInfo {
    constructor(fileInfo) {
        if (fileInfo) {
            this.FileName = fileInfo.filename;
            this.FileExt = fileInfo.fileext;
            this.FileSize = fileInfo.filesize;
            this.MimeType = fileInfo.mimetype;
            this.ContainerId = fileInfo.containerid;
            this.FileId = fileInfo.fileid;
            this.PrettyFileSize = fileInfo.prettyfilesize;
        }
    }
}
exports.AttachmentInfo = AttachmentInfo;
class ClMediaControl extends ClAttachmentControl {
    constructor(clControlFactory, attachmentInfo, parentControl, readonly, fieldId, attachmentId) {
        super(clControlFactory, attachmentInfo, parentControl, readonly);
        this.attachmentId = attachmentId;
        this.fieldId = fieldId;
    }
    init(jQueryElem) {
        let that = this;
        that.Container = $("<li class='attachmentitem attachmentdragable' style='padding:5px;'> </li>").appendTo(jQueryElem);
        that.Container.attr("cl_attachmentid", that.attachmentId);
        let fileIcon = "file.png";
        if (that.AttachmentInfo.MimeType === "application/octet-stream") {
            if (that.AttachmentInfo.FileExt.toLocaleLowerCase() === "msg")
                fileIcon = "file_outlook.png";
            else if (that.AttachmentInfo.FileExt.toLocaleLowerCase() === "vsdx")
                fileIcon = "file_visio.png";
        }
        else {
            if (that.AttachmentInfo.MimeType.startsWith("image")) {
                if (that.AttachmentInfo.MimeType === "image/vnd.dwg" || that.AttachmentInfo.MimeType === "image/vnd.dxf" || that.AttachmentInfo.MimeType === "image/x-dwg")
                    fileIcon = "file_dwg.png";
                else
                    fileIcon = "file_image.png";
            }
            else if (that.AttachmentInfo.MimeType.startsWith("video"))
                fileIcon = "file_video.png";
            else if (that.AttachmentInfo.MimeType.startsWith("audio"))
                fileIcon = "file_audio.png";
            else if (that.AttachmentInfo.MimeType.startsWith("text"))
                fileIcon = "file_text.png";
            else {
                switch (that.AttachmentInfo.MimeType) {
                    case "application/pdf":
                        fileIcon = "file_pdf.png";
                        break;
                    case "application/msword":
                    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                    case "application/vnd.openxmlformats-officedocument.wordprocessingml.template":
                    case "application/vnd.ms-word.document.macroEnabled.12":
                    case "application/vnd.ms-word.template.macroEnabled.12":
                        fileIcon = "file_word.png";
                        break;
                    case "application/msexcel":
                    case "application/vnd.ms-excel":
                    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    case "application/vnd.openxmlformats-officedocument.spreadsheetml.template":
                    case "application/vnd.ms-excel.sheet.macroEnabled.12":
                    case "application/vnd.ms-excel.template.macroEnabled.12":
                    case "application/vnd.ms-excel.addin.macroEnabled.12":
                    case "application/vnd.ms-excel.sheet.binary.macroEnabled.12":
                        fileIcon = "file_excel.png";
                        break;
                    case "application/mspowerpoint":
                    case "application/vnd.ms-powerpoint":
                    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                    case "application/vnd.openxmlformats-officedocument.presentationml.template":
                    case "application/vnd.openxmlformats-officedocument.presentationml.slideshow":
                    case "application/vnd.ms-powerpoint.addin.macroEnabled.12":
                    case "application/vnd.ms-powerpoint.presentation.macroEnabled.12":
                    case "application/vnd.ms-powerpoint.template.macroEnabled.12":
                    case "application/vnd.ms-powerpoint.slideshow.macroEnabled.12":
                        fileIcon = "file_powerpoint.png";
                        break;
                    case "application/zip":
                        fileIcon = "file_archive.png";
                        break;
                    case "application/vnd.visio":
                        fileIcon = "file_visio.png";
                        break;
                    case "application/vnd.ms-outlook":
                        fileIcon = "file_outlook.png";
                        break;
                    case "application/acad":
                        fileIcon = "file_dwg.png";
                        break;
                }
            }
        }
        let container = $("<div class='attachmentcontainer attachmentitem' style='display: table; width: 100%;'/>").appendTo(that.Container);
        let fileIconContainer = $("<div style='display: table-cell; width: 2.5em; text-align: start; vertical-align: middle;'/>").appendTo(container);
        $("<img alt src='assets/checklist/" + fileIcon + "' style='width:2em;height:2em;' />").appendTo(fileIconContainer);
        let labelcontainer = $("<div style='display: table-cell; vertical-align: middle;'/>").appendTo(container);
        let fileNamecontainer = $("<div  />").appendTo(labelcontainer);
        let fileSizecontainer = $("<div  />").appendTo(labelcontainer);
        let iconContainer = $("<div style='display: table-cell; width: 4.5em; text-align: end; vertical-align: middle;'/>").appendTo(container);
        let fileNameElem = $("<label class='attachmentitem' style='word-break: break-all; font-size:1em;'/>").appendTo(fileNamecontainer);
        let fileSizeElem = $("<label class='attachmentitem' style='word-break: break-all; font-size:0.75em;'/>").appendTo(fileSizecontainer);
        let hyperlink = "WSProxy.axd?cache=FileCache/" + that.AttachmentInfo.ContainerId + "/" + that.AttachmentInfo.FileId + "/";
        let link = $("<a href='" + hyperlink + "' download style='font-size:1.5em;margin-left:0.5em; vertical-align: middle;'><i class='attachmenticon fa fa-download' aria-hidden='true' style='color:black;'></a>").appendTo(iconContainer);
        fileNameElem.text(that.AttachmentInfo.FileName + "." + that.AttachmentInfo.FileExt);
        fileSizeElem.text(that.AttachmentInfo.PrettyFileSize);
        if (!that.isReadOnly()) {
            let delbutton = $("<i class='attachmenticon fa fa-times' aria-hidden='true' style='color:red;font-size:1.5em;margin-left:0.5em;'>").appendTo(iconContainer);
            delbutton.on("click", function () {
                that.ClControlFactory.removeImageFromField(that.fieldId, that.attachmentId);
                that.Container.remove();
                that.ParentControl.removeAttachment(that);
            });
        }
    }
}
exports.ClMediaControl = ClMediaControl;
class ClImageViewControl extends ClFieldControl {
    constructor(prependId, field, checklistControlFactory, levelcount, containerid) {
        super(prependId, field, checklistControlFactory, levelcount);
        this.imageIds = [];
        this.Attachments = [];
        field.attachments.sort((a, b) => { return a.Order - b.Order; });
        $.each(field.attachments, (idx, value) => {
            this.imageIds.push(field.attachments[idx].Id);
        });
        if (field.labelhorizontaloption)
            this.horizontaloption = field.labelhorizontaloption;
        if (field.layoutposition)
            this.layoutposition = field.layoutposition.toLowerCase();
    }
    init(jQueryElem) {
        let that = this;
        that.container = undefined;
        if (that.field.datatype === "EmbeddedImage") {
            super.init(jQueryElem);
            that.container = that.controljQueryElem;
            that.addAttachmentButton = $("<div class='claddattachmentbutton' style='background-color:#d9d9d9;height: 3.5em; width: 3.5em; ' />").appendTo(that.container);
            that.addAttachmentInnerButton = $("<div class='claddattachmentbutton claddattachmentinnerbutton' style='background-color:white; height: 3em; width: 3em; padding: 9px;' />").appendTo(that.addAttachmentButton);
            $("<i class='clbuttoncontainer fa fa-plus' style='background-color: transparent !important; display: flex; align-items: center; justify-content: center;'/>").appendTo(that.addAttachmentInnerButton);
            that.setContextMenu();
        }
        else {
            if (that.field.layoutposition && that.field.layoutposition.toLowerCase() !== "all") {
                super.init(jQueryElem);
                if (that.field.layoutposition && that.field.layoutposition.toLowerCase() === "label")
                    that.container = that.labelColumn;
                else
                    that.container = that.inputColumn;
            }
            else {
                that.divContainer = $("<div id='" + that.id + "_item' class='checklistrow'/>").appendTo(jQueryElem);
                that.divItem = $("<div id='" + that.id + "_inputitem' class='checklistinputrow'/>").appendTo(that.divContainer);
                if ((that.clControlFactory.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
                    if (that.clControlFactory.rowSpacing > 0) {
                        that.divItem.css("padding-top", (that.clControlFactory.rowSpacing / 2).toString() + "px");
                        that.divItem.css("padding-bottom", (that.clControlFactory.rowSpacing / 2).toString() + "px");
                    }
                    else {
                        that.divItem.css("padding-top", "0px");
                        that.divItem.css("padding-bottom", "0px");
                    }
                    if (this.clControlFactory.instance.fontsize)
                        this.divItem.css("font-size", this.clControlFactory.instance.fontsize.toString() + "px");
                }
                that.container = that.divItem;
            }
        }
        that.isStatic = that.field.datatype === "StaticImage";
        if (that.isStatic && (that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer) {
            that.templateLabel = $("<label id='" + that.id + "_templatelabel' >" + Utilities_1.synUtil.Strings.getValue("clstaticimageplaceholder") + "</label>").appendTo(that.container);
            that.templateLabel.hide();
        }
        that.inputControl = $("<div id='" + that.id + "' />").appendTo(that.container);
        that.sortContainer = $("<ul class='attachmentsortable'></ul>").appendTo(that.inputControl);
        if (!that.isStatic && that.field.imageonly)
            that.sortContainer.css("display", "flex");
        that.sortContainer.kendoSortable({
            autoScroll: true,
            ignore: "li",
            filter: ".attachmentdragable",
            hint(element) {
                let clonedElem = element.clone();
                // clonedElem.css("font-size","30px");
                clonedElem.css("width", element[0].scrollWidth);
                clonedElem.css("height", element[0].scrollHeight);
                clonedElem.addClass("hint");
                return clonedElem;
            },
            placeholder(element) {
                let clonedElem = element.clone().addClass("attachmentplaceholder");
                return clonedElem;
            },
            end: (e) => {
                if (e.item && e.item.length === 1) {
                    let selAttId = e.item[0].getAttribute("cl_attachmentid");
                    let children = that.sortContainer.children();
                    let order = 0;
                    $.each(children, (idx, child) => {
                        let attachmentId = child.getAttribute("cl_attachmentid");
                        if (attachmentId !== selAttId || $(child).hasClass("attachmentplaceholder")) {
                            that.clControlFactory.updateAttachmentOrder(that.field.id, attachmentId, order);
                            ++order;
                        }
                    });
                }
            }
        });
        if (that.imageIds.length === 0) {
            if (that.isStatic && (that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer) {
                that.templateLabel.show();
            }
        }
        else {
            for (let idx = 0; idx < that.imageIds.length; ++idx) {
                let containerId = this.clControlFactory.getContainerId(that.imageIds[idx], this.id);
                let fileId = this.clControlFactory.getFileId(that.imageIds[idx], this.id);
                if (containerId && fileId) {
                    let clImage;
                    let attachmentInfo;
                    if (that.isStatic) {
                        clImage = new ClStaticImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + that.imageIds[idx], that.imageIds[idx], that.id, that.field.maxwidth, that.horizontaloption);
                        clImage.init(that.inputControl);
                        that.Attachments.push(clImage);
                    }
                    else {
                        attachmentInfo = that.clControlFactory.GetAttachmentInfo(that.field.attachments[idx]);
                        if (that.field.imageonly) {
                            clImage = new ClImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + that.imageIds[idx], that.imageIds[idx], that.id, that.columncount);
                            clImage.init(that.sortContainer);
                            that.Attachments.push(clImage);
                        }
                        else {
                            let attItem = new ClMediaControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.field["id"], that.imageIds[idx]);
                            attItem.init(that.sortContainer);
                            that.Attachments.push(attItem);
                        }
                    }
                }
            }
        }
        if (that.isStatic) {
            if (that.horizontaloption && (that.horizontaloption.toLowerCase() === "center" || that.horizontaloption.toLowerCase() === "right" || that.horizontaloption.toLowerCase() === "justify"))
                that.inputControl.css("text-align", that.horizontaloption.toLowerCase());
            else
                that.inputControl.css("text-align", "left");
        }
        this.setVisibility(this.field.visible, this.field.show);
        if (!that.isStatic) {
            this.enable(!that.IsReadOnly());
            this.highlightMandatory();
            this.checkButtonVisibility();
        }
    }
    setContextMenu() {
        let that = this;
        that.addAttachmentButton.off("click");
        let oldContextMenu = that.container.find(".synContextMenu");
        if (oldContextMenu && oldContextMenu.length > 0) {
            $.each(oldContextMenu, (idx, oldMenu) => {
                oldMenu.data("kendoContextMenu").destroy();
                oldMenu.remove();
            });
        }
        let attachmentSourceCount = 0;
        let cameraItem;
        let cameraTerminalItem;
        let cameraTerminalFaceDetectionItem;
        let mediaItem;
        if ((that.field.attachmentsource & 1) === 1) {
            ++attachmentSourceCount;
            if (that.field.imageonly) {
                mediaItem = $("<li><i class='fa fa-picture-o k-image' style='font-size:1.5em' ></i>" + Utilities_1.synUtil.Strings.getValue("climageuploadlabelproperty") + "</li>");
                mediaItem.attr("attachmentAction", "image");
            }
            else {
                mediaItem = $("<li><i class='fa fa-paperclip k-image' style='font-size:1.5em' ></i>" + Utilities_1.synUtil.Strings.getValue("clattachmentuploadlabelproperty") + "</li>");
                mediaItem.attr("attachmentAction", "media");
            }
        }
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            if ((this.field.attachmentsource & 2) === 2) {
                ++attachmentSourceCount;
                cameraItem = $("<li> <i class='fa fa-camera k-image' style='font-size:1.5em' ></i>" + Utilities_1.synUtil.Strings.getValue("clattachmentsourcecameralabelproperty") + "</li>");
                cameraItem.attr("attachmentAction", "camera");
            }
            if ((this.field.attachmentsource & 4) === 4) {
                ++attachmentSourceCount;
                cameraTerminalItem = $("<li> <i class='fa fa-camera k-image' style='font-size:1.5em' ></i>" + Utilities_1.synUtil.Strings.getValue("clattachmentsourcecameraterminalmodelabelproperty") + "</li>");
                cameraTerminalItem.attr("attachmentAction", "cameraterminal");
            }
            if ((this.field.attachmentsource & 8) === 8) {
                ++attachmentSourceCount;
                cameraTerminalFaceDetectionItem = $("<li> <i class='fa fa-camera k-image' style='font-size:1.5em' ></i>" + Utilities_1.synUtil.Strings.getValue("clattachmentsourcecameraterminalmodefacedetectionlabelproperty") + "</li>");
                cameraTerminalFaceDetectionItem.attr("attachmentAction", "cameraterminalfacedetection");
            }
        }
        if (attachmentSourceCount > 0) {
            if (attachmentSourceCount > 1) {
                that.contextMenu = $("<ul class='synContextMenu clContextMenu'> </ul> ").appendTo(that.container);
                if (cameraItem)
                    cameraItem.appendTo(that.contextMenu);
                if (cameraTerminalItem)
                    cameraTerminalItem.appendTo(that.contextMenu);
                if (cameraTerminalFaceDetectionItem)
                    cameraTerminalFaceDetectionItem.appendTo(that.contextMenu);
                if (mediaItem)
                    mediaItem.appendTo(that.contextMenu);
                that.contextMenu.kendoContextMenu({
                    target: that.addAttachmentButton,
                    select(e) {
                        let attachmentAction = e.item.getAttribute("attachmentAction");
                        if (attachmentAction) {
                            switch (attachmentAction) {
                                case "camera":
                                    that.showWebCam(that.inputControl, false, false);
                                    break;
                                case "cameraterminal":
                                    that.showWebCam(that.inputControl, true, false);
                                    break;
                                case "cameraterminalfacedetection":
                                    that.showWebCam(that.inputControl, true, true);
                                    break;
                                case "media":
                                    that.onAttachmentClicked(Utilities_1.synUtil.Strings.getValue("clattachmentuploadlabelproperty"));
                                    break;
                                case "image":
                                    that.onAttachmentClicked(Utilities_1.synUtil.Strings.getValue("climageuploadlabelproperty"));
                                    break;
                            }
                        }
                    },
                    showOn: "click",
                });
            }
            else {
                that.addAttachmentButton.on("click", () => {
                    if ((that.field.attachmentsource & 1) === 1) {
                        if (that.field.imageonly)
                            that.onAttachmentClicked(Utilities_1.synUtil.Strings.getValue("climageuploadlabelproperty"));
                        else
                            that.onAttachmentClicked(Utilities_1.synUtil.Strings.getValue("clattachmentuploadlabelproperty"));
                    }
                    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                        if ((this.field.attachmentsource & 2) === 2) {
                            that.showWebCam(that.inputControl, false, false);
                        }
                        if ((this.field.attachmentsource & 4) === 4) {
                            that.showWebCam(that.inputControl, true, false);
                        }
                        if ((this.field.attachmentsource & 8) === 8) {
                            that.showWebCam(that.inputControl, true, true);
                        }
                    }
                });
            }
        }
    }
    onAttachmentClicked(action) {
        let that = this;
        // get max number of allowed files
        let maxNumOfAllowedAttachments = 1;
        if (that.field.max)
            maxNumOfAllowedAttachments = that.field.max - that.Attachments.length;
        if (maxNumOfAllowedAttachments < 1)
            maxNumOfAllowedAttachments = 0;
        let windowData = Utilities_1.synUtil.uploadWindow({
            multiUpload: !(maxNumOfAllowedAttachments === 1),
            action,
            maxfiles: maxNumOfAllowedAttachments,
            onAction(guids) {
                $.each(guids, (idx, value) => {
                    Utilities_1.synUtil.getAJAXData({
                        url: Utilities_1.synUtil.getWSUrl("ChecklistCheckAttachment"),
                        method: "POST",
                        requestData: { filecacheGuid: value, jpegquality: that.clControlFactory.instance["jpegquality"], isstaticimage: false, imageonly: that.field["imageonly"] },
                        done(fileInfo) {
                            let attachmentInfo = new AttachmentInfo(fileInfo);
                            let imageGuid = Utilities_1.synUtil.getGUID(true);
                            that.clControlFactory.addImageToField(that.id, imageGuid, fileInfo);
                            if (that.field.imageonly) {
                                let clImage = new ClImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + imageGuid, imageGuid, that.id, that.columncount);
                                clImage.init(that.sortContainer);
                                that.Attachments.push(clImage);
                            }
                            else {
                                let attItem = new ClMediaControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id, imageGuid);
                                attItem.init(that.sortContainer);
                                that.Attachments.push(attItem);
                            }
                            if (idx === guids.length - 1)
                                $("#" + windowData.windowID).data("kendoWindow").close();
                            if ((that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
                                $("#cl_preview_layout").focus();
                            that.notifyChange();
                            $(that).trigger("controlValueChanged");
                        },
                        fail(jqXHR, textStatus, errorThrown, url) {
                            Utilities_1.synUtil.Notifications.error(jqXHR.responseJSON.ErrorDisplayMessage);
                        },
                        cleanUp() {
                            if (idx === guids.length - 1)
                                Utilities_1.synUtil.endAjaxProgress("#" + windowData.buttonID);
                        }
                    });
                });
            }
        });
    }
    showWebCam(inputControl, terminalMode, faceDetection) {
        let that = this;
        let interval;
        Utilities_1.synUtil.beginAjaxProgress();
        let options = {
            title: Utilities_1.synUtil.Strings.getValue("clattachmentsourcecameralabelproperty"),
            actions: [],
            width: undefined,
            height: undefined,
            resizable: true,
            modal: true,
            synDesktopAware: true,
        };
        let faceDetectionCounter = that.clControlFactory.getFaceDetectionRetryCount() + 1;
        if (!terminalMode || faceDetection)
            options.actions = ["Close"];
        let windowData = Utilities_1.synUtil.popupWindow(options);
        let windowId = "popup_" + windowData.guid;
        let text = Utilities_1.synUtil.Strings.getValue("clwebcamtextproperty", undefined);
        if (text) {
            let labelControl = $("<label style='margin-bottom: 0.58em; display:block;' >" + text + "</label>").appendTo(windowData.contentDiv);
            labelControl.text(text);
        }
        windowData.contentDiv.css("text-align", "center");
        that.videoContainer = $("<div id='" + that.id + "_videocontainer' class='videocontainer'/>").appendTo(windowData.contentDiv);
        that.videoControl = $("<video id='" + that.id + "_stream'/>").appendTo(that.videoContainer);
        let canvasControl = $("<canvas id='" + that.id + "_canvas' style='display:none;' />").appendTo(that.videoContainer);
        let buttonPane = $("<div class='buttonPane' style='padding-top: 5px; padding-bottom: 5px; float: right; '>").appendTo(windowData.contentDiv);
        let captureButton = $("<button id='listname_dlg_ok_button' type='button' class='btn btn-primary' readonly  style='display:inline-block'>" + Utilities_1.synUtil.Strings.getValue("clcapturebuttonproperty") + "</button>").appendTo(buttonPane);
        let cancelButton = $("<button id='listname_dlg_cancel_button' type='button' class='btn'  style='display:inline-block'>" + Utilities_1.synUtil.Strings.getValue("cldiscardbuttonproperty") + "</button>").appendTo(buttonPane);
        let okButton = $("<button id='listname_dlg_ok_button' type='button' class='btn btn-primary' disabled readonly style='display:inline-block'>" + Utilities_1.synUtil.Strings.getValue("clokbuttonproperty") + "</button>").appendTo(buttonPane);
        let discardButton = $("<button id='listname_dlg_cancel_button' type='button' class='btn' disabled readonly style='display:inline-block'>" + Utilities_1.synUtil.Strings.getValue("clretrybuttonproperty") + "</button>").appendTo(buttonPane);
        let overlaycontainer = $("<div style='position: absolute; top: 0px;  padding: 2.3em; box-sizing: border-box;  color: rgb(195, 195, 195); text-align:left'/>").appendTo(that.videoContainer);
        let overlay = $("<label disabled style='font-size: 100px; font-weight: bold;'/>").appendTo(overlaycontainer);
        overlay.hide();
        that.videoControl.attr("playsinline", "true");
        windowData.contentDiv.css("box-sizing", "border-box");
        if (terminalMode) {
            captureButton.css("display", "none");
            cancelButton.css("display", "none");
            if (faceDetection) {
                okButton.css("display", "none");
                discardButton.css("display", "none");
            }
        }
        else {
            okButton.css("display", "none");
            discardButton.css("display", "none");
        }
        let captureInterval = function () {
            let countdown = 5;
            interval = setInterval(function () {
                if (countdown === 0) {
                    clearInterval(interval);
                    overlay.hide();
                    if (faceDetection && faceDetectionCounter > 0)
                        faceDetectionCounter = faceDetectionCounter - 1;
                    captureImage();
                }
                else {
                    overlay.show();
                    overlay.text(countdown.toString());
                    --countdown;
                }
            }, 1000);
        };
        let captureImage = function () {
            Utilities_1.synUtil.beginAjaxProgress();
            let canvas = document.getElementById(that.id + "_canvas");
            let video = document.querySelector("video");
            let context = canvas.getContext("2d");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            that.videoControl.css("display", "none");
            canvasControl.css("display", "block");
            captureButton.css("display", "none");
            cancelButton.css("display", "none");
            if (faceDetection) {
                let elem = $("#" + windowId)[0];
                let style = window.getComputedStyle(elem);
                let _Width = $("#" + windowId)[0].scrollWidth + parseFloat(style.marginRight) + parseFloat(style.paddingRight);
                let _Height = $("#" + windowId)[0].scrollHeight + parseFloat(style.marginBottom) + parseFloat(style.paddingBottom);
                $("#" + windowId).data("kendoWindow").setOptions({ width: _Width, height: _Height });
                $("#" + windowId).data("kendoWindow").resize(true);
                $("#" + windowId).data("kendoWindow").center();
            }
            else {
                okButton.css("display", "inline-block");
                discardButton.css("display", "inline-block");
                okButton.removeAttr("disabled");
                discardButton.removeAttr("disabled");
            }
            let formData = new FormData();
            let dataUrl = canvas.toDataURL("image/jpeg");
            let newblob = that.dataURItoBlob(dataUrl);
            let tmpGuid = Utilities_1.synUtil.getGUID(true) + ".jpg";
            formData.append("files", newblob, tmpGuid);
            Utilities_1.synUtil.getAJAXData({
                url: Utilities_1.synUtil.getWSUrl("ContentUpload"),
                requestData: formData,
                method: "POST",
                contentType: false,
                processData: false,
                done(data) {
                    if (data) {
                        that.fileCacheGuid = data[tmpGuid];
                        if (faceDetection) {
                            let faceTracker = new tracking.ObjectTracker("face");
                            faceTracker.setInitialScale(4);
                            faceTracker.setStepSize(2);
                            faceTracker.setEdgesDensity(0.1);
                            faceTracker.once("track", (e) => {
                                if (e.data.length === 0 && faceDetectionCounter > 0)
                                    discardImage();
                                else
                                    useImage();
                            });
                            tracking.track(canvas, faceTracker);
                        }
                    }
                },
                fail(data) {
                    "Method not implemented.";
                },
                cleanUp() {
                    Utilities_1.synUtil.endAjaxProgress();
                }
            });
        };
        let constraints = { audio: false };
        if (terminalMode && that.field["aspectratio"]) {
            let strAspectRatio = that.field["aspectratio"];
            let idx = strAspectRatio.indexOf(":");
            let strAspectWidth = strAspectRatio.substring(0, idx);
            let strAspectHeight = strAspectRatio.substring(idx + 1);
            let aspectWidth = Number(strAspectWidth);
            let aspectHeight = Number(strAspectHeight);
            let aspectratio = aspectWidth / aspectHeight;
            constraints["video"] = { aspectRatio: aspectratio };
        }
        else
            constraints["video"] = true;
        let constr = { video: { aspectRatio: 7 / 9 }, audio: false };
        navigator.mediaDevices.getUserMedia(constraints).then((localMediaStream) => {
            that.mediaStream = localMediaStream;
            let video = document.querySelector("video");
            video.srcObject = localMediaStream;
            video.onloadedmetadata = function (e) {
                video.play();
                let canvas = document.getElementById(that.id + "_canvas");
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                $("#" + windowId).css("box-sizing", "border-box");
                let elem = $("#" + windowId)[0];
                let style = window.getComputedStyle(elem);
                that.videoContainer.css("width", video.videoWidth.toString() + "px");
                that.videoContainer.css("height", video.videoHeight.toString() + "px");
                if (Utilities_1.synUtil.clientDeviceClass === "desktop") {
                    let _Width = $("#" + windowId)[0].scrollWidth + parseFloat(style.marginRight) + parseFloat(style.paddingRight);
                    let _Height = $("#" + windowId)[0].scrollHeight + parseFloat(style.marginBottom) + parseFloat(style.paddingBottom);
                    $("#" + windowId).data("kendoWindow").setOptions({ width: _Width, height: _Height });
                    $("#" + windowId).data("kendoWindow").resize(true);
                    $("#" + windowId).data("kendoWindow").center();
                }
                Utilities_1.synUtil.endAjaxProgress();
                if (terminalMode) {
                    captureInterval();
                }
            };
        }).catch((err) => {
            Utilities_1.synUtil.endAjaxProgress();
            Utilities_1.synUtil.Notifications.error(Utilities_1.synUtil.Strings.getValue("clwebcamnotavailablenotification"));
            $("#" + windowId).data("kendoWindow").close();
            if ((that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
                $("#cl_preview_layout").focus();
        });
        captureButton.on("click", () => {
            captureImage();
        });
        let discardImage = function () {
            // Delete cachedfile
            that.videoControl.css("display", "block");
            canvasControl.css("display", "none");
            Utilities_1.synUtil.getAJAXData({
                url: "WSProxy.axd?cache=FileCache/" + that.fileCacheGuid + "/" + that.fileCacheGuid,
                method: "DELETE",
                fail() {
                    "Method not implemented.";
                },
            });
            if (terminalMode) {
                okButton.attr("disabled", "disabled");
                discardButton.attr("disabled", "disabled");
                captureInterval();
            }
            else {
                okButton.css("display", "none");
                discardButton.css("display", "none");
                captureButton.css("display", "inline-block");
                cancelButton.css("display", "inline-block");
            }
        };
        discardButton.on("click", () => {
            discardImage();
        });
        let useImage = function () {
            Utilities_1.synUtil.beginAjaxProgress();
            let requestData = { filecacheGuid: that.fileCacheGuid, jpegquality: that.clControlFactory.instance["jpegquality"], isstaticimage: false, imageonly: that.field.imageonly };
            Utilities_1.synUtil.getAJAXData({
                url: Utilities_1.synUtil.getWSUrl("ChecklistCheckAttachment"),
                method: "POST",
                requestData,
                done(fileInfo) {
                    let imageGuid = Utilities_1.synUtil.getGUID(true);
                    that.clControlFactory.addImageToField(that.id, imageGuid, fileInfo);
                    let attachmentInfo = new AttachmentInfo(fileInfo);
                    if (that.field.imageonly) {
                        let clImage = new ClImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + imageGuid, imageGuid, that.id, that.columncount);
                        clImage.init(inputControl);
                        that.Attachments.push(clImage);
                    }
                    else {
                        let attItem = new ClMediaControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.field["id"], that.id);
                        attItem.init(that.sortContainer);
                        that.Attachments.push(attItem);
                    }
                    that.closeStream();
                    $("#" + windowId).data("kendoWindow").close();
                    if ((that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
                        $("#cl_preview_layout").focus();
                    that.notifyChange();
                    $(that).trigger("controlValueChanged");
                },
                fail(jqXHR, textStatus, errorThrown, url) {
                    Utilities_1.synUtil.Notifications.error(jqXHR.responseJSON.ErrorDisplayMessage);
                },
                cleanUp() {
                    Utilities_1.synUtil.endAjaxProgress();
                }
            });
        };
        okButton.on("click", () => {
            useImage();
        });
        $("#" + windowId).data("kendoWindow").bind("close", function (e) {
            if (faceDetection && faceDetectionCounter > 0)
                clearInterval(interval);
            that.closeStream();
        });
        cancelButton.on("click", () => {
            that.closeStream();
            if (typeof window.synDesktopApp !== "undefined")
                window.synDesktopApp.endDialog("1");
            else {
                $("#" + windowId).data("kendoWindow").close();
                if ((that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
                    $("#cl_preview_layout").focus();
            }
        });
    }
    dataURItoBlob(dataURI) {
        let byteString = atob(dataURI.split(',')[1]);
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        let blob = new Blob([ab], { type: mimeString });
        return blob;
    }
    closeStream() {
        if (this.mediaStream) {
            this.mediaStream.getTracks().forEach(function (track) {
                track.stop();
            });
            this.mediaStream = undefined;
        }
    }
    resetLayout() {
        let that = this;
        if (that.field.datatype === "StaticImage") {
            if (that.field.labelhorizontaloption)
                that.horizontaloption = that.field.labelhorizontaloption.toLowerCase();
            if (that.field.layoutposition)
                that.layoutposition = that.field.layoutposition.toLowerCase();
            that.Attachments.splice(0, that.imageIds.length);
            that.divItem.children().remove();
            let parentControl;
            if (that.field.layoutposition && that.field.layoutposition.toLowerCase() !== "all") {
                that.labelColumn = $("<div id='" + that.id + "_labeldiv' class='checklistlabelcolumn'/>").appendTo(that.divItem);
                that.labelColumn.css("width", "30%");
                that.inputColumn = $("<div id='" + that.id + "_controldiv' class='checklistinputcolumn'/>").appendTo(that.divItem);
                if (that.field.layoutposition && that.field.layoutposition.toLowerCase() === "label")
                    parentControl = that.labelColumn;
                else
                    parentControl = that.inputColumn;
            }
            else {
                parentControl = that.divItem;
            }
            if (that.isStatic && (that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer) {
                that.templateLabel = $("<label id='" + that.id + "_templatelabel' >" + Utilities_1.synUtil.Strings.getValue("clstaticimageplaceholder") + "</label>").appendTo(parentControl);
                that.templateLabel.hide();
            }
            that.inputControl = $("<div id='" + that.id + "' />").appendTo(parentControl);
            that.sortContainer = $("<ul class='attachmentsortable'></ul>").appendTo(that.inputControl);
            if (!that.isStatic && that.field.imageonly)
                that.sortContainer.css("display", "flex");
            that.sortContainer.kendoSortable({
                autoScroll: true,
                ignore: "li",
                filter: ".attachmentdragable"
            });
            if (that.imageIds.length === 0) {
                if (that.isStatic && (that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer) {
                    that.templateLabel.show();
                }
            }
            else {
                for (let idx = 0; idx < that.imageIds.length; ++idx) {
                    let containerId = this.clControlFactory.getContainerId(that.imageIds[idx], this.id);
                    let fileId = this.clControlFactory.getFileId(that.imageIds[idx], this.id);
                    let attachmentInfo = that.clControlFactory.GetAttachmentInfo(that.field.attachments[idx]);
                    if (containerId && fileId) {
                        let clImage;
                        if (that.isStatic) {
                            clImage = new ClStaticImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + that.imageIds[idx], that.imageIds[idx], that.id, that.field.maxwidth, that.horizontaloption);
                            clImage.init(that.inputControl);
                            that.Attachments.push(clImage);
                        }
                        else {
                            clImage = new ClImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + that.imageIds[idx], that.imageIds[idx], that.id, that.columncount);
                            clImage.init(that.sortContainer);
                            that.Attachments.push(clImage);
                        }
                    }
                }
            }
            if (that.isStatic) {
                if (that.horizontaloption && (that.horizontaloption.toLowerCase() === "center" || that.horizontaloption.toLowerCase() === "right" || that.horizontaloption.toLowerCase() === "justify"))
                    that.inputControl.css("text-align", that.horizontaloption.toLowerCase());
                else
                    that.inputControl.css("text-align", "left");
            }
        }
    }
    getValue() {
        return undefined;
    }
    setValue(value) {
        "Method not implemented.";
    }
    removeAttachment(attachment) {
        let pos = this.Attachments.indexOf(attachment);
        if (pos !== -1)
            this.Attachments.splice(pos, 1);
        this.notifyChange();
        $(this).trigger("controlValueChanged");
    }
    addAttachment(imageGuid, attachmentInfo) {
        let that = this;
        let clImage;
        if (that.isStatic) {
            clImage = new ClStaticImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + imageGuid, imageGuid, that.id, that.field.maxwidth, that.horizontaloption);
            clImage.init(that.inputControl);
            that.Attachments.push(clImage);
        }
        else {
            if (that.field.imageonly) {
                clImage = new ClImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + imageGuid, imageGuid, that.id, that.columncount);
                clImage.init(that.sortContainer);
                that.Attachments.push(clImage);
            }
            else {
                let attachmentItem = new ClMediaControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id, imageGuid);
                attachmentItem.init(that.sortContainer);
                that.Attachments.push(attachmentItem);
            }
        }
        this.notifyChange();
    }
    updateColCount() {
        this.columncount = this.field["colcount"];
        $.each(this.Attachments, (idx, control) => {
            if (control instanceof ClImageControl)
                control.resizeControl(this.field["colcount"]);
        });
    }
    updateControl() {
        if (this.isStatic) {
            if (this.Attachments.length === 1) {
                let attachment = this.Attachments[0];
                if (attachment instanceof ClImageControl)
                    attachment.resizeControl(this.field.maxwidth);
            }
        }
        else {
            let imageCount = this.getImageCount();
            if (imageCount > this.field.max) {
                for (let idx = this.field.max; idx < imageCount; ++idx) {
                    let att = this.Attachments[idx];
                    if (att instanceof ClImageControl)
                        att.removeImage();
                }
                this.Attachments.splice(this.field.max);
            }
            if (this.field.mandatory && this.field.min < 1) {
                this.field.min = 1;
            }
            this.setContextMenu();
            this.checkButtonVisibility();
        }
        this.notifyChange(true);
    }
    checkButtonVisibility() {
        if (!this.isStatic) {
            if (!this.IsReadOnly() || (this.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer) {
                if (this.Attachments.length < this.field.max)
                    this.addAttachmentButton.show();
                else
                    this.addAttachmentButton.hide();
            }
            else
                this.addAttachmentButton.hide();
        }
    }
    getImageCount() {
        return this.Attachments.length;
    }
    highlightMandatory() {
        if (!this.IsReadOnly() && !this.isStatic) {
            if (this.field.mandatory && (this.Attachments.length === 0 || this.Attachments.length < this.field.min))
                this.container.addClass("clMandatory");
            else
                this.container.removeClass("clMandatory");
        }
    }
    notifyChange(preventUpdateControl = false) {
        super.notifyChange(preventUpdateControl);
        if (!preventUpdateControl)
            this.clControlFactory.checklistjQuery.trigger("updateControl", [this.id]);
        this.checkButtonVisibility();
        this.imageIds.splice(0, this.imageIds.length);
        $.each(this.field.attachments, (idx, value) => {
            this.imageIds.push(this.field.attachments[idx].Id);
        });
        if (this.isStatic) {
            if (this.Attachments.length === 0 && (this.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
                this.templateLabel.show();
            else
                this.templateLabel.hide();
        }
    }
    setFieldValue() {
        let that = this;
        that.imageIds.splice(0);
        that.field.attachments.sort((a, b) => { return a.Order - b.Order; });
        $.each(that.field.attachments, (idx, value) => {
            this.imageIds.push(that.field.attachments[idx].Id);
        });
        if (that.field.datatype === "StaticImage") {
            that.resetLayout();
        }
        else {
            $.each(that.Attachments, (idx, att) => {
                att.removeContainer();
            });
            that.Attachments.splice(0);
            for (let idx = 0; idx < that.imageIds.length; ++idx) {
                let containerId = this.clControlFactory.getContainerId(that.imageIds[idx], this.id);
                let fileId = this.clControlFactory.getFileId(that.imageIds[idx], this.id);
                if (containerId && fileId) {
                    let clImage;
                    let attachmentInfo;
                    if (that.isStatic) {
                        clImage = new ClStaticImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + that.imageIds[idx], that.imageIds[idx], that.id, that.field.maxwidth, that.horizontaloption);
                        clImage.init(that.inputControl);
                        that.Attachments.push(clImage);
                    }
                    else {
                        attachmentInfo = that.clControlFactory.GetAttachmentInfo(that.field.attachments[idx]);
                        if (that.field.imageonly) {
                            clImage = new ClImageControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.id + "_" + that.imageIds[idx], that.imageIds[idx], that.id, that.columncount);
                            clImage.init(that.sortContainer);
                            that.Attachments.push(clImage);
                        }
                        else {
                            let attItem = new ClMediaControl(that.clControlFactory, attachmentInfo, that, that.IsReadOnly(), that.field["id"], that.imageIds[idx]);
                            attItem.init(that.sortContainer);
                            that.Attachments.push(attItem);
                        }
                    }
                }
            }
            if (!that.isStatic) {
                this.enable(!that.IsReadOnly());
                this.highlightMandatory();
                this.checkButtonVisibility();
            }
        }
    }
    hasValue() {
        return this.Attachments.length < this.field.min || this.Attachments.length > this.field.max ? false : true;
    }
}
exports.ClImageViewControl = ClImageViewControl;
class LayoutItem extends ClControl {
    constructor(prependId, item, checklistControlFactory) {
        super(prependId, item, checklistControlFactory);
        this.color = item.color;
        this.height = item.height;
    }
    init(jQueryElem) {
        super.init(jQueryElem);
        this.inputControl = $("<hr class='horizontalline' id='" + this.id + "'>").appendTo(this.divItem);
        if (this.height) {
            if (this.height > 0) {
                this.inputControl.css("margin-top", (this.height / 2).toString() + "px");
                this.inputControl.css("margin-bottom", (this.height / 2).toString() + "px");
            }
            else {
                this.inputControl.css("margin-top", "0px");
                this.inputControl.css("margin-bottom", "0px");
            }
        }
        if (this.color)
            this.inputControl.css("border-color", this.color);
        this.enable(!this.IsReadOnly());
        this.setVisibility(this.field.visible, this.field.show);
    }
    updateControl() {
        this.color = this.field.color;
        this.height = this.field.height;
        this.inputControl.css("border-color", this.color);
        if (this.height) {
            if (this.height > 0) {
                this.inputControl.css("margin-top", (this.height / 2).toString() + "px");
                this.inputControl.css("margin-bottom", (this.height / 2).toString() + "px");
            }
            else {
                this.inputControl.css("margin-top", "0px");
                this.inputControl.css("margin-bottom", "0px");
            }
        }
    }
    getValue() {
        return undefined;
    }
    setValue(value) {
        "Method not implemented.";
    }
    enable(enable) {
        super.enable(enable);
        if (enable)
            this.inputControl.removeAttr("disabled");
        else
            this.inputControl.attr("disabled", "disabled");
    }
    resetLabel(callback) {
        "Method not implemented.";
    }
    resetHelpLabel(callback) {
        "Method not implemented.";
    }
}
exports.LayoutItem = LayoutItem;
class ClPage extends ClControl {
    constructor(prependId, page, checklistControlFactory, forDesigner, firstPage) {
        super(prependId, page, checklistControlFactory);
        this.labels = page.labels;
        this.backgroundcolor = page.backgroundcolor;
        this.page = page;
        this.firstPage = firstPage;
        this.forDesigner = forDesigner;
        this.helpLabels = page.helplabels;
        this.initialized = false;
    }
    getPageId() {
        return this.page.id;
    }
    setPageId(pageId) {
    }
    init(jQueryElem) {
        let that = this;
        if (that.forDesigner) {
            super.init(jQueryElem);
            let inputControl;
            that.divItem.addClass("clPage");
            let pageHeader = $("<div id='" + that.id + "'_pageHeader'  class='cl_pageheader'></div>").appendTo(that.divItem);
            this.labelContainer = $("<div id='" + that.id + "'_pagelabelContainer'  class='cl_pagelabelcontainer' />").appendTo(pageHeader);
            that.helpLabelColumn = $("<div id='" + that.id + "_helplabeldiv' class='checklisthelplabelrow checklisthelplabelcolumn checklistdesignerpagehelplabelrow'/>").appendTo(that.divItem);
            this.pageBody = $("<div id='" + that.id + "'_pageBody'  class='cl_pagebody' />").appendTo(that.divItem);
            let label = "";
            if (that.labels)
                label = that.clControlFactory.getLabel(that.labels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
            $("<div class='cl_pagecorner'  />").appendTo(pageHeader);
            let labelControl = $("<div id='" + that.id + "_pagelabel'/>").appendTo(this.labelContainer);
            $(label).appendTo(labelControl);
            let helpLabel = that.clControlFactory.getLabel(that.helpLabels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
            that.setHelpLabel(helpLabel, false);
            if (that.backgroundcolor) {
                this.labelContainer.css("background-color", that.backgroundcolor);
                this.pageBody.css("background-color", that.backgroundcolor);
            }
            this.enable(!this.IsReadOnly());
            this.setVisibility(this.field.visible, this.field.show);
        }
        else {
            let tabStrip = jQueryElem;
            let tabList = jQueryElem.find(".clTablist");
            let tab = $("<li class='clpageTab' />").appendTo(tabList);
            tab.attr("cl_page_id", that.page.id);
            if (that.firstPage) {
                that.firstPage = false;
                tab.addClass("k-state-active");
            }
            let label = "";
            if (this.field.labels) {
                label = that.clControlFactory.getLabel(that.page.labels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
                $(label).appendTo(tab);
            }
            if (that.page.visible && that.page.show)
                tab.show();
            else
                tab.hide();
        }
    }
    resetLabel(callback) {
        this.labels = this.page.labels;
        let that = this;
        let resolveMarkdownCallback = function () {
            let label = "";
            if (that.page.labels)
                label = that.clControlFactory.getLabel(that.page.labels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
            $("#" + that.id + "_pagelabel").children().remove();
            $(label).appendTo($("#" + that.id + "_pagelabel"));
            if (callback)
                callback();
        };
        let requestOptions = {
            labels: JSON.stringify(that.field.labels)
        };
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            requestData: requestOptions,
            url: Utilities_1.synUtil.getWSUrl("ChecklistResolveMarkdown"),
            done(labels) {
                that.page.labels = labels;
                resolveMarkdownCallback();
            }
        });
    }
    resetHelpLabel(callback) {
        this.helpLabels = this.page.helplabels;
        let that = this;
        let resolveMarkdownCallback = function () {
            let label = "";
            if (that.page.labels)
                label = that.clControlFactory.getLabel(that.page.helplabels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
            that.helpLabelColumn.children().remove();
            that.setHelpLabel(label, false);
            if (callback)
                callback();
        };
        let requestOptions = {
            labels: JSON.stringify(that.field.helplabels)
        };
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            requestData: requestOptions,
            url: Utilities_1.synUtil.getWSUrl("ChecklistResolveMarkdown"),
            done(labels) {
                that.page.helplabels = labels;
                resolveMarkdownCallback();
            }
        });
    }
    getInputControl() {
        return this.pageBody;
    }
    getValue() {
        return undefined;
    }
    setValue(value) {
        "Method not implemented.";
    }
    enable(enable) {
        "Method not implemented.";
    }
    updateControl() {
        this.backgroundcolor = this.field.backgroundcolor;
        this.labelContainer.css("background-color", this.field.backgroundcolor);
        this.pageBody.css("background-color", this.field.backgroundcolor);
    }
}
exports.ClPage = ClPage;
class ClGroup extends ClControl {
    constructor(prependId, group, checklistControlFactory) {
        super(prependId, group, checklistControlFactory);
        this.labels = group.labels;
        this.bordercolor = group.bordercolor;
        this.backgroundcolor = group.backgroundcolor;
        this.helpLabels = group.helplabels;
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        that.divItem.addClass("clGroup");
        let label = "";
        if (that.labels)
            label = that.clControlFactory.getLabel(that.labels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
        let labelControl = $("<div id='" + that.id + "_grouplabel' style='font-weight: bold;'></div>").appendTo(that.divItem);
        $(label).appendTo(labelControl);
        that.helpLabelColumn = $("<div id='" + that.id + "_helplabeldiv' class='checklisthelplabelrow checklisthelplabelcolumn'/>").appendTo(that.divItem);
        let helpLabel = that.clControlFactory.getLabel(that.helpLabels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
        that.setHelpLabel(helpLabel, false);
        if (that.bordercolor) {
            that.divItem.addClass("clBorder");
            that.divItem.css("border-color", that.bordercolor);
        }
        else
            that.divItem.removeClass("clBorder");
        if (that.backgroundcolor)
            that.divItem.css("background-color", that.backgroundcolor);
        this.enable(!that.IsReadOnly());
        this.setVisibility(this.field.visible, this.field.show);
    }
    resetLabel(callback) {
        this.labels = this.field.labels;
        let that = this;
        let resolveMarkdownCallback = function () {
            let label;
            if (that.field.labels)
                label = that.clControlFactory.getLabel(that.field.labels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
            $("#" + that.id + "_grouplabel").children().remove();
            $(label).appendTo($("#" + that.id + "_grouplabel"));
            if (callback)
                callback();
        };
        let requestOptions = {
            labels: JSON.stringify(that.field.labels)
        };
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            requestData: requestOptions,
            url: Utilities_1.synUtil.getWSUrl("ChecklistResolveMarkdown"),
            done(labels) {
                that.field.labels = labels;
                resolveMarkdownCallback();
            }
        });
    }
    resetHelpLabel(callback) {
        this.helpLabels = this.field.helplabels;
        let that = this;
        let resolveMarkdownCallback = function () {
            let label;
            if (that.field.helplabels)
                label = that.clControlFactory.getLabel(that.field.helplabels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
            that.helpLabelColumn.children().remove();
            that.setHelpLabel(label, false);
            if (callback)
                callback();
        };
        let requestOptions = {
            labels: JSON.stringify(that.field.helplabels)
        };
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            requestData: requestOptions,
            url: Utilities_1.synUtil.getWSUrl("ChecklistResolveMarkdown"),
            done(labels) {
                that.field.helplabels = labels;
                resolveMarkdownCallback();
            }
        });
    }
    updateControl() {
        this.backgroundcolor = this.field.backgroundcolor;
        this.bordercolor = this.field.bordercolor;
        if (this.bordercolor) {
            this.divItem.addClass("clBorder");
            this.divItem.css("border-color", this.bordercolor);
        }
        else
            this.divItem.removeClass("clBorder");
        this.divItem.css("background-color", this.backgroundcolor);
    }
    getInputControl() {
        return this.divItem;
    }
    getValue() {
        return undefined;
    }
    setValue(value) {
        "Method not implemented.";
    }
    enable(enable) {
        "Method not implemented.";
    }
}
exports.ClGroup = ClGroup;
class ClStaticText extends ClFieldControl {
    constructor(prependId, field, checklistControlFactory, levelcount, type) {
        super(prependId, field, checklistControlFactory, levelcount);
        if (field.labelhorizontaloption)
            this.horizontaloption = field.labelhorizontaloption.toLowerCase();
        if (field.layoutposition)
            this.layoutposition = field.layoutposition.toLowerCase();
    }
    init(jQueryElem) {
        let that = this;
        let inputControl;
        let markdown = that.clControlFactory.getLabel(that.field.labels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
        // if (!markdown && (that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
        //    markdown = "<p>Fügen Sie einen Label hinzu.</p>";
        if (that.layoutposition && that.layoutposition.toLowerCase() !== "all") {
            super.init(jQueryElem);
            if (that.layoutposition && that.layoutposition.toLowerCase() === "label")
                inputControl = $(markdown).appendTo(that.labelColumn);
            else
                inputControl = $(markdown).appendTo(that.inputColumn);
        }
        else {
            that.divContainer = $("<div id='" + that.id + "_item' class='checklistrow'/>").appendTo(jQueryElem);
            that.divItem = $("<div id='" + that.id + "_inputitem' class='checklistinputrow'/>").appendTo(that.divContainer);
            if ((this.clControlFactory.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
                if (that.clControlFactory.rowSpacing > 0) {
                    that.divItem.css("padding-top", (that.clControlFactory.rowSpacing / 2).toString() + "px");
                    that.divItem.css("padding-bottom", (that.clControlFactory.rowSpacing / 2).toString() + "px");
                }
                else {
                    that.divItem.css("padding-top", "0px");
                    that.divItem.css("padding-bottom", "0px");
                }
                if (this.clControlFactory.instance.fontsize)
                    this.divItem.css("font-size", this.clControlFactory.instance.fontsize.toString() + "px");
            }
            inputControl = $(markdown).appendTo(that.divItem);
        }
        inputControl.addClass("checkliststatictext");
        if (that.horizontaloption && (that.horizontaloption.toLowerCase() === "center" || that.horizontaloption.toLowerCase() === "right" || that.horizontaloption.toLowerCase() === "justify"))
            inputControl.css("text-align", that.horizontaloption.toLowerCase());
        else
            inputControl.css("text-align", "left");
        this.setVisibility(this.field.visible, this.field.show);
    }
    resetLabel(callback) {
        let that = this;
        that.horizontaloption = that.field.labelhorizontaloption;
        that.layoutposition = that.field.layoutposition;
        let resolveMarkdownCallback = function () {
            let markdown = that.clControlFactory.getLabel(that.field.labels, that.clControlFactory.userUILangId, that.clControlFactory.instance.langid);
            if (!markdown && (that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
                markdown = "<p>Fügen Sie einen Label hinzu.</p>";
            that.divItem.children().remove();
            let inputControl;
            if (that.layoutposition && that.layoutposition.toLowerCase() !== "all") {
                that.labelColumn = $("<div id='" + that.id + "_labeldiv' class='checklistlabelcolumn'/>").appendTo(that.divItem);
                that.labelColumn.css("width", "30%");
                that.inputColumn = $("<div id='" + that.id + "_controldiv' class='checklistinputcolumn'/>").appendTo(that.divItem);
                if (that.layoutposition && that.layoutposition.toLowerCase() === "label")
                    inputControl = $(markdown).appendTo(that.labelColumn);
                else
                    inputControl = $(markdown).appendTo(that.inputColumn);
            }
            else {
                inputControl = $(markdown).appendTo(that.divItem);
            }
            inputControl.addClass("checkliststatictext");
            if (that.horizontaloption && (that.horizontaloption.toLowerCase() === "center" || that.horizontaloption.toLowerCase() === "right" || that.horizontaloption.toLowerCase() === "justify"))
                inputControl.css("text-align", that.horizontaloption);
            else
                inputControl.css("text-align", "left");
            if (callback)
                callback();
        };
        let requestOptions = {
            labels: JSON.stringify(that.field.labels)
        };
        Utilities_1.synUtil.getAJAXData({
            method: "POST",
            requestData: requestOptions,
            url: Utilities_1.synUtil.getWSUrl("ChecklistResolveMarkdown"),
            done(labels) {
                that.field.labels = labels;
                resolveMarkdownCallback();
            }
        });
    }
    getValue() {
        return this.field.value;
    }
    setValue(value) {
        this.inputControl.text(value);
    }
    setFieldValue() {
        "Method not implemented.";
    }
}
exports.ClStaticText = ClStaticText;
class ClTextInput extends ClMVableControl {
    constructor(prependId, field, checklistControlFactory, levelcount, rootControl, mvValue) {
        super(prependId, field, checklistControlFactory, levelcount, mvValue);
        this.rootControl = rootControl;
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        that.inputControl = $("<input  id='" + that.id + "' type='text' class='clInput k-textbox'  maxlength='" + that.field.maxlength.toString() + "'/>").appendTo(that.controlContainer);
        if (that.field.multivalue) {
            if (that.isMultiValueControl) {
                that.setValue(that.currentMV);
                that.inputControl.addClass("clReadOnly");
                that.controlButton.on("click", function () {
                    // remove
                    that.rootControl.removeMultivalueInput(that);
                    that.rootControl.notifyChange();
                    let rootValue = that.rootControl.getCurrentValue();
                    if (rootValue)
                        that.rootControl.setButtonVisibility(rootValue);
                    $(that.rootControl).trigger("controlValueChanged");
                });
                this.enable(false);
            }
            else {
                that.inputControl.on("input", function (e) {
                    // check button visibility
                    that.setButtonVisibility(that.inputControl.val());
                    that.notifyChange();
                    that.setTelephoneButtonVisibility(that.inputControl.val().toString());
                });
                that.setMultiValue(that.field.value);
                that.inputControl.on("keydown", (e) => {
                    if (e.keyCode === 13) {
                        that.controlButton.trigger("click");
                    }
                });
                that.controlButton.on("click", function () {
                    let val = that.inputControl.val();
                    if (val) {
                        // addchildcontrol
                        that.addMultiValue(val);
                        that.setValue("");
                        that.controlButton.hide();
                        that.notifyChange();
                        $(that).trigger("controlValueChanged");
                    }
                });
                this.enable(!that.IsReadOnly());
            }
        }
        else {
            that.inputControl.on("input", function (e) {
                that.notifyChange();
                that.setTelephoneButtonVisibility(that.inputControl.val().toString());
            });
            that.inputControl.on("change", function (e) {
                $(that).trigger("controlValueChanged");
            });
            this.enable(!that.IsReadOnly());
            this.setValue(this.field.value);
        }
        that.telephoneButton.on("click", function () {
            that.clControlFactory.executeTelLink(that.getCurrentValue());
        });
        if (!that.isMultiValueControl) {
            this.setVisibility(this.field.visible, this.field.show);
            that.highlightMandatory();
        }
    }
    getMultiValue() {
        let that = this;
        let values = [];
        for (let i = 0; i < that.multiValues.allControls.length; ++i) {
            values.push(that.multiValues.allControls[i].getValue());
        }
        if (values.length > 0)
            return values;
        else
            return undefined;
    }
    getCurrentValue() {
        return this.inputControl.val();
    }
    getValue() {
        let that = this;
        if (that.field.multivalue && !that.isMultiValueControl) {
            let values = [];
            let singlevalue = that.inputControl.val();
            let multivalues = that.getMultiValue();
            if (multivalues) {
                multivalues.forEach((item) => {
                    values.push(item);
                });
            }
            if (singlevalue) {
                let bAdd = true;
                if (values.length > 0) {
                    values.forEach((item) => {
                        if (item === singlevalue)
                            bAdd = false;
                    });
                }
                if (bAdd)
                    values.push(singlevalue);
            }
            if (!values || values.length === 0)
                return undefined;
            else {
                return values;
            }
        }
        else {
            let value = that.inputControl.val();
            if (value)
                return value;
            else
                return undefined;
        }
    }
    addMultiValue(value) {
        let that = this;
        if (that.field.multivalue) {
            if (value instanceof Array) {
                $.each(value, (idx, val) => {
                    let bAdd = true;
                    for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                        if (that.multiValues.allControls[i].getValue() === val)
                            bAdd = false;
                    }
                    if (bAdd) {
                        let guid = Utilities_1.synUtil.getGUID(true);
                        let multiValInput = new ClTextInput(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that, val);
                        multiValInput.setPageId(that.pageId);
                        multiValInput.init(that.multivalueContainer);
                        that.multiValues.pushControl(multiValInput);
                    }
                });
            }
            else {
                if (value) {
                    if (that.isMultiValueControl) {
                        that.inputControl.val(value);
                    }
                    else {
                        let bAdd = true;
                        for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                            if (that.multiValues.allControls[i].getValue() === value)
                                bAdd = false;
                        }
                        if (bAdd) {
                            let guid = Utilities_1.synUtil.getGUID(true);
                            let multiValInput = new ClTextInput(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that, value);
                            multiValInput.setPageId(that.pageId);
                            multiValInput.init(that.multivalueContainer);
                            that.multiValues.pushControl(multiValInput);
                        }
                    }
                }
            }
        }
    }
    updateValueProperties() {
        this.inputControl.attr("maxlength", this.field.maxlength.toString());
    }
    setValue(value) {
        this.inputControl.val(value);
        this.setTelephoneButtonVisibility(value);
    }
    setTelephoneButtonVisibility(value) {
        if (this.field["istelnr"] && this.clControlFactory.filterTelephoneNumber(value))
            this.telephoneButtonContainer.show();
        else
            this.telephoneButtonContainer.hide();
    }
    enable(enable) {
        super.enable(enable);
        if (enable) {
            this.inputControl.show();
            this.inputControl.removeAttr("disabled");
        }
        else {
            this.inputControl.attr("disabled", "disabled");
            if (this.field.multivalue && this.hasValue() && !this.getCurrentValue())
                this.inputControl.hide();
        }
    }
}
exports.ClTextInput = ClTextInput;
class ClNumericInput extends ClMVableControl {
    constructor(prependId, field, checklistControlFactory, levelcount, type, rootControl, mvValue) {
        super(prependId, field, checklistControlFactory, levelcount, mvValue);
        this.type = type.toLowerCase();
        this.steps = 2;
        if (field.steps)
            this.steps = field.steps;
        if (field.max)
            this.max = field.max;
        if (field.min)
            this.min = field.min;
        this.rootControl = rootControl;
        this.checkEnter = false;
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        let max = 2147483647, min = -2147483648;
        if (that.type === "float") {
            max = 3.40282e+038;
            min = -3.40282e+038;
        }
        if (that.type === "integer") {
            that.steps = 0;
        }
        if (!that.max || that.max > max)
            that.max = max;
        if (!that.min || that.min < min)
            that.min = min;
        that.inputControl = $("<input  id='" + that.id + "' />").appendTo(that.controlContainer);
        that.inputControl.css("width", "100%");
        that.inputControl.removeAttr("title");
        that.inputControl.addClass("clInput");
        let format = that.steps > 0 ? "n" + that.steps.toString() : "#";
        if (that.field.multivalue) {
            if (that.isMultiValueControl) {
                that.numericInput = that.inputControl.kendoNumericTextBox({
                    decimals: that.steps,
                    format,
                    min: that.min,
                    max: that.max,
                    culture: that.clControlFactory.userCulture,
                    downArrowText: "",
                    upArrowText: "",
                    change: (e) => {
                        e.sender.element.parent().children("input.k-input").removeAttr("title");
                    }
                }).data("kendoNumericTextBox");
                that.inputControl.parent().children("input.k-input").removeAttr("title");
                that.setValue(that.currentMV);
                that.controlButton.on("click", function () {
                    // remove
                    that.rootControl.removeMultivalueInput(that);
                    that.rootControl.notifyChange();
                    let rootValue = that.rootControl.getCurrentValue();
                    if (rootValue != undefined)
                        that.rootControl.setButtonVisibility(rootValue);
                    $(that.rootControl).trigger("controlValueChanged");
                });
                this.enable(false);
            }
            else {
                that.numericInput = that.inputControl.kendoNumericTextBox({
                    decimals: that.steps,
                    format,
                    min: that.min,
                    max: that.max,
                    culture: that.clControlFactory.userCulture,
                    downArrowText: "",
                    upArrowText: "",
                    change: (e) => {
                        e.sender.element.parent().children("input.k-input").removeAttr("title");
                        let val = e.sender.value();
                        that.checkEnter = true;
                        that.setButtonVisibility(val);
                        that.notifyChange();
                        $(that).trigger("controlValueChanged");
                    },
                }).data("kendoNumericTextBox");
                that.inputControl.on("input", (e) => {
                    that.checkEnter = false;
                    that.controlButton.hide();
                });
                that.inputControl.on("keydown", (e) => {
                    if (e.keyCode === 13 && that.checkEnter) {
                        that.controlButton.trigger("click");
                    }
                });
                that.inputControl.parent().children("input.k-input").removeAttr("title");
                that.setMultiValue(that.field.value);
                that.controlButton.on("click", function () {
                    let val = that.inputControl.data("kendoNumericTextBox").value();
                    if (val || val === 0) {
                        // addchildcontrol
                        that.addMultiValue(val);
                        that.setValue("");
                        that.controlButton.hide();
                        that.notifyChange();
                        $(that).trigger("controlValueChanged");
                    }
                });
                this.enable(!that.IsReadOnly());
            }
        }
        else {
            that.numericInput = that.inputControl.kendoNumericTextBox({
                decimals: that.steps,
                format,
                min: that.min,
                max: that.max,
                culture: that.clControlFactory.userCulture,
                downArrowText: "",
                upArrowText: "",
                change: (e) => {
                    that.notifyChange();
                    // remove tooltip
                    $(that).trigger("controlValueChanged");
                    e.sender.element.parent().children("input.k-input").removeAttr("title");
                },
            }).data("kendoNumericTextBox");
            that.inputControl.parent().children("input.k-input").removeAttr("title");
            that.setValue(that.field.value);
            this.enable(!that.IsReadOnly());
        }
        if (!that.isMultiValueControl) {
            this.setVisibility(this.field.visible, this.field.show);
            that.highlightMandatory();
        }
    }
    getMultiValue() {
        let that = this;
        let values = [];
        for (let i = 0; i < that.multiValues.allControls.length; ++i) {
            values.push(that.multiValues.allControls[i].getValue());
        }
        if (values.length > 0)
            return values;
        else
            return undefined;
    }
    getCurrentValue() {
        let value;
        if (this.numericInput)
            value = this.numericInput.value();
        if (value != undefined)
            return value;
        else
            return undefined;
    }
    getValue() {
        let that = this;
        if (that.field.multivalue && !that.isMultiValueControl) {
            let values = [];
            let singlevalue = that.numericInput.value();
            let multivalues = that.getMultiValue();
            if (multivalues != undefined) {
                multivalues.forEach((item) => {
                    values.push(item);
                });
            }
            if (singlevalue != undefined) {
                let bAdd = true;
                if (values.length > 0) {
                    values.forEach((item) => {
                        if (item === singlevalue)
                            bAdd = false;
                    });
                }
                if (bAdd)
                    values.push(singlevalue);
            }
            if (values == undefined || values.length === 0)
                return undefined;
            else {
                return values;
            }
        }
        else {
            let value = that.numericInput.value();
            if (value != undefined)
                return value;
            else
                return undefined;
        }
    }
    addMultiValue(value) {
        let that = this;
        if (that.field.multivalue) {
            if (value instanceof Array) {
                $.each(value, (idx, val) => {
                    let bAdd = true;
                    for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                        if (that.multiValues.allControls[i].getValue() === val)
                            bAdd = false;
                    }
                    if (bAdd) {
                        let guid = Utilities_1.synUtil.getGUID(true);
                        let multiValInput = new ClNumericInput(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that.type, that, val);
                        multiValInput.setPageId(that.pageId);
                        multiValInput.init(that.multivalueContainer);
                        that.multiValues.pushControl(multiValInput);
                    }
                });
            }
            else {
                if (value || value === 0) {
                    if (that.isMultiValueControl) {
                        $("#" + this.id).val(value);
                    }
                    else {
                        let bAdd = true;
                        for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                            if (that.multiValues.allControls[i].getValue() === value)
                                bAdd = false;
                        }
                        if (bAdd) {
                            let guid = Utilities_1.synUtil.getGUID(true);
                            let multiValInput = new ClNumericInput(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that.type, that, value);
                            multiValInput.setPageId(that.pageId);
                            multiValInput.init(that.multivalueContainer);
                            that.multiValues.pushControl(multiValInput);
                        }
                    }
                }
            }
        }
    }
    setValue(value) {
        if (this.type === "float") {
            let num = parseFloat(value);
            value = num.toLocaleString(this.clControlFactory.userCulture);
        }
        this.numericInput.value(value);
    }
    enable(enable) {
        super.enable(enable);
        this.numericInput.enable(enable);
        if (enable)
            this.numericInput.wrapper.show();
        else {
            if (this.field.multivalue && this.hasValue() && !this.getCurrentValue())
                this.numericInput.wrapper.hide();
        }
    }
    updateValueProperties() {
        this.field.value = this.getValue();
        this.numericInput.options.decimals = this.field.steps;
        this.numericInput.options.format = "n" + this.field.steps.toString();
        this.numericInput.options.max = this.field.max;
        this.numericInput.options.min = this.field.min;
        if (this.field.max && this.field.value > this.field.max)
            this.field.value = this.field.max;
        if (this.field.min && this.field.value < this.field.min)
            this.field.value = this.field.min;
        this.setValue(this.field.value);
        this.numericInput.trigger("change");
    }
    highlightMandatory() {
        let target = this.inputControl.closest(".k-widget").find(".clInput");
        if (this.field.mandatory && !this.hasValue())
            target.addClass("clMandatory");
        else
            target.removeClass("clMandatory");
    }
}
exports.ClNumericInput = ClNumericInput;
class ClDatetime extends ClMVableControl {
    constructor(prependId, field, checklistControlFactory, levelcount, type, rootControl, mvValue) {
        super(prependId, field, checklistControlFactory, levelcount, mvValue);
        this.type = type.toLowerCase();
        if (field.max)
            this.max = new Date(field.max);
        if (field.min)
            this.min = new Date(field.min);
        this.rootControl = rootControl;
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        that.inputControl = $("<input id='" + that.id + "' class='clInput'>").appendTo(that.controlContainer);
        let control;
        if (!this.max && that.type !== "time")
            that.max = new Date(9999, 11);
        if (!this.min && that.type !== "time")
            that.min = new Date(1601, 0);
        let configOptions = {
            culture: that.clControlFactory.userCulture,
        };
        if (that.type !== "time") {
            configOptions["max"] = this.max;
            configOptions["min"] = this.min;
        }
        if (that.type === "time") {
            control = that.inputControl.kendoTimePicker(configOptions);
            that.picker = control.data("kendoTimePicker");
        }
        else if (that.type === "date") {
            control = that.inputControl.kendoDatePicker(configOptions);
            that.picker = control.data("kendoDatePicker");
        }
        else {
            control = that.inputControl.kendoDateTimePicker(configOptions);
            that.picker = control.data("kendoDateTimePicker");
        }
        if (that.field.multivalue) {
            if (that.isMultiValueControl) {
                that.setValue(that.currentMV);
                that.inputControl.addClass("clReadOnly");
                that.controlButton.on("click", function () {
                    // remove
                    that.rootControl.removeMultivalueInput(that);
                    that.rootControl.notifyChange();
                    let rootValue = that.rootControl.getCurrentValue();
                    if (rootValue != undefined)
                        that.rootControl.setButtonVisibility(rootValue);
                    $(that.rootControl).trigger("controlValueChanged");
                });
                this.enable(false);
            }
            else {
                that.picker.bind("change", () => {
                    let val = that.picker.value();
                    that.setButtonVisibility(val);
                    that.notifyChange();
                    $(that).trigger("controlValueChanged");
                });
                that.setMultiValue(that.field.value);
                that.inputControl.on("keydown", (e) => {
                    if (e.keyCode === 13) {
                        that.controlButton.trigger("click");
                    }
                });
                that.controlButton.on("click", function () {
                    let val = that.picker.value();
                    if (val) {
                        // addchildcontrol
                        let dtvalue = new Date(val).toISOString();
                        that.addMultiValue(val);
                        that.setValue("");
                        that.controlButton.hide();
                        that.notifyChange();
                        $(that).trigger("controlValueChanged");
                    }
                });
                this.enable(!this.IsReadOnly());
            }
        }
        else {
            this.setValue(this.field.value);
            that.picker.bind("change", () => {
                that.notifyChange();
                $(that).trigger("controlValueChanged");
            });
            this.enable(!this.IsReadOnly());
        }
        if (!that.isMultiValueControl) {
            this.setVisibility(this.field.visible, this.field.show);
            that.highlightMandatory();
        }
    }
    getCurrentValue() {
        let val = this.picker.value();
        if (val == undefined)
            return undefined;
        if (this.type === "time") {
            return kendo.toString(val, "HH:mm:ss");
        }
        else if (this.type === "date")
            return kendo.toString(val, "yyyy-MM-dd");
        else
            return new Date(val).toISOString();
    }
    getValue() {
        let that = this;
        if (that.field.multivalue && !that.isMultiValueControl) {
            let values = [];
            let singlevalue = that.getCurrentValue();
            let multivalues = that.getMultiValue();
            if (multivalues)
                multivalues.forEach((item) => {
                    values.push(item);
                });
            if (singlevalue) {
                let bAdd = true;
                if (values.length > 0) {
                    values.forEach((item) => {
                        if (item === singlevalue)
                            bAdd = false;
                    });
                }
                if (bAdd)
                    values.push(singlevalue);
            }
            if (!values || values.length === 0)
                return undefined;
            else
                return values;
        }
        else
            return that.getCurrentValue();
    }
    getMultiValue() {
        let that = this;
        let values = [];
        for (let i = 0; i < that.multiValues.allControls.length; ++i) {
            let value = that.multiValues.allControls[i].getValue();
            if (value)
                values.push(value);
        }
        if (values.length > 0)
            return values;
        else
            return undefined;
    }
    setValue(value) {
        this.picker.value(kendo.parseDate(value));
    }
    addMultiValue(value) {
        let that = this;
        if (that.field.multivalue) {
            if (value instanceof Array) {
                $.each(value, (idx, val) => {
                    let tmpVal;
                    if (that.type === "time")
                        tmpVal = kendo.toString(val, "hh:mm:ss");
                    else if (that.type === "date")
                        tmpVal = kendo.toString(val, "yyyy-MM-dd");
                    else
                        tmpVal = new Date(val).toISOString();
                    let bAdd = true;
                    for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                        if (tmpVal === that.multiValues.allControls[i].getValue())
                            bAdd = false;
                    }
                    if (bAdd) {
                        let guid = Utilities_1.synUtil.getGUID(true);
                        let multiValInput = new ClDatetime(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that.type, that, val);
                        multiValInput.setPageId(that.pageId);
                        multiValInput.init(that.multivalueContainer);
                        that.multiValues.pushControl(multiValInput);
                    }
                });
            }
            else {
                if (value) {
                    let tmpVal;
                    if (that.type === "time")
                        tmpVal = kendo.toString(value, "hh:mm:ss");
                    else if (that.type === "date")
                        tmpVal = kendo.toString(value, "yyyy-MM-dd");
                    else
                        tmpVal = new Date(value).toISOString();
                    let bAdd = true;
                    for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                        let valToCheck = that.multiValues.allControls[i].getValue();
                        if (tmpVal === valToCheck)
                            bAdd = false;
                    }
                    if (bAdd) {
                        let guid = Utilities_1.synUtil.getGUID(true);
                        let multiValInput = new ClDatetime(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that.type, that, value);
                        multiValInput.setPageId(that.pageId);
                        multiValInput.init(that.multivalueContainer);
                        that.multiValues.pushControl(multiValInput);
                    }
                }
            }
        }
    }
    setButtonVisibility(value) {
        let that = this;
        let entryAlreadExist = false;
        if (value) {
            let tmpVal;
            if (that.type === "time")
                tmpVal = kendo.toString(value, "hh:mm:ss");
            else if (that.type === "date")
                tmpVal = kendo.toString(value, "yyyy-MM-dd");
            else
                tmpVal = new Date(value).toISOString();
            let bAdd = true;
            for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                if (tmpVal === that.multiValues.allControls[i].getValue())
                    entryAlreadExist = true;
            }
            if (!entryAlreadExist)
                that.controlButton.show();
            else
                that.controlButton.hide();
        }
        else
            that.controlButton.hide();
    }
    enable(enable) {
        super.enable(enable);
        this.picker.enable(enable);
        if (enable)
            this.picker.wrapper.show();
        else {
            if (this.field.multivalue && this.hasValue() && !this.getCurrentValue())
                this.picker.wrapper.hide();
        }
    }
    resetCulture() {
        let format = "";
        if (this.type === "time") {
            format = "T";
        }
        else if (this.type === "date") {
            format = "d";
        }
        else {
            format = "G";
        }
        let options = this.picker.options;
        options.culture = this.clControlFactory.userCulture;
        options.format = format;
        this.picker.setOptions(options);
    }
}
exports.ClDatetime = ClDatetime;
class ClTextArea extends ClFieldControl {
    constructor(prependId, field, checklistControlFactory, levelcount) {
        super(prependId, field, checklistControlFactory, levelcount);
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        if (!that.field.rowcount || that.field.rowcount === 0)
            that.field.rowcount = 1;
        that.inputControl = $("<textarea  id='" + that.id + "' rows='" + that.field.rowcount.toString() + "' class='cltextarea k-textbox' maxlength='" + this.field.maxlength.toString() + "' />").appendTo(that.controljQueryElem);
        that.setValue(that.field.value);
        that.inputControl.on("input", function () {
            that.notifyChange();
        });
        that.inputControl.on("change", function (e) {
            $(that).trigger("controlValueChanged");
        });
        this.enable(!this.IsReadOnly());
        this.setVisibility(this.field.visible, this.field.show);
        that.highlightMandatory();
    }
    updateRowCount() {
        this.inputControl.prop("rows", this.field.rowcount.toString());
    }
    getValue() {
        return this.inputControl.val();
    }
    setValue(value) {
        this.inputControl.val(value);
    }
    enable(enable) {
        super.enable(enable);
        if (enable) {
            this.inputControl.removeAttr("disabled");
        }
        else {
            this.inputControl.attr("disabled", "disabled");
        }
    }
    updateValueProperties() {
        this.inputControl.attr("maxlength", this.field.maxlength.toString());
    }
}
exports.ClTextArea = ClTextArea;
class ClSVCheckBoxSwitch extends ClFieldControl {
    constructor(prependId, field, checklistControlFactory, levelcount, controlType) {
        super(prependId, field, checklistControlFactory, levelcount);
        this.checkboxId = this.id + "_checkbox";
        this.controlType = controlType;
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        that.inputControl = $("<div id='" + that.id + "' />").appendTo(that.controljQueryElem);
        if (this.controlType === "Switch") {
            let label = $("<label class='synSwitch' />").appendTo(that.inputControl);
            that.checkBox = $("<input id='" + that.checkboxId + "' type='checkbox' >").appendTo(label);
            that.switch = $("<span class='synSlider synSliderRound' />").appendTo(label);
        }
        else {
            that.inputControl.addClass("ClRadiobuttons");
            that.checkBox = $("<input  id='" + that.checkboxId + "' type='checkbox' class='clListItem'/>").appendTo(that.inputControl);
        }
        if (that.field.value === "true")
            that.checkBox.attr("data-hasvalue", "true").prop("checked", "checked");
        else if (that.field.value === "false")
            that.checkBox.attr("data-hasvalue", "true");
        else
            that.checkBox.attr("data-hasvalue", "false");
        if (that.IsReadOnly())
            that.checkBox.attr("disabled", "disabled");
        that.checkBox.change(() => {
            that.checkBox.attr("data-hasvalue", "true");
            that.notifyChange();
            $(that).trigger("controlValueChanged");
        });
        that.enable(!that.IsReadOnly());
        that.setVisibility(that.field.visible, this.field.show);
        that.highlightMandatory();
    }
    getValue() {
        if (this.checkBox.attr("data-hasvalue") === "true") {
            if (this.checkBox.prop("checked"))
                return "true";
            else
                return "false";
        }
        return undefined;
    }
    setValue(value) {
        if (value === "true")
            this.checkBox.attr("data-hasvalue", "true").prop("checked", "checked");
        else if (value === "false")
            this.checkBox.attr("data-hasvalue", "true").prop("checked", false);
        else
            this.checkBox.removeAttr("data-hasvalue").prop("checked", false);
    }
    enable(enable) {
        if (this.controlType === "Switch") {
            if (enable) {
                this.switch.removeClass("clReadOnly");
            }
            else {
                this.switch.addClass("clReadOnly");
            }
        }
        if (enable)
            this.checkBox.removeAttr("disabled");
        else
            this.checkBox.attr("disabled", "disabled");
    }
    highlightMandatory() {
        if (this.controlType === "Switch") {
            if (this.field.mandatory && !this.hasValue())
                this.switch.addClass("clMandatory");
            else
                this.switch.removeClass("clMandatory");
        }
        else
            super.highlightMandatory();
    }
}
exports.ClSVCheckBoxSwitch = ClSVCheckBoxSwitch;
class ClMVCheckBoxRadio extends ClFieldControl {
    constructor(prependId, field, checklistControlFactory, levelcount, controlType) {
        super(prependId, field, checklistControlFactory, levelcount);
        this.controlType = controlType;
    }
    init(jQueryElem) {
        let that = this;
        that.initJQueryElem = jQueryElem;
        super.init(jQueryElem);
        if (that.controlType === "Checkbox")
            that.type = "checkbox";
        else
            that.type = "radio";
        that.inputControl = $("<div id='" + that.id + "' class='checkboxcontainer'/>").appendTo(that.controljQueryElem);
        let initializeControl = function (datacollection) {
            that.initInternal(datacollection, false);
            that.enable(!that.IsReadOnly());
            that.setVisibility(that.field.visible, that.field.show);
            that.highlightMandatory();
        };
        let pids = [];
        if (that.field.dependentfield) {
            if (that.ParentField) {
                if (that.parentIsValid())
                    pids = that.clControlFactory.getAsArray(that.ParentField.field.value);
                that.clControlFactory.getDataList(initializeControl, that.field, undefined, pids, undefined, that.keepIds, that.hardDeletedIds, false, false, that.invalidIds);
            }
        }
        else
            that.clControlFactory.getDataList(initializeControl, that.field, undefined, pids, undefined, that.keepIds, that.hardDeletedIds, false, false, that.invalidIds);
    }
    initInternal(datacollection, currentControlHasChanged) {
        let that = this;
        if (datacollection != undefined) {
            if (currentControlHasChanged) {
                $.each(that.inputControl.children(), (idx, container) => {
                    let entryid = container.getAttribute("cl_entryid");
                    if (datacollection.findIndex(entry => entry["id"] === entryid) === -1) {
                        container.remove();
                    }
                });
            }
            else {
                that.inputControl.children().remove();
                for (let index = 0; index < datacollection.length; ++index) {
                    let dataItem = datacollection[index];
                    let guid = Utilities_1.synUtil.getGUID(true);
                    let container = $("<div style='overflow-wrap: break-word;display:inline-block;vertical-align:top; margin-bottom: 0.25em;' />").appendTo(that.inputControl);
                    container.attr("cl_entryid", dataItem.id);
                    let checkBox = $("<input id='" + that.id + "_" + guid + "' type = '" + that.type + "' name = '" + that.id + "' value = '" + dataItem.id + "' class='clListItem' >"); // .appendTo(container);
                    let label = $("<label id='" + that.id + "_" + guid + "_label' style='overflow-wrap: break-word;display:inline-block;vertical-align:middle;' />"); // .appendTo(container);
                    label.text(dataItem[that.field.datafield]);
                    checkBox.attr("cl_pid", dataItem["pid"]);
                    checkBox.attr("cl_dataitem", dataItem);
                    if (that.columncount > 0)
                        container.css("width", "calc((100% / " + that.columncount.toString() + ") - 0.1px)");
                    let showIcon = false;
                    let iconClass;
                    if (that.clControlFactory.isHardDeleted(dataItem)) {
                        label.addClass("clFtHardDeletedEntry");
                        showIcon = true;
                        iconClass = "clFtHardDeletedEntry";
                    }
                    if (that.clControlFactory.isSoftDeleted(dataItem) && that.clControlFactory.showDeletedWarning(dataItem)) {
                        label.addClass("clFtSoftDeletedEntry");
                        showIcon = true;
                        iconClass = "clFtSoftDeletedEntry";
                    }
                    if (that.clControlFactory.isAbstract(dataItem))
                        label.addClass("clFtAbstractEntry");
                    if (that.ParentField) {
                        if (!that.parentIsValid() || that.invalidIds.indexOf(dataItem.id) !== -1) {
                            label.addClass("clInvalidState");
                            showIcon = true;
                            iconClass = "clInvalidState";
                        }
                    }
                    if (showIcon) {
                        $("<i class='clbuttoncontainer fa fa-exclamation-triangle " + iconClass + "' aria-hidden='true' style='box-sizing:border-box;font-size: 1.5em;width: 1.5em;'></i>").appendTo(container);
                        label.css("width", "calc(100% - 4em)");
                    }
                    else
                        label.css("width", "calc(100% - 2em)");
                    checkBox.appendTo(container);
                    label.appendTo(container);
                    checkBox.change(() => {
                        if (!that.field.datapresentedinfo)
                            that.field.datapresentedinfo = {};
                        let val = dataItem.id;
                        if (val)
                            that.field.datapresentedinfo[val] = dataItem;
                        that.notifyChange();
                        $(that).trigger("controlValueChanged");
                    });
                }
            }
        }
        if (!currentControlHasChanged) {
            that.setValue(that.field.value);
            that.enable(!that.IsReadOnly());
            that.setVisibility(that.field.visible, that.field.show);
            that.highlightMandatory();
        }
    }
    dataSortChanged() {
        this.resetData(undefined, undefined, undefined, false);
    }
    resetData(dataCollection, textField, valueField, currentControlHasChanged) {
        let that = this;
        if (that.field.datapresentedinfo) {
            $.each(that.field.datapresentedinfo, (key, value) => {
                if (that.clControlFactory.isSoftDeleted(value) || that.clControlFactory.isHardDeleted(value) || that.clControlFactory.isAbstract(value)) {
                    if (that.keepIds.indexOf(key) === -1)
                        that.keepIds.push(key);
                    if (that.clControlFactory.isHardDeleted(value)) {
                        if (that.hardDeletedIds.indexOf(key) === -1)
                            that.hardDeletedIds.push(key);
                    }
                }
            });
        }
        let callback = function (data) {
            that.removeInvalidValues(data);
            that.initInternal(data, currentControlHasChanged);
        };
        let pids = [];
        if (that.field.dependentfield && that.ParentField) {
            if (that.parentIsValid())
                pids = that.clControlFactory.getAsArray(that.ParentField.field.value);
        }
        that.clControlFactory.getDataList(callback, that.field, undefined, pids, undefined, that.keepIds, that.hardDeletedIds, false, false, that.invalidIds);
    }
    removeInvalidValues(dataCollection) {
        if (this.field.value) {
            if (this.field.multivalue) {
                let tmpMultiValues = JSON.parse(JSON.stringify(this.field.value));
                if (tmpMultiValues instanceof Array) {
                    this.field.value.splice(0, this.field.value.length);
                    $.each(tmpMultiValues, (idx, multiValue) => {
                        let valueInCollection = false;
                        $.each(dataCollection, (idx, entry) => {
                            if (entry["id"] === multiValue)
                                valueInCollection = true;
                        });
                        if (valueInCollection)
                            this.field.value.push(multiValue);
                    });
                }
                else {
                    this.field.value = undefined;
                    let valueInCollection = false;
                    $.each(dataCollection, (idx, entry) => {
                        if (entry["id"] === tmpMultiValues)
                            valueInCollection = true;
                    });
                    if (valueInCollection)
                        this.field.value = tmpMultiValues;
                }
            }
            else {
                let valueInCollection = false;
                $.each(dataCollection, (idx, entry) => {
                    if (entry["id"] === this.field.value)
                        valueInCollection = true;
                });
                if (!valueInCollection)
                    this.field.value = undefined;
            }
        }
    }
    updateColCount() {
        // resize
        this.columncount = this.field["colcount"];
        if (this.columncount === 0) {
            $("#" + this.id + " > div").css("width", "auto");
        }
        else {
            $("#" + this.id + " > div").css("width", "calc((100% / " + this.columncount.toString() + ") - 0.1px)");
        }
    }
    getValue() {
        if (this.controlType === "Checkbox") {
            let i = 0;
            let values = [];
            let value = this.inputControl.find("input[name='" + this.id + "']:checked").each(function () {
                values[i++] = $(this).val();
            });
            if (values.length > 0)
                return values;
            else
                return undefined;
        }
        else {
            let radio_value = this.inputControl.find("input[name=" + this.id + "]:checked").val();
            return radio_value;
        }
    }
    setValue(value) {
        if (this.controlType === "Checkbox") {
            this.inputControl.find("input[name=" + this.id + "]").prop("checked", false);
            if (value instanceof Array) {
                for (let i = 0; i < value.length; i++) {
                    this.inputControl.find("input[name=" + this.id + "][value=" + value[i] + "]").prop("checked", "checked");
                }
            }
        }
        else {
            if (value)
                this.inputControl.find("input[name=" + this.id + "][value=" + value + "]").prop("checked", "checked");
            else
                this.inputControl.find("input[name=" + this.id + "]").prop("checked", false);
        }
    }
    enable(enable) {
        if (enable)
            this.inputControl.find("input[name = " + this.id + "]").removeAttr("disabled");
        else
            this.inputControl.find("input[name = " + this.id + "]").attr("disabled", "disabled");
    }
    updateValue(updateField, valueOnly, updateDataPresentedInfo = true) {
        let that = this;
        let callback = function (datapresentedinfo) {
            updateField.datapresentedinfo = datapresentedinfo;
            that.controlType = updateField["controltype"];
            that.updateValueInternal(updateField, valueOnly);
        };
        if (updateDataPresentedInfo)
            that.clControlFactory.getComboboxInfo(updateField, updateField.value, callback);
        else
            callback(updateField.datapresentedinfo);
    }
    getIdPidMap() {
        let that = this;
        let dataItem;
        let values = that.clControlFactory.getAsArray(that.field.value);
        let idPidMap = [];
        if (values && values.length > 0) {
            $.each(values, (idx, value) => {
                if (that.field.datapresentedinfo && that.field.datapresentedinfo[value])
                    dataItem = that.field.datapresentedinfo[value];
                else
                    dataItem = { pid: $("input[name=" + that.id + "][value=" + value + "]").attr("cl_pid") };
                if (dataItem) {
                    idPidMap.push({ id: value, pids: dataItem["pid"] ? dataItem["pid"].split("|") : [""] });
                }
            });
        }
        return idPidMap;
    }
    updateDataSource(currentControlHasChanged) {
        this.resetData(undefined, undefined, undefined, currentControlHasChanged);
    }
}
exports.ClMVCheckBoxRadio = ClMVCheckBoxRadio;
class ClMultipleChoiceForQuestionnaire {
    constructor(prependId, fieldI, checklistControlFactoryI) {
        this.id = prependId;
        this.field = fieldI;
        this.checklistControlFactory = checklistControlFactoryI;
    }
    init(jQueryElem) {
        let that = this;
        let divContainer = $("<div id='" + that.id + "_item' class='checklistrow'/>").appendTo(jQueryElem);
        let container = $("<div id='" + that.id + "_inputitem' class='checklistinputrow'/>").appendTo(divContainer);
        container.attr("cl_fieldId", that.id);
        if ((that.checklistControlFactory.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
            if (that.checklistControlFactory.rowSpacing > 0) {
                container.css("padding-top", (this.checklistControlFactory.rowSpacing / 2).toString() + "px");
                container.css("padding-bottom", (this.checklistControlFactory.rowSpacing / 2).toString() + "px");
            }
            else {
                container.css("padding-top", "0px");
                container.css("padding-bottom", "0px");
            }
            if (that.checklistControlFactory.instance.fontsize)
                container.css("font-size", that.checklistControlFactory.instance.fontsize.toString() + "px");
        }
        let labelColumn = $("<div id='" + that.id + "_labeldiv' class='mclabel'/>").appendTo(container);
        // $("<label  id='" + that.id + "_cllabel' for='" + that.id + "' class='checklistlabel' />").appendTo(labelColumn);
        let labelControl = $("<div id='" + that.id + "_grouplabel' style='font-weight: bold;'></div>").appendTo(labelColumn);
        if (that.field.labelhorizontaloption && (that.field.labelhorizontaloption.toLowerCase() === "center" || that.field.labelhorizontaloption.toLowerCase() === "left" || that.field.labelhorizontaloption.toLowerCase() === "justify"))
            labelColumn.css("text-align", that.field.labelhorizontaloption.toLowerCase());
        else
            labelColumn.css("text-align", "right");
        if (that.field.labelverticaloption && (that.field.labelverticaloption.toLowerCase() === "middle" || that.field.labelverticaloption.toLowerCase() === "bottom"))
            labelColumn.css("vertical-align", that.field.labelverticaloption.toLowerCase());
        else
            labelColumn.css("vertical-align", "top");
        let label = that.checklistControlFactory.getLabel(that.field.labels, that.checklistControlFactory.userUILangId, that.checklistControlFactory.instance.langid);
        $(label).appendTo(labelControl);
        // if (label)
        //    $("#" + that.id + "_cllabel").text(label);
        let inputColumn = $("<div id='" + that.id + "_controldiv' class='questionnaireinput' '/>").appendTo(container);
        let type;
        if (that.field.multivalue)
            type = "checkbox";
        else
            type = "radio";
        let initializeControl = function (datacollection) {
            if (datacollection != undefined) {
                for (let index = 0; index < datacollection.length; ++index) {
                    let dataItem = datacollection[index];
                    let listControl = $("<div id='" + that.id + "_" + dataItem["id"] + "' class='questionnairecontainer'/>").appendTo(inputColumn);
                    listControl.attr("item_id", dataItem.id);
                    let iconContainer = $("<div id='" + that.id + "_" + dataItem["id"] + "_iconcontainer'  class='questionnaireiconcontainer'/>").appendTo(listControl);
                    let checkBox = $("<input id='" + that.id + "_" + dataItem["id"] + "_checklist' type='" + type + "' name='" + that.id + "' value='" + datacollection[index].id + "' class='clQuestionnaire' > <span class='checkmark'/>").appendTo(iconContainer);
                    let labelContainer = $("<div id='" + that.id + "_" + dataItem["id"] + "_labelcontainer' class='questionnaireitemlabelcontainer' />").appendTo(listControl);
                    let listLabel = $("<span class='questionnaireitemlabel'></span>").appendTo(labelContainer);
                    let labelControl = $("<label style='text-align:center; font-size:24px;' />").appendTo(listLabel);
                    if (that.checklistControlFactory.isHardDeleted(dataItem))
                        labelControl.addClass("clFtHardDeletedEntry");
                    if (that.checklistControlFactory.isSoftDeleted(dataItem) && that.checklistControlFactory.showDeletedWarning(dataItem))
                        labelControl.addClass("clFtSoftDeletedEntry");
                    if (that.checklistControlFactory.isAbstract(dataItem))
                        labelControl.addClass("clFtAbstractEntry");
                    labelControl.text(datacollection[index][that.field.datafield]);
                    listControl.on("click", (event) => {
                        let value = event.delegateTarget.getAttribute("item_id");
                        if (that.field.multivalue) {
                            let checkbox = $("input[name=" + that.id + "][value=" + value + "]");
                            if (checkbox.attr("checked") === "checked")
                                checkbox.removeAttr("checked");
                            else
                                checkbox.attr("checked", "checked");
                        }
                        else {
                            $("input[name=" + that.id + "][value=" + value + "]").prop("checked", "checked");
                        }
                        that.field.value = that.getValue();
                        // Update button visibility
                        if (that.getValue() != undefined) {
                            $("#" + that.checklistControlFactory.configData.nextButtonId).removeAttr("disabled");
                            $("#" + that.checklistControlFactory.configData.okButtonId).removeAttr("disabled");
                            $("#" + that.checklistControlFactory.configData.checkButtonId).removeAttr("disabled");
                        }
                        else {
                            $("#" + that.checklistControlFactory.configData.nextButtonId).attr("disabled", "disabled");
                            $("#" + that.checklistControlFactory.configData.okButtonId).attr("disabled", "disabled");
                            $("#" + that.checklistControlFactory.configData.checkButtonId).attr("disabled", "disabled");
                        }
                    });
                }
            }
        };
        that.checklistControlFactory.getDataList(initializeControl, that.field, undefined, undefined, undefined);
    }
    getValue() {
        let elem = $("#" + this.id);
        if (this.field.multivalue) {
            let i = 0;
            let values = [];
            let value = $("input[name='" + this.id + "']:checked").each(function () {
                values[i++] = $(this).val();
            });
            if (values.length > 0)
                return values;
            else
                return undefined;
        }
        else {
            let radio_value = $("input[name=" + this.id + "]:checked").val();
            return radio_value;
        }
    }
}
class ClMultipleChoice extends ClFieldControl {
    constructor(prependId, field, checklistControlFactory, levelcount) {
        super(prependId, field, checklistControlFactory, levelcount);
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        that.labelColumn.css("width", "100%");
        that.labelColumn.css("display", "block");
        $("#" + that.id + "_cllabel").css("font-weight", "bold");
        that.inputColumn.css("width", "100%");
        that.inputColumn.css("display", "block");
        that.inputColumn.css("padding-left", "25%");
        that.inputColumn.css("padding-right", "25%");
        that.inputColumn.css("padding-top", "10px");
        that.inputControl = $("<ul id='" + that.id + "' class='radiocontrols'/>").appendTo(that.controljQueryElem);
        let initializeControl = function (datacollection) {
            that.initInternal(datacollection);
            that.enable(!that.IsReadOnly());
            that.setVisibility(that.field.visible, that.field.show);
            that.highlightMandatory();
        };
        let pids = [];
        if (that.field.dependentfield) {
            if (that.ParentField) {
                if (that.parentIsValid())
                    pids = that.clControlFactory.getAsArray(that.ParentField.field.value);
                that.clControlFactory.getDataList(initializeControl, that.field, undefined, pids, undefined, that.keepIds, that.hardDeletedIds, false, false, that.invalidIds);
            }
        }
        else
            that.clControlFactory.getDataList(initializeControl, that.field, undefined, pids, undefined, that.keepIds, that.hardDeletedIds, false, false, that.invalidIds);
    }
    initInternal(datacollection, currentControlHasChanged = false) {
        let that = this;
        let type;
        if (that.field.multivalue)
            type = "checkbox";
        else
            type = "radio";
        if (datacollection != undefined) {
            if (currentControlHasChanged) {
                $.each(that.inputControl.children(), (idx, container) => {
                    let entryid = container.getAttribute("cl_entryid");
                    if (datacollection.findIndex(entry => entry["id"] === entryid) === -1) {
                        container.remove();
                    }
                });
            }
            else {
                that.inputControl.children().remove();
                for (let index = 0; index < datacollection.length; ++index) {
                    let dataItem = datacollection[index];
                    let listItem = $("<li class='clList' style='display:table;'/>").appendTo(that.inputControl);
                    listItem.attr("cl_entryid", dataItem.id);
                    let checkBox = $("<input id='" + that.id + "_" + dataItem["id"] + "' type='" + type + "' name='" + that.id + "' value='" + dataItem.id + "' class='clListItem' style='display:table-cell;'>"); // .appendTo(listItem);
                    checkBox.attr("cl_pid", dataItem["pid"]);
                    let labelControl = $("<label style='display:table-cell; vertical-align:middle;' for= '" + that.id + "_" + dataItem["id"] + "' id = '" + that.id + "_" + dataItem["id"] + "_label' />"); // .appendTo(listItem);
                    labelControl.text(dataItem[that.field.datafield]);
                    let showIcon = false;
                    let iconClass;
                    if (that.clControlFactory.isHardDeleted(dataItem)) {
                        labelControl.addClass("clFtHardDeletedEntry");
                        showIcon = true;
                        iconClass = "clFtHardDeletedEntry";
                    }
                    if (that.clControlFactory.isSoftDeleted(dataItem) && that.clControlFactory.showDeletedWarning(dataItem)) {
                        labelControl.addClass("clFtSoftDeletedEntry");
                        showIcon = true;
                        iconClass = "clFtSoftDeletedEntry";
                    }
                    if (that.clControlFactory.isAbstract(dataItem))
                        labelControl.addClass("clFtAbstractEntry");
                    if (that.ParentField) {
                        if (!that.parentIsValid() || that.invalidIds.indexOf(dataItem.id) !== -1) {
                            labelControl.addClass("clInvalidState");
                            showIcon = true;
                            iconClass = "clInvalidState";
                        }
                    }
                    if (showIcon) {
                        $("<i class='clbuttoncontainer fa fa-exclamation-triangle " + iconClass + "' aria-hidden='true' style='box-sizing:border-box;font-size: 1.5em;width: 1.5em;'></i>").appendTo(listItem);
                        labelControl.css("width", "calc(100% - 2em)");
                    }
                    else
                        labelControl.css("width", "100%");
                    checkBox.appendTo(listItem);
                    labelControl.appendTo(listItem);
                    checkBox.change(() => {
                        that.notifyChange();
                        $(that).trigger("controlValueChanged");
                    });
                }
            }
        }
        if (!currentControlHasChanged) {
            if ((that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
                that.setValue(that.field.correctvalues);
            else
                that.setValue(that.field.value);
        }
    }
    dataSortChanged() {
        this.resetData(undefined);
    }
    resetData(datacollection, textField, valueField, currentControlHasChanged = false) {
        let that = this;
        let type = "";
        if (that.field.multivalue)
            type = "checkbox";
        else
            type = "radio";
        if ((that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
            that.field.correctvalues = that.getValue();
        else
            that.field.value = that.getValue();
        if (that.field.datapresentedinfo) {
            $.each(that.field.datapresentedinfo, (key, value) => {
                if (that.clControlFactory.isSoftDeleted(value) || that.clControlFactory.isHardDeleted(value) || that.clControlFactory.isAbstract(value)) {
                    if (that.keepIds.indexOf(key) === -1)
                        that.keepIds.push(key);
                    if (that.clControlFactory.isHardDeleted(value)) {
                        if (that.hardDeletedIds.indexOf(key) === -1)
                            that.hardDeletedIds.push(key);
                    }
                }
            });
        }
        let callback = function (data) {
            that.initInternal(data, currentControlHasChanged);
        };
        let pids = [];
        if (that.field.dependentfield && that.ParentField) {
            pids = that.clControlFactory.getAsArray(that.ParentField.field.value);
        }
        that.clControlFactory.getDataList(callback, that.field, undefined, pids, undefined, that.keepIds, that.hardDeletedIds, false, false, that.invalidIds);
    }
    removeInvalidValues(dataCollection) {
        if (this.field.value) {
            if (this.field.multivalue) {
                let tmpMultiValues = JSON.parse(JSON.stringify(this.field.value));
                if (tmpMultiValues instanceof Array) {
                    this.field.value.splice(0, this.field.value.length);
                    $.each(tmpMultiValues, (idx, multiValue) => {
                        let valueInCollection = false;
                        $.each(dataCollection, (idx, entry) => {
                            if (entry["id"] === multiValue)
                                valueInCollection = true;
                        });
                        if (valueInCollection)
                            this.field.value.push(multiValue);
                    });
                }
                else {
                    this.field.value = undefined;
                    let valueInCollection = false;
                    $.each(dataCollection, (idx, entry) => {
                        if (entry["id"] === tmpMultiValues)
                            valueInCollection = true;
                    });
                    if (valueInCollection)
                        this.field.value = tmpMultiValues;
                }
            }
            else {
                let valueInCollection = false;
                $.each(dataCollection, (idx, entry) => {
                    if (entry["id"] === this.field.value)
                        valueInCollection = true;
                });
                if (!valueInCollection)
                    this.field.value = undefined;
            }
        }
    }
    getValue() {
        if (this.field.multivalue) {
            let i = 0;
            let values = [];
            let value = this.inputControl.find("input[name='" + this.id + "']:checked").each(function () {
                values[i++] = $(this).val();
            });
            if (values.length > 0)
                return values;
            else
                return undefined;
        }
        else {
            let radio_value = this.inputControl.find("input[name=" + this.id + "]:checked").val();
            return radio_value;
        }
    }
    setValue(value) {
        if (this.field.multivalue) {
            this.inputControl.find("input[name=" + this.id + "]").prop("checked", false);
            if (value instanceof Array) {
                for (let i = 0; i < value.length; i++) {
                    this.inputControl.find("input[name=" + this.id + "][value=" + value[i] + "]").prop("checked", "checked");
                }
            }
        }
        else {
            let correctvalue;
            if (value instanceof Array) {
                if (value.length === 1)
                    correctvalue = value[0];
            }
            else
                correctvalue = value;
            if (correctvalue)
                this.inputControl.find("input[name=" + this.id + "][value=" + correctvalue + "]").prop("checked", "checked");
            else
                this.inputControl.find("input[name=" + this.id + "]").prop("checked", false);
        }
        this.inputControl.trigger("clcontrolchange", this.field);
    }
    setFieldValue() {
        if ((this.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
            this.setValue(this.field.correctvalues);
        else
            this.setValue(this.field.value);
    }
    enable(enable) {
        if (enable)
            this.inputControl.find("input[name = " + this.id + "]").removeAttr("disabled");
        else
            this.inputControl.find("input[name = " + this.id + "]").attr("disabled", "disabled");
    }
    notifyChange(ignore = false) {
        // Override notifyChange for designer mode
        // designer mode correctvalues are used for control
        let that = this;
        if ((that.clControlFactory.Mode & ChecklistMode.Designer) === ChecklistMode.Designer)
            that.field.correctvalues = that.getValue();
        else
            that.field.value = that.getValue();
        that.removeNotNeededDataPresentedInfo();
        let checkFieldVisibilities = false;
        if (that.field.conrelfield || (that.clControlFactory.Mode & ChecklistMode.Preview) === ChecklistMode.Preview)
            checkFieldVisibilities = true;
        that.highlightMandatory();
        $("#" + that.id).trigger("clcontrolchange", that.field);
        if (!ignore) {
            if (that.field["linkedfield"] && (that.clControlFactory.Mode & ChecklistMode.Editor) === ChecklistMode.Editor) {
                let linkedFields = that.clControlFactory.GetLinkedFields(that.field["linkedfield"]);
                $.each(linkedFields, (idx, linkedField) => {
                    if (linkedField["id"] !== that.field["id"]) {
                        let control = that.clControlFactory.getFieldControl(linkedField["id"]);
                        linkedField.value = that.getValue();
                        if (control instanceof ClFieldControl) {
                            control.updateValue(linkedField, true);
                            let checkFieldVisibilities = false;
                            if (linkedField.conrelfield || (that.clControlFactory.Mode & ChecklistMode.Preview) === ChecklistMode.Preview)
                                checkFieldVisibilities = true;
                        }
                    }
                });
            }
        }
        if ((that.clControlFactory.Mode & ChecklistMode.Editor) === ChecklistMode.Editor)
            that.parentFieldControlHasChanged(true, true);
        if (checkFieldVisibilities)
            that.clControlFactory.checkFieldVisibilities();
        that.clControlFactory.setChecklistChanged(true);
    }
    updateValue(updateField, valueOnly, updateDataPresentedInfo = true) {
        let that = this;
        let callback = function (datapresentedinfo) {
            updateField.datapresentedinfo = datapresentedinfo;
            that.updateValueInternal(updateField, valueOnly);
        };
        if (updateDataPresentedInfo)
            that.clControlFactory.getComboboxInfo(updateField, updateField.value, callback);
        else
            callback(updateField.datapresentedinfo);
    }
    getIdPidMap() {
        let that = this;
        let dataItem;
        let values = that.clControlFactory.getAsArray(that.field.value);
        let idPidMap = [];
        if (values && values.length > 0) {
            $.each(values, (idx, value) => {
                if (that.field.datapresentedinfo && that.field.datapresentedinfo[value])
                    dataItem = that.field.datapresentedinfo[value];
                else
                    dataItem = { pid: this.inputControl.find("input[name=" + that.id + "][value=" + value + "]").attr("cl_pid") };
                if (dataItem) {
                    idPidMap.push({ id: value, pids: dataItem["pid"] ? dataItem["pid"].split("|") : [""] });
                }
            });
        }
        return idPidMap;
    }
    updateDataSource(currentControlHasChanged) {
        this.resetData(undefined, undefined, undefined, currentControlHasChanged);
    }
}
exports.ClMultipleChoice = ClMultipleChoice;
class ClCombobox extends ClMVableControl {
    constructor(prependId, field, checklistControlFactory, levelcount, rootControl, mvValue, invalidIds) {
        super(prependId, field, checklistControlFactory, levelcount, mvValue);
        this.hintIconClasses = [];
        this.rootControl = rootControl;
        this.checkEnter = false;
        if (invalidIds)
            this.invalidIds = invalidIds;
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        that.inputControl = $("<select id='" + that.id + "' class='clInput'/>").appendTo(that.controlContainer);
        let dataSet = that.field.dataname && that.field.datafield;
        if (that.field.multivalue) {
            if (that.isMultiValueControl) {
                if (dataSet) {
                    if (that.currentMV) {
                        let option = $("<option value='" + that.currentMV.id + "'></option>");
                        option.text(that.currentMV.value[that.field.datafield]);
                        that.inputControl.append(option);
                    }
                    else {
                        if (that.field.datapresentedinfo && that.field.datapresentedinfo[that.field.value]) {
                            let option = $("<option value='" + that.field.value + "'></option>");
                            option.text(that.field.datapresentedinfo[that.field.value][that.field.datafield]);
                            that.inputControl.append(option);
                        }
                    }
                }
                that.comboBox = that.inputControl.kendoComboBox({
                    dataTextField: that.field.datafield,
                    dataValueField: "id",
                    autoBind: false,
                    dataSource: new kendo.data.DataSource({
                        serverFiltering: true,
                        requestStart: function requestStart(e) {
                            "Method not implemented.";
                        },
                        requestEnd: function requestEnd(e) {
                            "Method not implemented.";
                        },
                        transport: {
                            read: function read(options) {
                                let callback = function (data) {
                                    options.success(data);
                                };
                                that.clControlFactory.getDataList(callback, that.field, undefined, undefined, options.data.filter, that.keepIds, that.hardDeletedIds);
                            },
                        }
                    }),
                    filter: "contains",
                    noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
                }).data("kendoComboBox");
                that.controlButton.on("click", function () {
                    // remove
                    that.rootControl.removeMultivalueInput(that);
                    that.rootControl.notifyChange();
                    let rootValue = that.rootControl.getCurrentValue();
                    if (rootValue != undefined)
                        that.rootControl.setButtonVisibility(rootValue);
                    $(that.rootControl).trigger("controlValueChanged");
                });
                that.enable(false);
                if (dataSet) {
                    if (that.currentMV)
                        that.updateEntryState(that.currentMV.value);
                    else if (that.field.datapresentedinfo && that.field.datapresentedinfo[that.field.value])
                        that.updateEntryState(that.field.datapresentedinfo[that.field.value]);
                }
            }
            else {
                let firstchange = true;
                that.comboBox = that.inputControl.kendoComboBox({
                    dataTextField: that.field.datafield,
                    dataValueField: "id",
                    autoBind: false,
                    dataSource: new kendo.data.DataSource({
                        serverFiltering: true,
                        requestStart: function requestStart(e) {
                            "Method not implemented.";
                        },
                        requestEnd: function requestEnd(e) {
                            "Method not implemented.";
                        },
                        transport: {
                            read: function read(options) {
                                let callback = function (data) {
                                    options.success(data);
                                };
                                let value;
                                if (options.data.filter && options.data.filter.filters && options.data.filter.filters.length === 0) {
                                    if (that.comboBox.dataItem())
                                        value = that.comboBox.value();
                                    else if (that.field.datapresentedinfo) {
                                        let currentValue = that.getCurrentValue();
                                        if (currentValue && that.field.datapresentedinfo[currentValue])
                                            value = currentValue;
                                    }
                                }
                                let pids = [];
                                if (that.field.dependentfield && that.ParentField) {
                                    if (that.parentIsValid())
                                        pids = that.clControlFactory.getAsArray(that.ParentField.field.value);
                                }
                                that.clControlFactory.getDataList(callback, that.field, value, pids, options.data.filter, that.keepIds, that.hardDeletedIds, false, false, that.invalidIds);
                            },
                        }
                    }),
                    filter: "contains",
                    noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
                    close(e) {
                        that.checkEnter = true;
                    },
                    open(e) {
                        that.checkEnter = false;
                        let combo = e.sender;
                        if (combo.select() < 0 && combo.input.val() === that.currentMV)
                            combo.input.val("");
                    },
                    change: (e) => {
                        firstchange = false;
                        let combo = e.sender;
                        let val = e.sender.value();
                        if (val && e.sender.dataItem()) {
                            that.setButtonVisibility(val);
                            if (!that.field.datapresentedinfo)
                                that.field.datapresentedinfo = {};
                            that.field.datapresentedinfo[val] = e.sender.dataItem();
                            that.field.datapresentedinfo[val][that.field.datafield] = e.sender.text();
                        }
                        else {
                            e.sender.select(-1);
                            that.controlButton.hide();
                        }
                        that.notifyChange();
                        that.updateEntryState();
                        that.setTelephoneButtonVisibility();
                        $(that).trigger("controlValueChanged");
                    },
                    select: (e) => {
                        let combo = e.sender;
                        let dataItem;
                        if (e.item)
                            dataItem = combo.dataItem(e.item.index());
                        that.updateEntryState(dataItem);
                    },
                    dataBound: (e) => {
                        let combo = e.sender;
                        let dataItem = combo.dataItem(combo.select());
                        that.updateEntryState(dataItem);
                    },
                    cascade: (e) => {
                        if (e["userTriggered"] === true && firstchange) {
                            if (!e.sender.value() && that.currentMV && !e.sender.dataItem() && e.sender.select() === -1) {
                                e.preventDefault();
                                e.sender.select(-1);
                                that.comboBox.trigger("change");
                            }
                        }
                    },
                }).data("kendoComboBox");
                if (that.field.value && dataSet)
                    that.setMultiValue(that.field.value);
                that.comboBox.input.on("keydown", (e) => {
                    if (e.keyCode === 13 && that.checkEnter && that.comboBox.dataItem()) {
                        that.controlButton.trigger("click");
                    }
                });
                that.controlButton.on("click", function () {
                    let val = that.comboBox.value();
                    if (val) {
                        // addchildcontrol
                        if (!that.field.datapresentedinfo)
                            that.field.datapresentedinfo = {};
                        that.field.datapresentedinfo[val] = that.comboBox.dataItem();
                        that.field.datapresentedinfo[val][that.field.datafield] = that.comboBox.text();
                        that.addMultiValue(val);
                        that.setValue("");
                        that.controlButton.hide();
                        that.notifyChange();
                        that.updateEntryState();
                        that.setTelephoneButtonVisibility();
                        $(that).trigger("controlValueChanged");
                    }
                });
                that.enable(!that.IsReadOnly());
            }
        }
        else {
            let firstchange = true;
            if (dataSet && that.field.datapresentedinfo && that.field.datapresentedinfo[that.field.value]) {
                let option = $("<option value='" + that.field.value + "'></option>");
                option.text(that.field.datapresentedinfo[that.field.value][that.field.datafield]);
                that.inputControl.append(option);
            }
            that.comboBox = that.inputControl.kendoComboBox({
                dataTextField: that.field.datafield,
                dataValueField: "id",
                autoBind: false,
                clearButton: false,
                dataSource: new kendo.data.DataSource({
                    serverFiltering: true,
                    requestStart: function requestStart(e) {
                        "Method not implemented.";
                    },
                    requestEnd: function requestEnd(e) {
                        "Method not implemented.";
                    },
                    transport: {
                        read: function read(options) {
                            let callback = function (data) {
                                if (data)
                                    options.success(data);
                                else
                                    options.success([]);
                            };
                            let value;
                            if (options.data.filter && options.data.filter.filters && options.data.filter.filters.length === 0) {
                                if (that.inputControl.data("kendoComboBox").dataItem())
                                    value = that.inputControl.data("kendoComboBox").value();
                                else if (that.field.datapresentedinfo) {
                                    let currentValue = that.getCurrentValue();
                                    if (currentValue && that.field.datapresentedinfo[currentValue])
                                        value = currentValue;
                                }
                            }
                            let pids;
                            if (that.field.dependentfield && that.ParentField) {
                                if (that.parentIsValid())
                                    pids = that.clControlFactory.getAsArray(that.ParentField.field.value);
                            }
                            that.clControlFactory.getDataList(callback, that.field, value, pids, options.data.filter, that.keepIds, that.hardDeletedIds, false, false, that.invalidIds);
                        },
                    }
                }),
                change: (e) => {
                    firstchange = false;
                    let val = e.sender.value();
                    if (!that.field.datapresentedinfo)
                        that.field.datapresentedinfo = {};
                    if (e.sender.dataItem() || !val) {
                        if (val) {
                            that.field.datapresentedinfo[val] = e.sender.dataItem();
                            that.field.datapresentedinfo[val][that.field.datafield] = e.sender.text();
                        }
                    }
                    else
                        e.sender.select(-1);
                    that.notifyChange();
                    that.updateEntryState();
                    that.setTelephoneButtonVisibility();
                    $(that).trigger("controlValueChanged");
                },
                select: (e) => {
                    let combo = e.sender;
                    let dataItem;
                    if (e.item)
                        dataItem = combo.dataItem(e.item.index());
                    that.updateEntryState(dataItem);
                },
                cascade: (e) => {
                    if (e["userTriggered"] === true && firstchange) {
                        if (!e.sender.value() && that.field.value && !e.sender.dataItem() && e.sender.select() === -1) {
                            e.preventDefault();
                            e.sender.select(-1);
                            that.comboBox.trigger("change");
                        }
                    }
                },
                dataBound: (e) => {
                    let combo = e.sender;
                    let dataItem = combo.dataItem(combo.select());
                    that.updateEntryState(dataItem);
                },
                open: (e) => {
                    let combo = e.sender;
                    if (combo.select() < 0 && combo.input.val() == that.field.value)
                        combo.input.val("");
                },
                filter: "contains",
                noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            }).data("kendoComboBox");
            that.enable(!that.IsReadOnly());
            if (dataSet && that.field.datapresentedinfo && that.field.datapresentedinfo[that.field.value])
                that.updateEntryState(that.field.datapresentedinfo[that.field.value]);
        }
        that.telephoneButton.on("click", function () {
            let dataItem;
            let value = that.getCurrentValue();
            if (that.field.datapresentedinfo && that.field.datapresentedinfo[value])
                dataItem = that.field.datapresentedinfo[value];
            else
                dataItem = that.comboBox.dataItem();
            if (dataItem && dataItem[that.field["telnrcolumn"]])
                that.clControlFactory.executeTelLink(dataItem[that.field["telnrcolumn"]]);
        });
        if (!that.isMultiValueControl) {
            that.highlightMandatory();
            that.setVisibility(that.field.visible, that.field.show);
        }
        that.setTelephoneButtonVisibility();
    }
    resetData() {
        this.comboBox.refresh();
    }
    dataSortChanged() {
        this.comboBox.refresh();
    }
    removeInvalidValues(dataCollection) {
        if (this.field.value) {
            if (this.field.multivalue) {
                let tmpMultiValues = JSON.parse(JSON.stringify(this.field.value));
                if (tmpMultiValues instanceof Array) {
                    this.field.value.splice(0, this.field.value.length);
                    $.each(tmpMultiValues, (idx, multiValue) => {
                        let valueInCollection = false;
                        $.each(dataCollection, (idx, entry) => {
                            if (entry["id"] === multiValue)
                                valueInCollection = true;
                        });
                        if (valueInCollection)
                            this.field.value.push(multiValue);
                    });
                }
                else {
                    this.field.value = undefined;
                    let valueInCollection = false;
                    $.each(dataCollection, (idx, entry) => {
                        if (entry["id"] === tmpMultiValues)
                            valueInCollection = true;
                    });
                    if (valueInCollection)
                        this.field.value = tmpMultiValues;
                }
            }
            else {
                let valueInCollection = false;
                $.each(dataCollection, (idx, entry) => {
                    if (entry["id"] === this.field.value)
                        valueInCollection = true;
                });
                if (!valueInCollection)
                    this.field.value = undefined;
            }
        }
    }
    getCurrentValue() {
        if (this.comboBox) {
            let value = this.comboBox.value();
            if (this.comboBox.dataItem() || this.isMultiValueControl || (value && this.field.datapresentedinfo && this.field.datapresentedinfo[value]))
                return value;
        }
        return undefined;
    }
    getValue() {
        let that = this;
        if (this.field.multivalue && !that.isMultiValueControl) {
            let values = [];
            let singlevalue = that.getCurrentValue();
            let multivalues = that.getMultiValue();
            if (multivalues) {
                multivalues.forEach((item) => {
                    values.push(item);
                });
            }
            if (singlevalue) {
                let bAdd = true;
                if (values.length > 0) {
                    values.forEach((item) => {
                        if (item === singlevalue)
                            bAdd = false;
                    });
                }
                if (bAdd)
                    values.push(singlevalue);
            }
            if (!values || values.length === 0)
                return undefined;
            else {
                return values;
            }
        }
        else
            return that.getCurrentValue();
    }
    getMultiValue() {
        let values = [];
        for (let i = 0; i < this.multiValues.allControls.length; ++i) {
            values.push(this.multiValues.allControls[i].getValue());
        }
        if (values.length > 0)
            return values;
        else
            return undefined;
    }
    getText() {
        return this.comboBox.text();
    }
    addMultiValue(value) {
        let that = this;
        if (value) {
            if (that.field.multivalue) {
                if (value instanceof Array) {
                    $.each(value, (idx, val) => {
                        let bAdd = true;
                        for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                            if (that.multiValues.allControls[i].getValue() === val)
                                bAdd = false;
                        }
                        if (bAdd) {
                            let guid = Utilities_1.synUtil.getGUID(true);
                            let multiValInput = new ClCombobox(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that, { id: val, value: that.field.datapresentedinfo[val] }, that.invalidIds);
                            multiValInput.setPageId(that.pageId);
                            multiValInput.init(that.multivalueContainer);
                            that.multiValues.pushControl(multiValInput);
                        }
                    });
                }
                else {
                    let bAdd = true;
                    for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                        if (that.multiValues.allControls[i].getValue() === value)
                            bAdd = false;
                    }
                    if (bAdd) {
                        let guid = Utilities_1.synUtil.getGUID(true);
                        let multiValInput = new ClCombobox(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that, { id: value, value: that.field.datapresentedinfo[value] }, that.invalidIds);
                        multiValInput.setPageId(that.pageId);
                        multiValInput.init(that.multivalueContainer);
                        that.multiValues.pushControl(multiValInput);
                    }
                }
            }
        }
    }
    updateValue(updateField, valueOnly, updateDataPresentedInfo = true) {
        let that = this;
        let callback = function (datapresentedinfo) {
            updateField.datapresentedinfo = datapresentedinfo;
            that.updateValueInternal(updateField, valueOnly);
            if (datapresentedinfo && datapresentedinfo[that.field.value])
                that.updateEntryState(datapresentedinfo[that.field.value]);
            else
                that.updateEntryState();
        };
        if (updateDataPresentedInfo)
            that.clControlFactory.getComboboxInfo(updateField, updateField.value, callback);
        else
            callback(updateField.datapresentedinfo);
    }
    setValue(value) {
        if (value)
            this.comboBox.value(value);
        else
            // eslint-disable-next-line no-null/no-null
            this.comboBox.value(null);
    }
    enable(enable) {
        super.enable(enable);
        enable = enable && !this.clControlFactory.ReadOnly;
        this.inputControl.prop("readonly", !enable);
        this.comboBox.enable(enable);
        let target = this.comboBox.input.closest(".k-input");
        if (enable) {
            target.removeClass("clReadOnly");
            this.comboBox.wrapper.show();
        }
        else {
            target.addClass("clReadOnly");
            if (this.field.multivalue && this.hasValue() && !this.getCurrentValue())
                this.comboBox.wrapper.hide();
        }
    }
    highlightMandatory() {
        let target = this.comboBox.input.closest(".k-input");
        if (this.field.mandatory && !this.hasValue())
            target.addClass("clMandatory");
        else
            target.removeClass("clMandatory");
    }
    updateDataSource() {
        let that = this;
        if (that.field.multivalue) {
            $.each(that.multiValues.allControls, (_idx, mvControl) => {
                mvControl.invalidIds = that.invalidIds;
                mvControl.updateEntryState();
            });
        }
        that.updateEntryState();
        this.comboBox.dataSource.fetch(function () {
            let data = this.data();
        });
    }
    updateEntryState(datapresentedInfo, valid = true) {
        let that = this;
        if (typeof that.comboBox === "undefined")
            return;
        let dataItem = datapresentedInfo || that.comboBox.dataItem();
        if (!dataItem && that.isMultiValueControl)
            dataItem = that.field.datapresentedinfo[that.getCurrentValue()];
        if (this.clControlFactory.isHardDeleted(dataItem)) {
            that.comboBox.input.addClass("clFtHardDeletedEntry");
            if (that.hintIconClasses.indexOf("clFtHardDeletedEntry") === -1)
                that.hintIconClasses.push("clFtHardDeletedEntry");
        }
        else {
            that.comboBox.input.removeClass("clFtHardDeletedEntry");
            let idx = that.hintIconClasses.indexOf("clFtHardDeletedEntry");
            if (idx !== -1)
                that.hintIconClasses.splice(idx, 1);
        }
        if (this.clControlFactory.isSoftDeleted(dataItem) && this.clControlFactory.showDeletedWarning(dataItem)) {
            that.comboBox.input.addClass("clFtSoftDeletedEntry");
            if (that.hintIconClasses.indexOf("clFtSoftDeletedEntry") === -1)
                that.hintIconClasses.push("clFtSoftDeletedEntry");
        }
        else {
            that.comboBox.input.removeClass("clFtSoftDeletedEntry");
            let idx = that.hintIconClasses.indexOf("clFtSoftDeletedEntry");
            if (idx !== -1)
                that.hintIconClasses.splice(idx, 1);
        }
        let currentValue = that.getCurrentValue();
        if (currentValue) {
            if (that.invalidIds.indexOf(currentValue) === -1) {
                that.comboBox.input.removeClass("clInvalidState");
                let idx = that.hintIconClasses.indexOf("clInvalidState");
                if (idx !== -1)
                    that.hintIconClasses.splice(idx, 1);
            }
            else {
                that.comboBox.input.addClass("clInvalidState");
                if (that.hintIconClasses.indexOf("clInvalidState") === -1)
                    that.hintIconClasses.push("clInvalidState");
            }
        }
        else {
            that.comboBox.input.removeClass("clInvalidState");
            let idx = that.hintIconClasses.indexOf("clInvalidState");
            if (idx !== -1)
                that.hintIconClasses.splice(idx, 1);
        }
        that.showHintIcon();
        let target = that.comboBox.input.closest(".k-input");
        if (that.clControlFactory.isAbstract(dataItem))
            target.addClass("clFtAbstractEntryComboBox");
        else
            target.removeClass("clFtAbstractEntryComboBox");
    }
    showHintIcon() {
        let that = this;
        if (that.hintIconClasses && that.hintIconClasses.length > 0) {
            if (that.hintIcon) {
                that.hintIcon.removeClass("clFtHardDeletedEntry");
                that.hintIcon.removeClass("clFtSoftDeletedEntry");
                that.hintIcon.removeClass("clInvalidState");
            }
            else {
                that.hintIcon = $("<i class='clbuttoncontainer fa fa-exclamation-triangle' aria-hidden='true' style='box-sizing:border-box;font-size: 1.5em;width: 1.5em;display: table-cell;'></i>");
                that.hintIcon.insertBefore(that.controlContainer);
            }
            $.each(that.hintIconClasses, (idx, iconClass) => {
                that.hintIcon.addClass(iconClass);
            });
        }
        else {
            if (that.hintIcon) {
                that.hintIcon.remove();
                that.hintIcon = undefined;
            }
        }
    }
    setTelephoneButtonVisibility() {
        let that = this;
        if (this.field["istelnr"] && this.field["telnrcolumn"]) {
            let dataItem;
            let value = that.getCurrentValue();
            if (value) {
                if (that.field.datapresentedinfo && that.field.datapresentedinfo[value])
                    dataItem = that.field.datapresentedinfo[value];
                else
                    dataItem = that.comboBox.dataItem();
            }
            if (this.field["istelnr"] && this.field["telnrcolumn"] && dataItem && dataItem[that.field["telnrcolumn"]] && this.clControlFactory.filterTelephoneNumber(dataItem[that.field["telnrcolumn"]]))
                this.telephoneButtonContainer.show();
            else
                this.telephoneButtonContainer.hide();
        }
        else
            this.telephoneButtonContainer.hide();
    }
    getIdPidMap() {
        let that = this;
        let dataItem;
        let values = that.clControlFactory.getAsArray(that.field.value);
        let idPidMap = [];
        if (values && values.length > 0) {
            $.each(values, (idx, value) => {
                if (that.field.datapresentedinfo && that.field.datapresentedinfo[value])
                    dataItem = that.field.datapresentedinfo[value];
                else
                    dataItem = that.comboBox.dataItem();
                if (dataItem) {
                    idPidMap.push({ id: value, pids: dataItem["pid"] ? dataItem["pid"].split("|") : [""] });
                }
            });
        }
        return idPidMap;
    }
}
exports.ClCombobox = ClCombobox;
class ClSRCombobox {
    constructor(id, field, checklistControlFactory, rootControl, isLastElem, initvalue, data) {
        this.hintIconClasses = [];
        this.initValue = initvalue;
        this.id = id;
        this.dataname = field.dataname;
        this.datafield = field.datafield;
        this.field = field;
        this.checklistControlFactory = checklistControlFactory;
        this.data = data;
        this.parentElem = rootControl;
        this.keepIds = [];
        this.hardDeletedIds = [];
    }
    init(jQueryElem) {
        let that = this;
        that.controlContainer = $("<div style='width: 100%'/>").appendTo(jQueryElem);
        that.inputControl = $("<select id='" + that.id + "' class='clInput srcmbbox' />").appendTo(that.controlContainer);
        if (that.initValue) {
            let option = $("<option value='" + that.initValue["id"] + "' selected='selected'></option>");
            option.text(that.initValue[that.field.datafield]);
            that.inputControl.append(option);
            if (that.initValue.softDeleted || that.initValue.hardDeleted || that.initValue.isAbstract) {
                that.keepIds.push(that.initValue["id"]);
                if (that.initValue.hardDeleted)
                    that.hardDeletedIds.push(that.initValue["id"]);
            }
        }
        let id = that.initValue;
        let firstchange = true;
        that.kendoCmbBox = that.inputControl.kendoComboBox({
            dataTextField: that.datafield,
            dataValueField: "id",
            autoBind: false,
            dataSource: new kendo.data.DataSource({
                serverFiltering: true,
                requestStart: function requestStart(e) {
                    "Method not implemented.";
                },
                requestEnd: function requestEnd(e) {
                    "Method not implemented.";
                },
                transport: {
                    read: function read(options) {
                        let currentId = "";
                        if (that.kendoCmbBox.value() && that.kendoCmbBox.text())
                            currentId = that.kendoCmbBox.value();
                        let callback = function (data) {
                            options.success(data);
                        };
                        let pids = [];
                        if (!currentId) {
                            let idx = that.parentElem.childElems.indexOf(that);
                            if (idx === that.parentElem.childElems.length - 1) {
                                let singleValue = that.parentElem.getSingleValue();
                                if (singleValue)
                                    pids.push(singleValue);
                            }
                            else if (idx > 0) {
                                let singleValue = that.parentElem.childElems[idx - 1].getCurrentValue();
                                if (singleValue)
                                    pids.push(singleValue);
                            }
                        }
                        that.checklistControlFactory.getDataList(callback, that.field, currentId, pids, options.data.filter, that.keepIds, that.hardDeletedIds, true, true);
                    },
                }
            }),
            filter: "contains",
            noDataTemplate: kendo.htmlEncode(Utilities_1.synUtil.Strings.getValue("dynpnomatchingitemfound")),
            change: (e) => {
                firstchange = false;
                let combo = e.sender;
                let val = e.sender.value();
                that.initValue = undefined;
                if (!(!e.sender.dataItem() || val)) {
                    val = undefined;
                    e.sender.select(-1);
                }
                let idx = that.parentElem.childElems.indexOf(that);
                let isLastElem = idx === that.parentElem.childElems.length - 1;
                that.parentElem.selectionChanged(isLastElem, that.id, val, e.sender.text());
                that.updateEntryState();
            },
            select: (e) => {
                let combo = e.sender;
                let dataItem;
                if (e.item)
                    dataItem = combo.dataItem(e.item.index());
                that.updateEntryState(dataItem);
            },
            dataBound: (e) => {
                let combo = e.sender;
                let dataItem = combo.dataItem(combo.select());
                that.updateEntryState(dataItem);
            }, cascade: (e) => {
                if (e["userTriggered"] === true && firstchange) {
                    if (!e.sender.value() && !e.sender.dataItem() && e.sender.select() === -1) {
                        e.preventDefault();
                        e.sender.select(-1);
                        that.kendoCmbBox.trigger("change");
                    }
                }
            },
            open: (e) => {
                let combo = e.sender;
                if (combo.select() < 0) {
                    let val = combo.input.val().toString();
                    if (val && this.initValue && val === this.initValue.id)
                        combo.input.val("");
                }
            },
        }).data("kendoComboBox");
        if (that.parentElem && that.parentElem.isMultiValueControl)
            that.enable(false);
        else
            that.enable(!that.IsReadOnly());
        if (that.initValue) {
            let option = $("<option value='" + that.initValue["id"] + "' selected='selected'></option>");
            option.text(that.initValue[that.field.datafield]);
            that.inputControl.append(option);
        }
        that.updateEntryState(that.initValue);
    }
    IsReadOnly() {
        return this.field.readonly || this.checklistControlFactory.ReadOnly;
    }
    addChild() {
        "Method not implemented.";
    }
    getInputControl() {
        return this.inputControl;
    }
    resetData(data) {
        let that = this;
        that.data = data;
        that.kendoCmbBox.setDataSource(new kendo.data.DataSource({ data }));
    }
    dataSortChanged() {
        let that = this;
        that.kendoCmbBox.dataSource.read();
    }
    isAbstract() {
        let dataItem = this.initValue || this.kendoCmbBox.dataItem();
        if (dataItem)
            return this.checklistControlFactory.isAbstract(dataItem);
        return true;
    }
    isSoftDeleted() {
        let dataItem = this.initValue || this.kendoCmbBox.dataItem();
        if (dataItem)
            return this.checklistControlFactory.isSoftDeleted(dataItem) && this.checklistControlFactory.showDeletedWarning(dataItem);
        return true;
    }
    getValue() {
        let that = this;
        if (that.kendoCmbBox.selectedIndex !== -1 || that.initValue)
            return that.kendoCmbBox.value();
        else
            return undefined;
    }
    enable(enable) {
        enable = enable && !this.checklistControlFactory.ReadOnly;
        this.inputControl.prop("readonly", !enable);
        this.kendoCmbBox.enable(enable);
        let target = this.kendoCmbBox.input.closest(".k-input");
        if (enable)
            target.removeClass("clReadOnly");
        else
            target.addClass("clReadOnly");
    }
    setValue(value) {
        if (value)
            this.kendoCmbBox.value(value);
        else
            // eslint-disable-next-line no-null/no-null
            this.kendoCmbBox.value(null);
    }
    getCurrentValue() {
        let val;
        if (this.kendoCmbBox)
            val = this.kendoCmbBox.value();
        if (val && this.kendoCmbBox.dataItem() || (this.initValue && this.initValue["id"] === val))
            return val;
        else
            return undefined;
    }
    resizeElem(childElemCount) {
        let offset = childElemCount * 10;
        this.kendoCmbBox.wrapper.css("width", "calc(100% - " + offset.toString() + "px)");
        this.kendoCmbBox.wrapper.css("min-width", "30%");
    }
    updateEntryState(datapresentedInfo) {
        let that = this;
        let combo = that.kendoCmbBox;
        if (typeof combo === "undefined")
            return;
        let dataItem = datapresentedInfo || combo.dataItem();
        if (that.checklistControlFactory.isHardDeleted(dataItem)) {
            combo.input.addClass("clFtHardDeletedEntry");
            if (that.hintIconClasses.indexOf("clFtHardDeletedEntry") === -1)
                that.hintIconClasses.push("clFtHardDeletedEntry");
        }
        else {
            combo.input.removeClass("clFtHardDeletedEntry");
            let idx = that.hintIconClasses.indexOf("clFtHardDeletedEntry");
            if (idx !== -1)
                that.hintIconClasses.splice(idx, 1);
        }
        if (that.checklistControlFactory.isSoftDeleted(dataItem) && that.checklistControlFactory.showDeletedWarning(dataItem)) {
            combo.input.addClass("clFtSoftDeletedEntry");
            if (that.hintIconClasses.indexOf("clFtSoftDeletedEntry") === -1)
                that.hintIconClasses.push("clFtSoftDeletedEntry");
        }
        else {
            combo.input.removeClass("clFtSoftDeletedEntry");
            let idx = that.hintIconClasses.indexOf("clFtSoftDeletedEntry");
            if (idx !== -1)
                that.hintIconClasses.splice(idx, 1);
        }
        that.showHintIcon();
        let target = that.kendoCmbBox.input.closest(".k-input");
        if (that.checklistControlFactory.isAbstract(dataItem))
            target.addClass("clFtAbstractEntryComboBox");
        else
            target.removeClass("clFtAbstractEntryComboBox");
        // Check if parent is abstract
        if (!that.getCurrentValue() && (that.parentElem.isParentValueAbstract(this) || that.parentElem.isParentValueSoftDeleted(this)))
            target.addClass("clSRMandatory");
        else
            target.removeClass("clSRMandatory");
    }
    showHintIcon() {
        let that = this;
        if (that.hintIconClasses && that.hintIconClasses.length > 0) {
            if (that.hintIcon) {
                that.hintIcon.removeClass("clFtHardDeletedEntry");
                that.hintIcon.removeClass("clFtSoftDeletedEntry");
                that.hintIcon.removeClass("clInvalidState");
            }
            else {
                that.hintIcon = $("<i class='clbuttoncontainer fa fa-exclamation-triangle' aria-hidden='true' style='box-sizing:border-box;font-size: 1.5em;width: 1.5em;display: table-cell;'></i>");
                that.hintIcon.insertBefore(that.controlContainer);
            }
            $.each(that.hintIconClasses, (idx, iconClass) => {
                that.hintIcon.addClass(iconClass);
            });
            that.controlContainer.addClass("clSRContainerWithIcon");
        }
        else {
            if (that.hintIcon) {
                that.hintIcon.remove();
                that.hintIcon = undefined;
            }
            that.controlContainer.removeClass("clSRContainerWithIcon");
        }
    }
    setMandatory(mandatory) {
        let target = this.kendoCmbBox.input.closest(".k-input");
        if (mandatory)
            target.addClass("clMandatory");
        else
            target.removeClass("clMandatory");
    }
    remove() {
        this.kendoCmbBox.destroy();
        this.kendoCmbBox.wrapper.remove();
        this.controlContainer.remove();
        if (this.hintIcon)
            this.hintIcon.remove();
    }
}
exports.ClSRCombobox = ClSRCombobox;
class ClSRComboboxContainer extends ClMVableControl {
    constructor(prependId, field, checklistControlFactory, levelcount, rootControl, mvValue) {
        super(prependId, field, checklistControlFactory, levelcount, mvValue);
        let index;
        this.rootControl = rootControl;
        this.childElems = new Array();
        if (mvValue)
            this.fieldValue = mvValue;
        else
            this.fieldValue = this.field.value;
    }
    init(jQueryElem) {
        let that = this;
        super.init(jQueryElem);
        that.comboboxContainer = $("<div id='" + that.id + "_srmvcontainer' class='srmvcontainer' />").appendTo(that.controlContainer);
        that.selectionContainer = $("<div id='" + that.id + "_srselcontainer' class='srselcontainer' />").appendTo(that.controlContainer);
        that.initInternal(that);
    }
    initInternal(that) {
        let dataSet = that.field.dataname && that.field.datafield;
        if (!that.field.multivalue) {
            if (dataSet)
                that.setValue(that.fieldValue);
            that.enable(!that.IsReadOnly());
            that.setVisibility(that.field.visible, that.field.show);
            that.highlightMandatory();
        }
        else {
            if (that.isMultiValueControl) {
                if (dataSet)
                    that.setValue(that.currentMV);
                that.controlButton.on("click", function () {
                    // remove
                    that.rootControl.removeMultivalueInput(that);
                    that.rootControl.notifyChange();
                    that.highlightMandatory();
                    let rootControlValue;
                    if (that.rootControl.childElems && that.rootControl.childElems.length > 0)
                        rootControlValue = that.rootControl.childElems[that.rootControl.childElems.length - 1].getValue();
                    if (!rootControlValue) {
                        if (that.rootControl.lastElem)
                            rootControlValue = that.rootControl.lastElem.getValue();
                    }
                    if (rootControlValue)
                        that.rootControl.setButtonVisibility(rootControlValue);
                    $(that.rootControl).trigger("controlValueChanged");
                });
                that.enable(false);
            }
            else {
                if (dataSet)
                    that.setMultiValue(that.fieldValue);
                that.controlButton.on("click", function () {
                    let val = that.getSingleValue();
                    // get selfrefstructure
                    if (val) {
                        // addchildcontrol
                        let callback = function (datapresentedinfo) {
                            if (!that.field.datapresentedinfo)
                                that.field.datapresentedinfo = {};
                            $.each(datapresentedinfo, (key, value) => {
                                that.field.datapresentedinfo[key] = value;
                            });
                            that.addMultiValue(val);
                            that.controlButton.hide();
                            that.notifyChange();
                            that.setTelephoneButtonVisibility();
                            $(that).trigger("controlValueChanged");
                        };
                        that.clControlFactory.getComboboxInfo(that.field, val, callback);
                    }
                });
                that.setVisibility(that.field.visible, that.field.show);
                that.enable(!that.IsReadOnly());
                that.highlightMandatory();
            }
        }
        that.telephoneButton.on("click", function () {
            let dataItem;
            let value = that.getSingleValue();
            if (value && that.field.datapresentedinfo && that.field.datapresentedinfo[value] && that.field.datapresentedinfo[value].find(entry => entry["id"] === value))
                dataItem = that.field.datapresentedinfo[value].find(entry => entry["id"] === value);
            else
                dataItem = that.getSingleDataItem();
            if (dataItem && dataItem[that.field["telnrcolumn"]])
                that.clControlFactory.executeTelLink(dataItem[that.field["telnrcolumn"]]);
        });
        that.setTelephoneButtonVisibility();
    }
    getRootControl() {
        return this.clControlFactory.getFieldControl(this.id);
    }
    getMultiValue() {
        let values = [];
        for (let i = 0; i < this.multiValues.allControls.length; ++i) {
            values.push(this.multiValues.allControls[i].getValue());
        }
        if (values.length > 0)
            return values;
        else
            return undefined;
    }
    getSingleValue() {
        let that = this;
        let value;
        if (that.childElems && that.childElems.length > 0) {
            for (let idx = that.childElems.length - 1; idx >= 0; --idx) {
                let tmpValue = that.childElems[idx].getValue();
                if (tmpValue)
                    return tmpValue;
            }
        }
        return undefined;
    }
    getSingleDataItem() {
        let that = this;
        let value;
        if (that.childElems && that.childElems.length > 0) {
            for (let idx = that.childElems.length - 1; idx >= 0; --idx) {
                let tmpValue = that.childElems[idx].getValue();
                if (tmpValue) {
                    return that.childElems[idx].kendoCmbBox.dataItem(); // $("#" + that.childElems[idx].id).data("kendoComboBox").dataItem();
                }
            }
        }
        else
            value = undefined;
    }
    isSingleValueAbstract() {
        let that = this;
        if (that.childElems && that.childElems.length > 0) {
            for (let idx = that.childElems.length - 1; idx >= 0; --idx) {
                let tmpValue = that.childElems[idx].getValue();
                if (tmpValue)
                    return that.childElems[idx].isAbstract();
            }
        }
        return false;
    }
    isSingleValueSoftDeleted() {
        let that = this;
        if (that.childElems && that.childElems.length > 0) {
            for (let idx = that.childElems.length - 1; idx >= 0; --idx) {
                let tmpValue = that.childElems[idx].getValue();
                if (tmpValue)
                    return that.childElems[idx].isSoftDeleted();
            }
        }
        return false;
    }
    hasAbstractValue() {
        let that = this;
        let bReturn = false;
        bReturn = that.isSingleValueAbstract();
        if (!bReturn && that.multiValues.allControls && that.multiValues.allControls.length > 0) {
            $.each(that.multiValues.allControls, (idx, mvControl) => {
                if (!bReturn) {
                    if (mvControl instanceof ClSRComboboxContainer) {
                        bReturn = mvControl.isSingleValueAbstract();
                    }
                }
            });
        }
        return bReturn;
    }
    hasSoftDeletedValue() {
        let that = this;
        let bReturn = false;
        bReturn = that.isSingleValueSoftDeleted();
        if (!bReturn && that.multiValues.allControls && that.multiValues.allControls.length > 0) {
            $.each(that.multiValues.allControls, (idx, mvControl) => {
                if (!bReturn) {
                    if (mvControl instanceof ClSRComboboxContainer) {
                        bReturn = mvControl.isSingleValueSoftDeleted();
                    }
                }
            });
        }
        return bReturn;
    }
    isParentValueAbstract(cmbBox) {
        let that = this;
        if (that.childElems && that.childElems.length > 1) {
            let idx = that.childElems.indexOf(cmbBox);
            if (idx === -1)
                return that.childElems[that.childElems.length - 1].isAbstract();
            else {
                if (idx > 0)
                    return that.childElems[idx - 1].isAbstract();
            }
        }
        return false;
    }
    isParentValueSoftDeleted(cmbBox) {
        let that = this;
        if (that.childElems && that.childElems.length > 1) {
            let idx = that.childElems.indexOf(cmbBox);
            if (idx === -1)
                return that.childElems[that.childElems.length - 1].isSoftDeleted();
            else {
                if (idx > 0)
                    return that.childElems[idx - 1].isSoftDeleted();
            }
        }
        return false;
    }
    getCurrentValue() {
        let that = this;
        let value;
        if (this.field.multivalue && !that.isMultiValueControl) {
            let values = [];
            let singlevalue = that.getSingleValue();
            let multivalues = that.getMultiValue();
            if (multivalues) {
                multivalues.forEach((item) => {
                    values.push(item);
                });
            }
            if (singlevalue) {
                let bAdd = true;
                if (values.length > 0) {
                    values.forEach((item) => {
                        if (item === singlevalue)
                            bAdd = false;
                    });
                }
                if (bAdd)
                    values.push(singlevalue);
            }
            if (!values || values.length === 0)
                return undefined;
            else
                return values;
        }
        else {
            value = that.getSingleValue();
        }
        return value;
    }
    getValue() {
        let that = this;
        let value;
        if (this.field.multivalue && !that.isMultiValueControl) {
            let values = [];
            let singlevalue = that.getSingleValue();
            let multivalues = that.getMultiValue();
            if (multivalues) {
                multivalues.forEach((item) => {
                    values.push(item);
                });
            }
            if (singlevalue) {
                let bAdd = true;
                if (values.length > 0) {
                    values.forEach((item) => {
                        if (item === singlevalue)
                            bAdd = false;
                    });
                }
                if (bAdd)
                    values.push(singlevalue);
            }
            if (!values || values.length === 0)
                return undefined;
            else
                return values;
        }
        else {
            if (that.childElems && that.childElems.length > 0) {
                value = that.getSingleValue();
            }
            else
                value = undefined;
        }
        return value;
    }
    setValue(value) {
        let that = this;
        if (that.childElems && that.childElems.length > 0) {
            for (let j = 0; j < that.childElems.length; ++j) {
                that.childElems[j].remove();
            }
            that.childElems.splice(0);
        }
        let addChildrenCallBack = function () {
            if (that.field.datapresentedinfo && !$.isEmptyObject(that.field.datapresentedinfo)) {
                $.each(that.field.datapresentedinfo[value], (idx, options) => {
                    let guid = Utilities_1.synUtil.getGUID(true);
                    let elem = new ClSRCombobox(that.id + "_" + guid, that.field, that.clControlFactory, that, idx === that.field.datapresentedinfo.length - 1, options);
                    elem.init(that.comboboxContainer);
                    that.childElems.push(elem);
                    elem.updateEntryState(options);
                });
                if (!that.isMultiValueControl) {
                    let pidCallBack = function (pids) {
                        if (pids && pids.length > 0) {
                            let guid = Utilities_1.synUtil.getGUID(true);
                            let elem = new ClSRCombobox(that.id + "_" + guid, that.field, that.clControlFactory, that, false, undefined);
                            elem.init(that.comboboxContainer);
                            that.childElems.push(elem);
                            elem.updateEntryState();
                        }
                        that.childElems.forEach((item, idx) => {
                            item.resizeElem(idx);
                        });
                    };
                    that.clControlFactory.GetPids(that.field, value, that.keepIds, pidCallBack);
                }
            }
            that.childElems.forEach((item, idx) => {
                item.resizeElem(idx);
            });
        };
        if (this.field.datapresentedinfo && !$.isEmptyObject(this.field.datapresentedinfo)) {
            addChildrenCallBack();
        }
        else {
            if (that.field.value) {
                let callback = function (datapresentedinfo) {
                    if (!that.field.datapresentedinfo)
                        that.field.datapresentedinfo = {};
                    $.each(datapresentedinfo, (key, value) => {
                        that.field.datapresentedinfo[key] = value;
                    });
                    addChildrenCallBack();
                };
                that.clControlFactory.getComboboxInfo(that.field, that.field.value, callback);
            }
            else {
                let guid = Utilities_1.synUtil.getGUID(true);
                let elem = new ClSRCombobox(that.id + "_" + guid, that.field, that.clControlFactory, that, true, undefined);
                elem.init(that.comboboxContainer);
                that.childElems.push(elem);
                elem.updateEntryState();
                that.childElems.forEach((item, idx) => {
                    item.resizeElem(idx);
                });
            }
        }
    }
    addMultiValue(value) {
        let that = this;
        if (that.field.multivalue) {
            // remove children if exist
            if (that.childElems && that.childElems.length > 0) {
                for (let j = 0; j < that.childElems.length; ++j) {
                    that.childElems[j].remove();
                }
                that.childElems.splice(0);
            }
            if (value) {
                if (value instanceof Array) {
                    $.each(value, (idx, val) => {
                        let bAdd = true;
                        for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                            if (that.multiValues.allControls[i].getValue() === val)
                                bAdd = false;
                        }
                        if (bAdd) {
                            let guid = Utilities_1.synUtil.getGUID(true);
                            let multiValInput = new ClSRComboboxContainer(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that, val);
                            multiValInput.setPageId(that.pageId);
                            multiValInput.init(that.multivalueContainer);
                            that.multiValues.pushControl(multiValInput);
                        }
                    });
                }
                else {
                    let bAdd = true;
                    for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                        if (that.multiValues.allControls[i].getValue() === value)
                            bAdd = false;
                    }
                    if (bAdd) {
                        let guid = Utilities_1.synUtil.getGUID(true);
                        let multiValInput = new ClSRComboboxContainer(that.id + "_input_" + guid, that.field, that.clControlFactory, that.levelcount, that, value);
                        multiValInput.setPageId(that.pageId);
                        multiValInput.init(that.multivalueContainer);
                        that.multiValues.pushControl(multiValInput);
                    }
                }
            }
            let guid = Utilities_1.synUtil.getGUID(true);
            let elem = new ClSRCombobox(that.id + "_" + guid, that.field, that.clControlFactory, that, true, undefined);
            elem.init(that.comboboxContainer);
            that.childElems.push(elem);
        }
    }
    selectionChanged(isLastElem, id, val, text) {
        let that = this;
        if (!that.field.datapresentedinfo)
            that.field.datapresentedinfo = {};
        let callback = function () {
            that.childElems.forEach((item, idx) => {
                item.resizeElem(idx);
            });
            if (that.field.multivalue) {
                if (val) {
                    that.setButtonVisibility(val);
                }
                else {
                    if (that.childElems.length > 0) {
                        that.setButtonVisibility(that.getCurrentValue());
                    }
                }
            }
            that.setTelephoneButtonVisibility();
            that.notifyChange();
            $(that).trigger("controlValueChanged");
        };
        if (isLastElem) {
            if (val && val !== "") {
                // addchild
                let pidCallBack = function (pids) {
                    if (pids && pids.length > 0) {
                        let guid = Utilities_1.synUtil.getGUID(true);
                        let elem = new ClSRCombobox(that.id + "_" + guid, that.field, that.clControlFactory, that, false, undefined);
                        elem.init(that.comboboxContainer);
                        that.childElems.push(elem);
                        elem.updateEntryState();
                        that.setTelephoneButtonVisibility();
                    }
                    callback();
                };
                that.clControlFactory.GetPids(that.field, val, that.keepIds, pidCallBack);
            }
            else {
                that.setButtonVisibility(that.getCurrentValue());
                that.notifyChange();
                $(that).trigger("controlValueChanged");
            }
        }
        else {
            let idx = that.getChildIndex(id);
            if (idx !== that.childElems.length) {
                let startindex = idx + 1;
                for (let i = startindex; i < that.childElems.length; ++i) {
                    that.childElems[i].remove();
                }
                that.childElems.splice(startindex);
            }
            let datacollection = [];
            let pidCallBack = function (pids) {
                if (pids && pids.length > 0) {
                    let guid = Utilities_1.synUtil.getGUID(true);
                    let elem = new ClSRCombobox(that.id + "_" + guid, that.field, that.clControlFactory, that, false, undefined);
                    elem.init(that.comboboxContainer);
                    that.childElems.push(elem);
                    elem.updateEntryState();
                    that.setTelephoneButtonVisibility();
                }
                callback();
            };
            that.clControlFactory.GetPids(that.field, val, that.keepIds, pidCallBack);
        }
    }
    resetData(dataCollection, textField, valueField) {
        let that = this;
        $.each(that.multiValues.allControls, (idx, value) => {
            value.controlButton.remove();
        });
        that.multiValues.allControls.splice(0, that.multiValues.allControls.length);
        that.selectionContainer.children().remove();
        that.comboboxContainer.children().remove();
        that.multivalueContainer.children().remove();
        if (that.controlButton)
            that.controlButton.hide();
        if (that.infoButton)
            that.infoButton.hide();
        that.rootControl = undefined;
        that.childElems.splice(0, that.childElems.length);
        if (dataCollection)
            that.removeInvalidValues(dataCollection);
        that.initInternal(that);
        that.notifyChange();
        $(that).trigger("controlValueChanged");
    }
    dataSortChanged() {
        $.each(this.childElems, (idx, child) => {
            child.dataSortChanged();
        });
    }
    removeInvalidValues(dataCollection) {
        if (this.fieldValue) {
            if (this.field.multivalue) {
                let tmpMultiValues = JSON.parse(JSON.stringify(this.fieldValue));
                if (tmpMultiValues instanceof Array) {
                    this.fieldValue.splice(0, this.fieldValue.length);
                    $.each(tmpMultiValues, (idx, multiValue) => {
                        let valueInCollection = false;
                        $.each(dataCollection, (idx, entry) => {
                            if (entry["id"] === multiValue)
                                valueInCollection = true;
                        });
                        if (valueInCollection)
                            this.fieldValue.push(multiValue);
                    });
                }
                else {
                    this.fieldValue = undefined;
                    let valueInCollection = false;
                    $.each(dataCollection, (idx, entry) => {
                        if (entry["id"] === tmpMultiValues)
                            valueInCollection = true;
                    });
                    if (valueInCollection)
                        this.fieldValue = tmpMultiValues;
                }
            }
            else {
                let valueInCollection = false;
                $.each(dataCollection, (idx, entry) => {
                    if (entry["id"] === this.fieldValue)
                        valueInCollection = true;
                });
                if (!valueInCollection)
                    this.fieldValue = undefined;
            }
        }
        this.field.value = this.getValue();
    }
    getChildIndex(id) {
        let index;
        this.childElems.forEach((item, idx) => {
            if (item.id === id)
                index = idx;
        });
        return index;
    }
    enable(enable) {
        this.childElems.forEach((item) => {
            item.enable(enable);
        });
        if (enable) {
            this.controlContainer.show();
        }
        else {
            if (this.field.multivalue && this.hasValue() && !this.getSingleValue())
                this.controlContainer.hide();
        }
    }
    highlightMandatory() {
        if (!this.isMultiValueControl) {
            let mandatory = this.field.mandatory && !this.hasValue();
            if (this.multiValues && this.multiValues.allControls && this.multiValues.allControls.length > 0) {
                $.each(this.multiValues.allControls, (idx, mvControl) => {
                    if (mvControl instanceof ClSRComboboxContainer)
                        mvControl.setMandatory(mandatory);
                });
            }
            this.setMandatory(mandatory);
        }
    }
    setMandatory(mandatory) {
        $.each(this.childElems, (idx, child) => {
            child.setMandatory(mandatory);
        });
    }
    updateValue(updateField, valueOnly, updateDataPresentedInfo = true) {
        let that = this;
        let callback = function (datapresentedinfo) {
            updateField.datapresentedinfo = datapresentedinfo;
            if (valueOnly) {
                that.setFieldValue();
            }
            else {
                that.selectionContainer.children().remove();
                that.comboboxContainer.children().remove();
                that.multivalueContainer.children().remove();
                if (that.controlButton)
                    that.controlButton.hide();
                if (that.infoButton)
                    that.infoButton.hide();
                that.rootControl = undefined;
                that.childElems = new Array();
                that.updateValueInternal(updateField, true);
            }
            that.setVisibility(that.field.visible, that.field.show);
            that.enable(!that.IsReadOnly());
            that.highlightMandatory();
        };
        if (updateDataPresentedInfo)
            that.clControlFactory.getComboboxInfo(updateField, updateField.value, callback);
        else
            callback(updateField.datapresentedinfo);
    }
    setButtonVisibility(value) {
        let that = this;
        let entryAlreadExist = false;
        if (that.controlButton) {
            if (value) {
                for (let i = 0; i < that.multiValues.allControls.length; ++i) {
                    if (value === that.multiValues.allControls[i].getValue())
                        entryAlreadExist = true;
                }
                if (!entryAlreadExist && !that.clControlFactory.ReadOnly && !that.isSingleValueAbstract())
                    that.controlButton.show();
                else
                    that.controlButton.hide();
            }
            else
                that.controlButton.hide();
        }
    }
    setTelephoneButtonVisibility() {
        let that = this;
        let dataItem;
        let value = that.getSingleValue();
        if (value) {
            if (that.field.datapresentedinfo && that.field.datapresentedinfo[value] && that.field.datapresentedinfo[value].find(entry => entry["id"] === value))
                dataItem = that.field.datapresentedinfo[value].find(entry => entry["id"] === value);
            else
                dataItem = that.getSingleDataItem();
        }
        if (this.field["istelnr"] && this.field["telnrcolumn"] && dataItem && dataItem[that.field["telnrcolumn"]] && this.clControlFactory.filterTelephoneNumber(dataItem[that.field["telnrcolumn"]]))
            this.telephoneButtonContainer.show();
        else
            this.telephoneButtonContainer.hide();
    }
}
exports.ClSRComboboxContainer = ClSRComboboxContainer;
